

(function () {
  var dataEl = document.getElementById('agcf-data');
  var copyEl = document.getElementById('agcf-copy');
  var rankEl = document.getElementById('agcf-rank');
  var cfgEl = document.getElementById('agcf-r6-config');
  if (!dataEl || !copyEl || !rankEl || !cfgEl) return;
  var FIN = JSON.parse(dataEl.textContent);
  /* 2f (Ansen 2026-10-17): warm (W) or cool (C) per finish code, from each swatch's mean color
     (theme-test/pantone-finishes/data/fin_temp.json); the Tone list's Warm / Cool use it */
  var A8TEMP = {"7001":"C","7003":"W","7007":"W","7008":"W","7011":"C","7071":"W","8084":"W","9007":"W","9010":"W","9012":"W","9013":"C","9028":"C","9069":"W","9176":"W","9287":"W","GR001":"W","L23023":"W","LGR001":"W","LS24002":"W","LS24003":"C","LS24004":"C","LS24012":"W","LS26001":"W","LS26002":"W","LS26003":"W","LS26004":"W","LS26005":"C","LS26006":"W","LS26007":"C","LS26008":"C","LS26009":"C","LS26010":"C","LS26011":"C","LS26012":"W","LS26013":"C","LS26014":"W","LS26015":"C","LS26016":"W","LS26017":"W","LS26018":"W","LS26019":"W","LS26020":"W","LS26021":"W","LS26022":"C","LS26023":"C","LS26024":"W","LS26025":"W","LS26026":"W","LS26027":"W","LS26028":"W","LS26029":"W","LS26030":"W","LS26031":"W","LS26032":"W","LS26033":"W","LS26034":"W","LS26035":"W","LS26036":"W","LS26037":"W","LS26038":"W","LS26039":"C","LS26040":"W","LS26041":"W","LS26042":"W","LS26043":"W","LS26044":"W","LS26045":"C","LS26046":"W","LS26047":"W","LS26048":"W","LS26049":"W","LS26050":"W","LS26051":"W","LS26052":"W","LS26053":"W","LS26054":"W","LS26055":"W","LS26056":"W","LS26057":"W","LS26058":"W","LS26059":"W","LS26060":"W","LS26061":"W","LS26062":"W","LS26063":"W","LS26064":"W","LS26065":"C","LS26066":"W","LS26067":"W","LS26068":"W","LS26069":"W","LS26070":"W","LS26071":"W","LS26072":"W","LS26073":"W","LS26074":"W","LS26075":"W","LS26076":"W","LS26077":"W","LS26078":"W","LS26079":"W","LS26080":"W","LS26081":"W","LS26082":"W","LS26083":"W","LS26084":"W","LS26085":"W","LS26086":"W","LS26087":"W","LS26088":"W","LS26089":"C","LS26090":"C","LS26091":"W","LS26092":"C","LS26093":"W","LS26094":"C","LS26095":"C","LS26096":"W","OR001":"W","SGR001":"W","SLB001G":"W","SLB001M":"C","W001":"C"};
  var COPY = JSON.parse(copyEl.textContent);
  var R3 = COPY.r3;
  var R5 = COPY.r5;
  var R6 = COPY.r6;
  var RANK = JSON.parse(rankEl.textContent);
  var CFG = JSON.parse(cfgEl.textContent);
  var BY_CODE = {};
  FIN.forEach(function (f) { BY_CODE[f.code] = f; });
  /* PANTONE round, stage 2 (Ansen 2026-10-16): a PANTONE code carries its own number and screen color,
     PMS-<number, spaces as underscores>-<RRGGBB> (PMS-2955_C-20426C), so BY_CODE resolves any PANTONE pick from the code
     alone - saved picks, history, the cart and set pieces never wait for the color list. The screen color is
     our own approximation from the printed swatch book, a guide only. */
  var A8PMS_RE = /^PMS-([A-Za-z0-9_]+)-([0-9A-Fa-f]{6})$/;
  var A8PMS = {};
  function a8PmsFin(code, tone, group) {
    var m = A8PMS_RE.exec(String(code || ''));
    if (!m) return null;
    var f = A8PMS[code];
    if (!f) {
      var hex = '#' + m[2].toLowerCase();
      var num = m[1].replace(/_/g, ' ');
      f = A8PMS[code] = {
        code: code, name: 'PANTONE ' + num, num: num, hex: hex, pms: true,
        family: 'PANTONE', tone: '', group: '',
        material: 'Painted gloss, matched to the physical PANTONE chip',
        desc: 'Painted gloss in PANTONE ' + num + '. The color on screen is a guide only; we paint to the'
          + ' physical PANTONE chip.',
        image: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" '
          + 'viewBox="0 0 8 8"><rect width="8" height="8" fill="' + hex + '"/></svg>')
      };
    }
    if (tone && !f.tone) f.tone = tone;
    if (group && !f.group) f.group = group;
    return f;
  }
  if (window.Proxy) {
    BY_CODE = new Proxy(BY_CODE, { get: function (t, k) {
      if (k in t) return t[k];
      return typeof k === 'string' ? (a8PmsFin(k) || undefined) : undefined;
    } });
  }
  var BY_NAME = {};
  FIN.forEach(function (f) { BY_NAME[f.name.toLowerCase()] = f; });
  var POS = {};
  RANK.forEach(function (code, i) { POS[code] = i; });
  var RANKED = FIN.slice().sort(function (a, b) {
    return (POS[a.code] || 0) - (POS[b.code] || 0);
  });

  var TONE_USECASE = {
    Light: 'Bright, airy. Best for open offices, smaller spaces, and '
      + 'environments that need to feel brighter.',
    Medium: 'Works in most office settings. Good for shared spaces and '
      + 'general use.',
    Dark: 'Great for executive offices and spaces where a more formal look '
      + 'is needed.'
  };

  var P_X = 'M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,'
    + '8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,'
    + '116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z';
  var P_REMOVE = 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a'
    + '.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5'
    + ' 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268'
    + '-7.418 7.417z';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cdn(url, w) {
    if (String(url).indexOf('data:') === 0) return url;   /* PANTONE chips */
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }
  function isMobile() {
    return window.matchMedia
      && window.matchMedia('(max-width: 768px)').matches;
  }

  var st = null;

  function q(sel) { return st && st.root ? st.root.querySelector(sel) : null; }

  function tileHTML(f) {
    return '<button type="button" class="agcf-sw" data-agcf-sw'
      + ' data-code="' + esc(f.code) + '" data-name="' + esc(f.name) + '"'
      + ' data-family="' + esc(f.family || '') + '"'
      + ' data-gloss="' + ((((f.name || '') + ' ' + (f.material || ''))
        .toLowerCase().indexOf('gloss') >= 0) ? '1' : '') + '"'
      + ' data-tone="' + esc(f.tone || '') + '"'
      + ' data-temp="' + (A8TEMP[f.code] === 'W' ? 'Warm' : A8TEMP[f.code] === 'C' ? 'Cool' : '') + '"'
      + ' aria-label="' + esc(f.name + ', code ' + f.code) + '">'
      + '<span class="agcf-sw-img"><img src="' + esc(cdn(f.image, 130)) + '"'
      + ' alt="' + esc(f.name) + '" loading="lazy" decoding="async"></span>'
      + '<span class="agcf-sw-role" aria-hidden="true"></span>'
      + '<span class="agcf-sw-name">' + esc(f.name) + '</span>'
      + '<span class="agcf-sw-code">' + esc(f.code) + '</span></button>';
  }

  function wireFilter() {
    var input = q('.agcf-search input');
    var clear = q('.agcf-clear');

    var fam = q('.agcf-fam:not(.agcf-tone)');
    var tone = q('.agcf-tone');
    var none = q('.agcf-none');
    if (!input) return;
    var wasEmptyState = false;
    function apply() {
      var query = (input.value || '').trim().toLowerCase();
      var famV = fam ? fam.value : '';
      var toneV = tone ? tone.value : '';
      if (clear) clear.classList.toggle('is-show', query.length > 0);
      var shown = 0;
      st.root.querySelectorAll('[data-agcf-sw]').forEach(function (b) {
        var hit = (!famV || (famV === 'Gloss'
            ? b.getAttribute('data-gloss') === '1'
            : b.getAttribute('data-family') === famV))
          && (!toneV || b.getAttribute(toneV === 'Warm' || toneV === 'Cool' ? 'data-temp' : 'data-tone') === toneV)
          && (!query
            || b.getAttribute('data-name').toLowerCase().indexOf(query) > -1
            || b.getAttribute('data-code').toLowerCase().indexOf(query) > -1
            || b.getAttribute('data-family').toLowerCase().indexOf(query) > -1
            || b.getAttribute('data-tone').toLowerCase().indexOf(query) > -1);
        b.style.display = hit ? '' : 'none';
        if (hit) shown += 1;
      });
      if (none) none.classList.toggle('is-show', shown === 0);

      if (shown === 0 && !wasEmptyState) announce(COPY.band.no_match);
      wasEmptyState = shown === 0;
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
    input.addEventListener('input', debounce(apply, 200));
    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      apply();
      input.focus();
    });
    if (fam) fam.addEventListener('change', apply);
    if (tone) tone.addEventListener('change', apply);
  }

  function gallery() { return document.querySelector('.slick-product-gallery'); }
  function ensurePreview() {
    var g = gallery();
    if (!g) return null;

    if (typeof A8 === 'object' && A8 && A8.pv && A8.pv.isConnected
        && !A8.pv.closest('.slick-cloned')) {
      return A8.pv;
    }
    var p = null;
    var cands = g.querySelectorAll('[data-agcf-preview]');
    for (var pi = 0; pi < cands.length; pi++) {
      if (!cands[pi].closest('.slick-cloned')) { p = cands[pi]; break; }
    }
    if (p) {
      if (typeof A8 === 'object' && A8) A8.pv = p;
      return p;
    }
    p = document.createElement('div');
    p.className = 'agcf-preview';
    p.setAttribute('data-agcf-preview', '');
    p.setAttribute('data-agcf-orphan', '');
    p.classList.add('agcf8');
    p.innerHTML =
      '<span class="agcf-preview-chip" data-agcf8-chip></span>'
      + '<span class="agcf8-load" data-agcf8-load>'
      + '<span class="agcf8-art" data-agcf8-art></span>'
      + '<span class="agcf8-stage" data-agcf8-stage>'
      + '<i data-agcf8-s0></i><i data-agcf8-s1></i></span>'
      + '<span class="agcf8-bar"><i data-agcf8-fill></i></span>'
      + '<span class="agcf8-eta" data-agcf8-eta></span>'
      + '<span class="agcf8-gate" data-agcf8-gate>'
      + '<span class="agcf8-gate-art" data-agcf8-gate-art'
      + ' aria-hidden="true"></span>'
      + '<span class="agcf8-gate-copy" data-agcf8-gate-copy></span>'
      + '<span class="agcf8-gate-box" data-agcf8-gate-box></span>'
      + '<span class="agcf8-gate-sub" data-agcf8-gate-sub></span>'
      + '</span>'
      + '</span>';
    g.appendChild(p);

    return p;
  }
  function applyPreview(f) {

    agcf8OnPick();
  }
  function clearPreview() {
    if (st) st.previewToken++;
    agcf8OnPick();
  }

  function stockFinishName() {

    var atc = document.getElementById('add-to-cart-btn');
    var form = atc && atc.closest ? atc.closest('form') : null;
    if (form) {
      var radios = form.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        var n = (radios[i].getAttribute('name') || '').toLowerCase();
        if (n.indexOf('finish') > -1) return radios[i].value;
      }
    }
    var sel = document.querySelector(
      '.ag-finish-row .ag-finish-card.is-selected,'
      + ' .ag-finish-display-list .ag-finish-card.is-selected');
    if (!sel) {

      sel = document.querySelector('.ag-finish-display-list .ag-finish-card');
    }
    return sel ? (sel.getAttribute('data-finish-name') || '') : '';
  }
  function enumerateOptions() {

    var atc = document.getElementById('add-to-cart-btn');
    var form = atc && atc.closest ? atc.closest('form') : null;
    if (!form) return [];
    var out = [], seen = {};
    form.querySelectorAll('select, input[type="radio"]:checked')
      .forEach(function (el) {

        if (el.closest('[data-agcf-r6]')) return;
        if (el.tagName === 'SELECT') {
          if (el.id === 'quantity') return;
          var nm = (el.getAttribute('name') || el.id || '').toLowerCase();
          if (nm.indexOf('finish') > -1) return;
          if (el.selectedIndex > -1 && el.options.length) {
            out.push(el.options[el.selectedIndex].textContent.trim());
          }
        } else {
          var n = el.getAttribute('name') || '';
          if (n.toLowerCase().indexOf('finish') > -1) return;
          if (seen[n]) return;
          seen[n] = 1;
          out.push(el.value);
        }
      });
    return out.filter(Boolean);
  }
  /* R44 (Datch 2026-09-07): the hero price and the ATC button price must
     always agree, INCLUDING while a custom-finish surcharge is active - the
     hero price used to only ever show the bare variant price. Both now
     route through here. A8_BASE_PRICE_TXT holds the pure variant price
     (no surcharge); A8_LAST_MAIN_WRITE is whatever we last wrote into
     #product-main-price ourselves, so a8RefreshBasePrice can tell "a real
     variant change (Size, Return) landed" apart from "I just wrote the
     surcharge-inclusive total in here a moment ago" - without that check,
     writing the surcharged total back into the hero price would get read
     as the new base on the next call and compound upward every time. */
  var A8_BASE_PRICE_TXT = null;
  var A8_LAST_MAIN_WRITE = null;
  function a8RefreshBasePrice() {
    var mainEl = document.getElementById('product-main-price');
    if (!mainEl) return;
    var curText = (mainEl.textContent || '').trim();
    if (curText && curText !== A8_LAST_MAIN_WRITE) A8_BASE_PRICE_TXT = curText;
  }
  function updateAtcPrice() {

    a8RefreshBasePrice();
    var sub = document.querySelector('[data-agcf-atc-sub]');
    var mainEl = document.getElementById('product-main-price');
    var finalTxt = (st && st.customOn && st.primary)
      ? money(customPrice()) : (A8_BASE_PRICE_TXT || CFG.price || '');
    if (mainEl) {
      A8_LAST_MAIN_WRITE = finalTxt;
      if (mainEl.textContent.trim() !== finalTxt) mainEl.textContent = finalTxt;
    }
    if (sub) sub.textContent = finalTxt;
  }

  function updateGhost() {
    var ghost = q('.agcf-ghost');
    var box = q('.agcf-ghost-box');
    var name = q('.agcf-ghost-name');
    if (!box || !name) return;
    var imgP = box.querySelector('.agcf-ghost-primary');
    var imgA = box.querySelector('.agcf-ghost-accent');
    if (!imgP) {
      imgP = document.createElement('img');
      imgP.className = 'agcf-ghost-primary';
      imgP.alt = '';
      box.appendChild(imgP);
      imgA = document.createElement('img');
      imgA.className = 'agcf-ghost-accent';
      imgA.alt = '';
      box.appendChild(imgA);
    }

    if (ghost) {
      if (st.primary) {
        ghost.setAttribute('aria-label', COPY.ghost + ': ' + st.primary.name
          + (st.accent ? (' with ' + st.accent.name + ' accent') : ''));
        ghost.removeAttribute('aria-expanded');

        ghost.removeAttribute('aria-controls');
        ghost.setAttribute('aria-pressed', st.customOn ? 'true' : 'false');
      } else {
        ghost.setAttribute('aria-label', COPY.ghost);
        ghost.removeAttribute('aria-pressed');

        ghost.setAttribute('aria-controls', 'agcf-band-r6');
        ghost.setAttribute('aria-expanded', bandIsOpen() ? 'true' : 'false');
      }
    }
    if (A8 && A8.applying) return;
    if (st.primary) {
      box.classList.add('is-filled');
      var pHid0 = imgP.style.display === 'none';
      a8GdSwap(imgP, cdn(st.primary.image, 260), !pHid0);
      a8GdShowImg(imgP, pHid0);
      imgP.alt = st.primary.name;
      if (st.accent) {
        var aHid0 = imgA.style.display === 'none';
        a8GdSwap(imgA, cdn(st.accent.image, 130), !aHid0);
        a8GdShowImg(imgA, aHid0);
        imgA.alt = st.accent.name;
        placeCaption(name, st.primary.name, st.accent.name);
      } else {
        a8GdHideImg(imgA, true);
        name.textContent = st.primary.name;
      }
    } else {
      box.classList.remove('is-filled');
      a8GdHideImg(imgP, true);
      a8GdHideImg(imgA, true);
      name.textContent = COPY.ghost;
    }
  }

  function captionFits(name, text) {
    var probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden;'
      + 'white-space:nowrap;left:-9999px;top:0;';
    var cs = getComputedStyle(name);
    probe.style.font = cs.font;
    probe.style.letterSpacing = cs.letterSpacing;
    probe.style.textTransform = cs.textTransform;
    probe.textContent = text;
    document.body.appendChild(probe);
    var w = probe.getBoundingClientRect().width;
    document.body.removeChild(probe);

    var mw = cs.maxWidth;
    if (!mw || mw === 'none') return true;
    var limit = parseFloat(mw);
    return !limit || w <= limit + 0.5;
  }
  function placeCaption(name, p, a) {
    var trailing = captionFits(name, p + ' /');
    name.innerHTML = trailing
      ? ('<span data-agcf-cap-p>' + esc(p) + '</span>'
         + '<span data-agcf-cap-sep> /</span><br>'
         + '<span data-agcf-cap-a>' + esc(a) + '</span>')
      : ('<span data-agcf-cap-p>' + esc(p) + '</span><br>'
         + '<span data-agcf-cap-sep-lead>/ </span>'
         + '<span data-agcf-cap-a>' + esc(a) + '</span>');
  }
  function replaceCaption() {
    if (!st || !st.primary || !st.accent) return;
    var name = q('.agcf-ghost-name');
    if (name) placeCaption(name, st.primary.name, st.accent.name);
  }

  function updateTiles() {
    st.root.querySelectorAll('[data-agcf-sw]').forEach(function (b) {
      var code = b.getAttribute('data-code');
      var role = st.primary && st.primary.code === code ? 'primary'
        : (st.accent && st.accent.code === code ? 'accent' : null);
      b.classList.toggle('is-selected', !!role);
      b.setAttribute('aria-pressed', role ? 'true' : 'false');
      var name = b.getAttribute('data-name');
      b.setAttribute('aria-label', name + ', code ' + code
        + (role ? ', ' + R3.roles[role] : ''));
      var badge = b.querySelector('.agcf-sw-role');
      if (badge) {
        badge.classList.toggle('is-on', !!role);
        badge.classList.toggle('is-accent', role === 'accent');
        badge.textContent = role === 'primary' ? 'P'
          : (role === 'accent' ? 'A' : '');
      }
    });
  }

  function updateSelectedState() {
    st.root.classList.toggle('is-agcf-custom', !!st.customOn);

    var payAtc = document.getElementById('add-to-cart-btn');
    var payForm = payAtc && payAtc.closest ? payAtc.closest('form') : null;
    if (payForm) {
      var payWas = payForm.classList.contains('is-agcf-custom');
      var payNow = !!(st.customOn && st.primary);
      payForm.classList.toggle('is-agcf-custom', payNow);
      if (payWas && !payNow && typeof a8PayRestore === 'function') {
        a8PayRestore();
      }
    }
    if (CFG.page === 'display') {
      var card = st.root.querySelector(
        '.ag-finish-display-list .ag-finish-card--display');
      if (card) {
        card.classList.toggle('is-agcf-stock', !st.customOn);
        card.setAttribute('aria-pressed', st.customOn ? 'false' : 'true');
      }
    }
  }

  function selectCustomSide() {
    if (!st.primary) return;
    if (st.customOn) { a8SelNav(); return; }
    st.customOn = true;
    applyPreview(st.primary);
    announce(COPY.ghost + ' selected: ' + st.primary.name);
    paneRefresh();
    a8SelNav();

    if (drawerIsOpen()) buildDrawer();
  }
  function selectStockSide(name) {
    if (!st.customOn) return;
    st.customOn = false;
    clearPreview();
    announce((name || stockFinishName() || 'Standard finish') + ' selected');
    paneRefresh();
    if (drawerIsOpen()) buildDrawer();
  }

  function sharedPanel() {
    return st.root
      ? st.root.querySelector('.ag-finish-panel:not([data-agcf-ghost-panel])')
      : null;
  }
  function paintShared(panel, d) {
    panel.dataset.hasAccent = d.accentImg ? 'true' : 'false';
    var pi = panel.querySelector('.ag-finish-panel-primary');
    var strip = panel.querySelector('.ag-finish-panel-strip');
    var ai = panel.querySelector('.ag-finish-panel-accent');
    if (pi) { pi.src = d.primaryImg; pi.alt = d.name || ''; }
    if (strip) strip.hidden = !d.accentImg;
    if (ai) {
      if (d.accentImg) { ai.src = d.accentImg; ai.alt = d.accentName || ''; }
      else { ai.removeAttribute('src'); ai.alt = ''; }
    }
    panel.querySelector('.ag-finish-panel-name').textContent = d.name || '';
    var an = panel.querySelector('.ag-finish-panel-accentname');
    if (an) {
      an.textContent = d.accentName ? ('with ' + d.accentName + ' accent') : '';
      an.hidden = !d.accentName;
    }
    var toneRow = panel.querySelector('.ag-finish-panel-tone-row');
    var pill = panel.querySelector('.ag-finish-panel-pill');
    var use = panel.querySelector('.ag-finish-panel-usecase');
    if (pill) {
      pill.textContent = d.toneLabel || '';
      pill.style.display = d.toneLabel ? '' : 'none';
    }
    if (use) use.textContent = d.usecase || '';
    if (toneRow) toneRow.hidden = !d.toneLabel && !d.usecase;
    var tRow = panel.querySelector('.ag-finish-panel-texture-row');
    var tv = panel.querySelector('.ag-finish-panel-texture');
    if (tRow) tRow.hidden = !d.texture;
    if (tv) tv.textContent = d.texture || '';
    var mv = panel.querySelector('.ag-finish-panel-material');
    if (mv) mv.textContent = d.material || '';
  }
  function cardData(card) {
    var g = function (n) {
      return card.getAttribute('data-finish-' + n) || '';
    };
    return {
      primaryImg: g('large-primary') || g('large'),
      accentImg: card.getAttribute('data-has-accent') === 'true'
        ? g('large-accent') : '',
      name: g('name-primary') || g('name'),
      accentName: g('name-accent'),
      toneLabel: g('tone-label'),
      usecase: g('usecase'),
      texture: g('texture'),
      material: g('material')
    };
  }
  function showSharedPanel(anchor, d) {
    var panel = sharedPanel();
    if (!panel || !d.primaryImg) return;

    var token = ++st.hoverToken;
    var pending = d.accentImg ? 2 : 1;
    var committed = false;
    var commit = function () {
      if (committed || token !== st.hoverToken) return;
      committed = true;
      paintShared(panel, d);
      panel.hidden = false;
      positionPanel(panel, anchor);
    };
    var settle = function () { if (--pending <= 0) commit(); };
    var im = new Image();
    im.onload = function () {
      if (im.decode) { im.decode().then(settle, settle); } else { settle(); }
    };
    im.onerror = settle;
    im.src = d.primaryImg;
    if (d.accentImg) {
      var ia = new Image();
      ia.onload = settle; ia.onerror = settle;
      ia.src = d.accentImg;
    }
    setTimeout(commit, 900);
  }
  function hideSharedPanel() {
    if (st) st.hoverToken++;
    var p = sharedPanel();
    if (p) p.hidden = true;
  }

  function ghostPanel() { return q('[data-agcf-ghost-panel]'); }
  function updateGhostPanel() {
    var panel = ghostPanel();
    if (!panel) return;
    if (!st.primary) { panel.hidden = true; return; }
    var p = st.primary, a = st.accent;
    panel.dataset.hasAccent = a ? 'true' : 'false';
    var pi = panel.querySelector('.ag-finish-panel-primary');
    var strip = panel.querySelector('.ag-finish-panel-strip');
    var ai = panel.querySelector('.ag-finish-panel-accent');
    pi.src = cdn(p.image, 400);
    pi.alt = p.name;
    strip.hidden = !a;
    if (a) { ai.src = cdn(a.image, 400); ai.alt = a.name; }
    else { ai.removeAttribute('src'); ai.alt = ''; }
    panel.querySelector('.ag-finish-panel-name').textContent = p.name;
    var an = panel.querySelector('.ag-finish-panel-accentname');
    an.textContent = a ? ('with ' + a.name + ' accent') : '';
    an.hidden = !a;
    var toneRow = panel.querySelector('.ag-finish-panel-tone-row');
    toneRow.hidden = !p.tone;
    var pill = panel.querySelector('.ag-finish-panel-pill');
    pill.textContent = p.tone ? (p.tone + ' tone').toUpperCase() : '';
    pill.style.display = p.tone ? '' : 'none';
    panel.querySelector('.ag-finish-panel-usecase').textContent =
      TONE_USECASE[p.tone] || '';
    var tRow = panel.querySelector('.ag-finish-panel-texture-row');
    tRow.hidden = !p.texture;
    panel.querySelector('.ag-finish-panel-texture').textContent =
      p.texture || '';
    panel.querySelector('.ag-finish-panel-material').textContent =
      p.material || '';
  }

  function positionPanel(panel, anchor) {
    var section = panel.closest('.ag-finish-option');
    if (!section) return;
    var sectionRect = section.getBoundingClientRect();
    var aRect = anchor.getBoundingClientRect();
    var pr = panel.getBoundingClientRect();
    var panelH = pr.height || 260;
    var panelW = pr.width || 580;
    panel.style.top = ((aRect.top - sectionRect.top) - panelH - 10) + 'px';
    panel.style.left = ((aRect.left - sectionRect.left)
      + (aRect.width / 2) - (panelW / 2)) + 'px';
    panel.style.right = 'auto';
    requestAnimationFrame(function () {
      var pr2 = panel.getBoundingClientRect();
      var vw = window.innerWidth;
      if (pr2.right > vw - 8) {
        panel.style.left = (parseFloat(panel.style.left)
          - (pr2.right - (vw - 8))) + 'px';
      }
      if (pr2.left < 8) {
        panel.style.left = (parseFloat(panel.style.left)
          + (8 - pr2.left)) + 'px';
      }
      if (pr2.top < 8) {
        panel.style.top = ((aRect.bottom - sectionRect.top) + 10) + 'px';
      }
    });
  }
  function showGhostPanel() {
    var panel = ghostPanel();
    var box = q('.agcf-ghost-box');
    if (!panel || !box || !st.primary || popOpen() || pickerOpen()) return;
    hideSharedPanel();
    panel.hidden = false;
    positionPanel(panel, box);
  }
  function hideGhostPanel() {
    var panel = ghostPanel();
    if (panel) panel.hidden = true;
  }

  function bandIsOpen() {
    var band = q('.agcf-band');
    return !!(band && band.classList.contains('is-open'));
  }
  function updateChanger() {
    var el = q('[data-agcf-change]');
    if (el) el.classList.toggle('is-show', !!st.primary && !bandIsOpen());
  }

  function paneRefresh() {
    updateTiles();
    updateGhost();
    updateGhostPanel();
    updateSelectedState();
    updateChanger();
    updateAtcPrice();
    updateSampleLink();
  }

  var sampleOrig;
  function sampleTail(mode) {
    if (mode === 'domestic') return R5.sample.tail_domestic;
    if (mode === 'factory') return R5.sample.tail_factory;
    return '';
  }
  function sampleWrap() {
    return document.querySelector('.ag-sample-link-wrap');
  }
  function wrapCounts() {
    var w = sampleWrap();
    var g = function (a) {
      return w ? (parseInt(w.getAttribute(a) || '0', 10) || 0) : 0;
    };
    return {dom: g('data-domestic-count'), fac: g('data-factory-count')};
  }

  var GRAY = {};
  (CFG.stock && CFG.stock.grays || []).forEach(function (c) { GRAY[c] = 1; });
  function effMode(f) {

    if (!f || GRAY[f.code]) return null;
    return f.mode || null;
  }
  function stockEntries() {

    if (st.stockList) return st.stockList;
    st.stockList = (CFG.stock && CFG.stock.orderable || [])
      .map(function (c) { return BY_CODE[c]; }).filter(Boolean);
    return st.stockList;
  }
  function grayEntries() {
    return (CFG.stock && CFG.stock.grays || [])
      .map(function (c) { return BY_CODE[c]; }).filter(Boolean);
  }
  function customAdditions() {

    var base = {}, out = [];
    stockEntries().forEach(function (f) { base[f.code] = 1; });
    grayEntries().forEach(function (f) { base[f.code] = 1; });
    [st.primary, st.accent].forEach(function (p) {
      if (p && effMode(p) && !base[p.code]
          && !out.some(function (x) { return x.code === p.code; })) {
        out.push(p);
      }
    });
    return out;
  }
  function updateSampleLink() {
    var link = document.querySelector('.ag-sample-link');
    if (!link) return;
    if (sampleOrig === undefined) sampleOrig = link.textContent;
    var txt;
    if (st && st.primary) {
      var added = customAdditions();
      if (!added.length) {

        txt = sampleOrig;
      } else {
        var wc = wrapCounts();
        var dom = wc.dom, fac = wc.fac;
        added.forEach(function (f) {
          if (effMode(f) === 'domestic') dom += 1; else fac += 1;
        });
        var total = dom + fac;
        if (total === 1) {
          // Datch 2026-09-09: no finish names in card sample copy - collapse the
          // {name} slot (and its surrounding space) instead of filling it
          txt = R5.sample.single.replace(' {name}', '').replace('{name} ', '').replace('{name}', '')
            + sampleTail(effMode(added[0]));
        } else {
          txt = R5.sample.plural
            + (fac === 0 && dom > 0 ? R5.sample.tail_domestic
               : (dom === 0 && fac > 0 ? R5.sample.tail_factory : ''));
        }
      }
    } else {
      txt = sampleOrig;
    }
    if (link.textContent !== txt) link.textContent = txt;
  }

  function drawerIsOpen() {
    var d = document.getElementById('cart-drawer');
    return !!(d && d.classList.contains('cart-drawer--open'));
  }
  function requestSample(f) {

    if (!A8_PROTO) return a8PortSample(f);
    if (!f || !effMode(f) || st.requested[f.code]) return false;
    st.requested[f.code] = 1;
    st.sampleOrder.push(f.code);
    announce(R5.sample.added + ': ' + f.name);
    if (drawerIsOpen()) buildDrawer();
    return true;
  }
  function unrequestSample(code) {
    if (!st.requested[code]) return;
    delete st.requested[code];
    st.sampleOrder = st.sampleOrder.filter(function (c) { return c !== code; });
    var f = BY_CODE[code];
    announce('Sample removed' + (f ? (': ' + f.name) : ''));
    if (drawerIsOpen()) {

      buildDrawer();
      var drawer = document.getElementById('cart-drawer');
      var next = drawer && (drawer.querySelector('[data-agcf-sample-remove]')
        || drawer.querySelector('.cart-drawer__checkout-button'));
      if (next && next.focus) {
        try { next.focus({preventScroll: true}); } catch (err) { next.focus(); }
      }
    }

  }

  function assign(role, f) {
    if (!f) return;

    if (role === 'accent'
        && (!st.primary || st.primary.code === f.code)) return;
    var other = role === 'primary' ? 'accent' : 'primary';
    if (st[other] && st[other].code === f.code) st[other] = null;
    st[role] = f;

    st.customOn = true;

    applyPreview(st.primary);
    announce(f.name + ' set as ' + (R3.roles[role] || role));
    paneRefresh();
    a8SelNav();
  }
  function clearRole(role) {
    if (role === 'primary') {

      st.primary = null;
      st.accent = null;
      st.customOn = false;
    } else {
      st.accent = null;
    }
    if (st.customOn && st.primary) applyPreview(st.primary);
    else clearPreview();
    announce((R3.roles[role] || role) + ' removed');
    paneRefresh();
  }
  function roleOf(f) {
    if (st.primary && st.primary.code === f.code) return 'primary';
    if (st.accent && st.accent.code === f.code) return 'accent';
    return null;
  }

  function leadFor(f, state) {

    if (state === 'soldout') return R6.lead_out;
    if (state === 'none') return R5.sample.lead_unavailable;
    if (GRAY[f.code]) return R6.lead_out;
    if (f.mode === 'domestic') return R5.sample.lead_domestic;
    if (f.mode === 'factory') return R5.sample.lead_factory;
    return R5.sample.lead_unavailable;
  }
  function sampleActionHTML(f) {
    if (f && f.pms) return '';   /* no samples for PANTONE colors (yet) */

    var done = !!st.requested[f.code];
    var sState = a8SmpState(f.code);
    var noSample = !effMode(f) || !!sState;
    var lbl = done ? R5.sample.added : R5.popover.request_sample;
    var lead = done ? '' : leadFor(f, sState);
    var attrs = noSample ? ' disabled'
      : (done ? ' aria-disabled="true"' : '');
    return '<button type="button" class="agcf-pop5-sample'
      + (done ? ' is-done' : '') + '" data-agcf-pop="sample"' + attrs + '>'
      + '<span class="agcf-pop5-sample-lbl">' + esc(lbl) + '</span>'
      + '<span class="agcf-pop5-lead">' + esc(lead) + '</span></button>';
  }
  function popHTML(f) {

    var role = roleOf(f);
    var removeBtn = role
      ? ('<button type="button" class="agcf-pop5-remove" '
         + 'data-agcf-pop="remove">' + esc(R3.popover.remove) + '</button>')
      : '';
    var btns = '<div class="agcf-pop5-actions">'
      + '<button type="button" class="agcf-pop5-btn" data-agcf-pop="primary">'
      + esc(R3.popover.set_primary) + '</button>'
      + '<button type="button" class="agcf-pop5-btn agcf-pop5-btn--ghost" '
      + 'data-agcf-pop="accent">' + esc(R3.popover.set_accent) + '</button>'
      + '</div>';
    var divider = '<span class="agcf-pop5-divider" aria-hidden="true"></span>';
    return '<div class="agcf-pop5-swatch"><img src="'
      + esc(cdn(f.image, 480)) + '" alt="' + esc(f.name)
      + '" decoding="async"></div>'
      + '<div class="agcf-pop5-body">'
      + '<span class="agcf-pop5-eyebrow">' + esc(COPY.dialog.eyebrow)
      + '</span>'
      + '<span class="agcf-pop5-name">' + esc(f.name) + '</span>'
      + '<span class="agcf-pop5-code">' + (f.pms ? esc('PANTONE\u00ae ' + f.num + ' \u00b7 painted gloss') : 'Code: ' + esc(f.code)) + '</span>'
      + '<span class="agcf-pop5-desc">' + esc(f.desc || '') + '</span>'
      + divider + btns + sampleActionHTML(f) + removeBtn + '</div>';
  }
  function ensurePop() {
    if (st.pop) return st.pop;
    var pop = document.createElement('div');
    pop.setAttribute('data-agcf-rolepop', '');
    pop.setAttribute('data-agcf-orphan', '');
    pop.setAttribute('role', 'dialog');
    st.root.appendChild(pop);
    pop.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-agcf-pop]') : null;
      if (!b || b.disabled) return;
      var act = b.getAttribute('data-agcf-pop');
      var f = st.popFinish;
      if (!f) { closePop(); return; }
      if (act === 'close') { closePop(true); return; }
      if (act === 'sample') {

        if (!requestSample(f)) return;
        b.classList.add('is-done');
        b.setAttribute('aria-disabled', 'true');
        var lbl = b.querySelector('.agcf-pop5-sample-lbl');
        if (lbl) lbl.textContent = R5.sample.added;
        var lead = b.querySelector('.agcf-pop5-lead');
        if (lead) lead.textContent = '';
        return;
      }

      closePop(true);
      if (act === 'remove') { var r = roleOf(f); if (r) clearRole(r); return; }
      assign(act, f);
    });

    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !popOpen()) return;
      var els = Array.prototype.filter.call(
        pop.querySelectorAll('button'),
        function (b) { return !b.disabled && b.offsetParent !== null; });
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      var leaving = (e.shiftKey && document.activeElement === first)
        || (!e.shiftKey && document.activeElement === last);
      if (!leaving) return;
      if (isMobile()) {

        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else {

        closePop(true);
      }
    });
    st.pop = pop;
    return pop;
  }
  function openPop(tile, f) {

    if (drawerIsOpen() || pickerOpen()) return;
    var pop = ensurePop();
    hideSharedPanel();
    hideGhostPanel();
    st.popFinish = f;
    st.popTile = tile;
    pop.className = 'agcf-pop5 agcf-pop5--a';
    pop.setAttribute('aria-label', f.name + ', ' + f.code);
    pop.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
    pop.innerHTML = popHTML(f)
      + ('<button type="button" class="agcf-pop5-x" data-agcf-pop="close" '
         + 'aria-label="' + esc(COPY.dialog.close) + '">'
         + '<svg class="agcf-x" viewBox="0 0 256 256" fill="currentColor" '
         + 'aria-hidden="true"><path d="' + P_X + '"/></svg></button>');
    var accBtn = pop.querySelector('[data-agcf-pop="accent"]');
    var accentOk = !!st.primary && st.primary.code !== f.code;
    if (accBtn) {
      accBtn.disabled = !accentOk;

      if (!accentOk) {
        accBtn.setAttribute('aria-label', R3.popover.set_accent + '. '
          + R3.popover.set_accent_hint);
      } else {
        accBtn.removeAttribute('aria-label');
      }
    }
    agcf8PopDeltas(pop, f, accentOk);
    pop.classList.add('is-show');

    if (isMobile()) a8Lock('pop', true);

    st.popOpenedAt = (window.performance && performance.now)
      ? performance.now() : 0;
    if (isMobile()) {

      pop.style.left = '';
      pop.style.top = '';
    } else {
      var r = tile.getBoundingClientRect();
      var w = Math.max(pop.offsetWidth, 178);
      var h = pop.offsetHeight;
      var left = Math.min(Math.max(r.left, 8), window.innerWidth - w - 8);
      var top = r.bottom + 6;
      if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 6);
      pop.style.left = Math.round(left) + 'px';
      pop.style.top = Math.round(top) + 'px';
    }

    var first = pop.querySelector('.agcf-pop5-actions .agcf-pop5-btn:not(.agcf-pop5-btn--ghost)');
    if (first) first.focus();
  }
  function closePop(restoreFocus) {
    a8Lock('pop', false);
    if (st && st.pop && st.pop.classList.contains('is-show')) {
      st.pop.classList.remove('is-show');
      if (restoreFocus && st.popTile && st.popTile.focus) {

        try {
          st.popTile.focus({preventScroll: true});
        } catch (err) {
          st.popTile.focus();
        }
      }
    }
    if (st) { st.popFinish = null; st.popTile = null; }
  }
  function popOpen() {
    return !!(st && st.pop && st.pop.classList.contains('is-show'));
  }

  function pickerOpen() {

    return !!document.querySelector('.agsp-backdrop.is-open');
  }
  function pickerVid(code) {

    if (!st.vidByCode[code]) {
      st.vidSeq += 1;
      st.vidByCode[code] = 900000 + st.vidSeq;
      st.codeByVid[st.vidByCode[code]] = code;
    }
    return st.vidByCode[code];
  }
  function pickerEntry(f, extra) {
    var e = {
      code: f.code,
      name: f.name,
      variantId: pickerVid(f.code),
      price: samplePrice() * 100,
      mode: effMode(f),
      image: cdn(f.image, 360),
      imageLarge: cdn(f.image, 800),
      toneLabel: f.tone ? (f.tone + ' tone').toUpperCase() : '',
      usecase: TONE_USECASE[f.tone] || '',
      texture: f.texture || '',
      material: f.material || ''
    };
    if (extra) { for (var k in extra) { e[k] = extra[k]; } }
    return e;
  }
  function simCart() {
    return {
      read: function () {
        return Promise.resolve({
          items: st.sampleOrder.map(function (c) {
            return {id: pickerVid(c)};
          })
        });
      },
      add: function (items) {
        items.forEach(function (it) {
          var code = st.codeByVid[it.id];
          var f = code && BY_CODE[code];
          if (f && !st.requested[f.code]) {
            st.requested[f.code] = 1;
            st.sampleOrder.push(f.code);
            announce(R5.sample.added + ': ' + f.name);
          }
        });
        return Promise.resolve({});
      }
    };
  }
  function openPicker() {
    if (!A8_PROTO) return;
    if (!window.AG_SAMPLE_PICKER) return;

    if (drawerIsOpen()) return;
    closePop();
    hideGhostPanel();
    hideSharedPanel();
    var samples = stockEntries().map(function (f) {
      return pickerEntry(f);
    });

    customAdditions().forEach(function (f) {
      samples.push(pickerEntry(f));
    });

    var grays = grayEntries().map(function (f) {
      return pickerEntry(f, {state: 'soldout'});
    });
    window.AG_SAMPLE_PICKER.open({
      samples: samples,
      unavailable: grays,
      cart: simCart(),
      onAdded: function (items) {

        if (items.length) openDrawer();
      }
    });

    var backdrop = document.querySelector('.agsp-backdrop');
    if (backdrop) {
      var closeBtn = backdrop.querySelector('.agsp-close');
      if (closeBtn) closeBtn.focus();
      backdrop.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var els = Array.prototype.filter.call(
          backdrop.querySelectorAll('button'),
          function (b) { return !b.disabled && b.offsetParent !== null; });
        if (!els.length) return;
        var first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
      var opener = document.querySelector('.ag-sample-link');
      var mo = new MutationObserver(function () {
        if (document.body.contains(backdrop)) return;
        mo.disconnect();
        var target = drawerIsOpen()
          ? document.querySelector('#cart-drawer .cart-drawer__close')
          : opener;
        if (target && target.focus) {
          try {
            target.focus({preventScroll: true});
          } catch (err) {
            target.focus();
          }
        }
      });
      mo.observe(document.body, {childList: true});
    }
  }

  function setExpanded(ghost, open) {
    ghost.classList.toggle('is-open', open);

    if (st && st.primary) ghost.removeAttribute('aria-expanded');
    else ghost.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function openBand() {
    var band = q('.agcf-band');
    var ghost = q('.agcf-ghost');
    if (!band || band.classList.contains('is-open')) return;
    setExpanded(ghost, true);
    if (st.rendered) {
      band.classList.add('is-open');
      return;
    }

    st.rendered = true;
    q('.agcf-rail').innerHTML = RANKED.map(tileHTML).join('');
    band.classList.add('is-open');
    paneRefresh();
  }
  function toggleBand() {
    var band = q('.agcf-band');
    var ghost = q('.agcf-ghost');
    if (band.classList.contains('is-open')) {
      band.classList.remove('is-open');
      setExpanded(ghost, false);
      updateChanger();
      return;
    }
    openBand();
    updateChanger();
  }

  function announce(msg) {
    if (!st || !st.live) return;
    st.live.textContent = msg;
  }

  function init(root) {
    st = {
      root: root,
      primary: null, accent: null, customOn: false,
      rendered: false,
      pop: null, popFinish: null, popTile: null,
      requested: {}, sampleOrder: [], stockList: null,
      vidByCode: {}, codeByVid: {}, vidSeq: 0,
      hoverToken: 0, previewToken: 0, bodyLocked: null, live: null
    };
    st.live = document.createElement('div');
    st.live.className = 'agcf-sr';
    st.live.setAttribute('aria-live', 'polite');
    root.appendChild(st.live);
    var bandEl = root.querySelector('.agcf-band');
    if (bandEl) bandEl.id = 'agcf-band-r6';
    // a11y 1c K7 (2026-10-21): the shut band collapses to 0 height (agcf.css grid 0fr), but its search, filters and
    // PANTONE buttons kept taking focus unseen. Inert while shut; its toggles already carry aria-expanded.
    if (bandEl) {
      var agBandSync = function () { bandEl.inert = !bandEl.classList.contains('is-open'); };
      agBandSync();
      new MutationObserver(agBandSync).observe(bandEl, { attributes: true, attributeFilter: ['class'] });
    }
    var railEl = root.querySelector('.agcf-rail');
    if (railEl) {

      railEl.setAttribute('role', 'group');
      railEl.setAttribute('aria-label', R5.rail_label);
    }
    root.querySelectorAll('.ag-finish-row .ag-finish-card--selectable')
      .forEach(function (cardEl) {
        cardEl.setAttribute('aria-pressed',
          cardEl.classList.contains('is-selected') ? 'true' : 'false');
      });

    var dispCard = root.querySelector(
      '.ag-finish-display-list .ag-finish-card--display');
    if (dispCard) {
      dispCard.setAttribute('role', 'button');
      dispCard.setAttribute('tabindex', '0');
      dispCard.setAttribute('aria-pressed', 'true');

      dispCard.setAttribute('aria-label',
        dispCard.getAttribute('data-finish-name') || 'Standard finish');
    }

    var ghost = q('.agcf-ghost');
    if (ghost) {
      ghost.setAttribute('aria-expanded', 'false');
      ghost.setAttribute('aria-controls', 'agcf-band-r6');
      ghost.addEventListener('click', function () {

        if (st.primary) { selectCustomSide(); return; }
        hideGhostPanel();
        toggleBand();
      });
    }
    var closeBtn = q('[data-agcf-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { toggleBand(); });
    }
    var changer = q('[data-agcf-change]');
    if (changer) {
      changer.setAttribute('aria-controls', 'agcf-band-r6');
      changer.addEventListener('click', function () {
        openBand();
        updateChanger();

        var si = q('.agcf-search input');
        if (si && si.focus) si.focus();
      });
    }

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var gbox = q('.agcf-ghost-box');
      if (gbox) {
        gbox.addEventListener('mouseenter', function () { showGhostPanel(); });
        gbox.addEventListener('mouseleave', hideGhostPanel);
      }
      root.querySelectorAll(
        '.ag-finish-row .ag-finish-card--selectable,'
        + ' .ag-finish-display-list .ag-finish-card--display')
        .forEach(function (card) {
          var anchorEl = card.querySelector('.ag-finish-card-img-wrap')
            || card;
          card.addEventListener('mouseenter', function () {
            if (popOpen() || pickerOpen()) return;
            showSharedPanel(anchorEl, cardData(card));
          });
          card.addEventListener('mouseleave', hideSharedPanel);
        });
    }

    root.addEventListener('focusin', function (e) {
      if (popOpen() || pickerOpen()) return;
      var t = e.target;

      try {
        if (t.matches && !t.matches(':focus-visible')) return;
      } catch (err) {   }
      if (t.closest && t.closest('[data-agcf-sw]')) return;
      var cardEl = t.closest ? t.closest(
        '.ag-finish-row .ag-finish-card--selectable,'
        + ' .ag-finish-display-list .ag-finish-card--display') : null;
      if (cardEl) {
        showSharedPanel(
          cardEl.querySelector('.ag-finish-card-img-wrap') || cardEl,
          cardData(cardEl));
        return;
      }
      if (t.closest && t.closest('.agcf-ghost')) showGhostPanel();
    });
    root.addEventListener('focusout', function (e) {

      var to = e.relatedTarget;
      var from = e.target;
      var anchor = from.closest ? from.closest(
        '.ag-finish-card, .agcf-ghost') : null;
      if (!anchor) return;
      if (to && anchor.contains(to)) return;
      hideSharedPanel();
      hideGhostPanel();
    });

    root.addEventListener('click', function (e) {
      var tile = e.target.closest ? e.target.closest('[data-agcf-sw]') : null;
      if (tile) {
        var f = BY_CODE[tile.getAttribute('data-code')];
        if (!f) return;
        openPop(tile, f);
        return;
      }

      var card = e.target.closest
        ? e.target.closest('.ag-finish-row .ag-finish-card') : null;
      if (card && root.contains(card)) {
        root.querySelectorAll('.ag-finish-row .ag-finish-card.is-selected')
          .forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        var vv = card.getAttribute('data-variant-value');
        var atcBtn = document.getElementById('add-to-cart-btn');
        var pform = atcBtn && atcBtn.closest ? atcBtn.closest('form') : null;
        if (vv && pform) {
          pform.querySelectorAll('input[type="radio"]')
            .forEach(function (radio) {
              var n = (radio.getAttribute('name') || '').toLowerCase();
              if (n.indexOf('finish') > -1 && radio.value === vv
                  && !radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', {bubbles: true}));
              }
            });
        }
        closePop();
        if (st.customOn) {
          selectStockSide(vv || card.getAttribute('data-finish-name'));
        } else {
          paneRefresh();
        }
        return;
      }

      var disp = e.target.closest ? e.target.closest(
        '.ag-finish-display-list .ag-finish-card--display') : null;
      if (disp && root.contains(disp)) {
        closePop();
        selectStockSide(disp.getAttribute('data-finish-name'));
      }
    });

    wireFilter();
    paneRefresh();
  }

  var root = document.querySelector('[data-agcf-r6]');
  if (root) init(root);

  document.addEventListener('mousedown', function (e) {
    if (!popOpen()) return;
    if (st.pop.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-agcf-sw]')) return;
    closePop();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    closePop(true);
  });
  window.addEventListener('scroll', function (e) {

    if (!popOpen()) return;
    if (isMobile()) return;
    if (st && st.pop && e.target && e.target !== document
        && st.pop.contains && st.pop.contains(e.target)) return;
    if (st && st.popOpenedAt && window.performance && performance.now
        && performance.now() - st.popOpenedAt < 350) return;
    closePop(true);
  }, true);
  window.addEventListener('resize', function () {
    closePop();
    if (window.requestAnimationFrame) {

      if (!window.__agcfCapRaf) {
        window.__agcfCapRaf = requestAnimationFrame(function () {
          window.__agcfCapRaf = null;
          replaceCaption();
        });
      }
    } else {
      replaceCaption();
    }
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { replaceCaption(); });
  }

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }
  function unitPrice() {
    /* R44 (Datch 2026-09-07): agcf8Variant() never carried a .price field
       (id/side only) - this always fell through to CFG.price, a string
       baked in once at initial page load, so custom-finish pricing stayed
       pinned to whatever size was selected on load. A8_BASE_PRICE_TXT
       (kept current by a8RefreshBasePrice, defined below with
       updateAtcPrice) is the pure variant price - unlike reading
       #product-main-price directly, it's immune to us having just written
       a surcharge-inclusive total in there ourselves. */
    a8RefreshBasePrice();
    var m = /([\d,]+)/.exec(A8_BASE_PRICE_TXT || CFG.price || '');
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
  }
  function samplePrice() {
    var m = /([\d,]+)/.exec(R6.sheet.price || '');
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : 5;
  }
  function heroImg() {
    var img = document.querySelector(
      '.slick-product-gallery .product-header_gallery-image');
    return img ? (img.currentSrc || img.src) : '';
  }
  function sampleLineHTML(code) {
    var f = BY_CODE[code];
    if (!f) return '';
    var title = R6.drawer_sample
      .replace('{name}', f.name).replace('{code}', f.code);
    return '<div class="cart-drawer__item agcf-cart-sample" '
      + 'data-agcf-sample-line data-code="' + esc(code) + '">'
      + '<div class="cart-drawer__item-image">'
      + '<img src="' + esc(cdn(f.image, 150)) + '" alt="' + esc(title) + '"'
      + ' class="cart-drawer__item-image-img" width="150" height="150"></div>'
      + '<div class="cart-drawer__item-details">'
      + '<h3 class="cart-drawer__item-title">'
      + '<a href="#" class="cart-drawer__item-link">' + esc(title)
      + '</a></h3>'
      + '<div class="cart-drawer__item-price">' + money(samplePrice())
      + '</div></div>'
      + '<div class="cart-drawer__item-remove">'
      + '<button type="button" class="cart-drawer__item-remove-button" '
      + 'data-agcf-sample-remove data-code="' + esc(code) + '" '
      + 'aria-label="Remove ' + esc(title) + '">'
      + '<svg aria-hidden="true" focusable="false" class="icon icon-remove" viewBox="0 0 18 17"><path d="'
      + P_REMOVE + '" fill="currentColor"/></svg></button></div></div>';
  }
  function buildDrawer() {
    if (!A8_PROTO) { a8DrawerSync(); return null; }
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return null;
    var content = drawer.querySelector('.cart-drawer__content');
    var qtyEl = document.getElementById('quantity');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value || '1', 10) || 1);
    var sampleCount = st ? st.sampleOrder.length : 0;
    var effUnit = (st && st.customOn && st.primary) ? customPrice() : unitPrice();
    var total = effUnit * qty + samplePrice() * sampleCount;
    var title = (document.querySelector('h1') || {textContent: 'Product'})
      .textContent.trim();

    var variantRow = enumerateOptions().concat(
      stockFinishName() ? [stockFinishName()] : []).join(' / ');
    var propRows = '';
    if (st && st.customOn && st.primary) {

      variantRow = enumerateOptions().concat(
        ['Custom Finishing: ' + st.primary.name
         + (st.accent ? ' & ' + st.accent.name : '')]).join(' / ');
    }
    var sampleRows = st
      ? st.sampleOrder.map(sampleLineHTML).join('') : '';
    content.innerHTML =
      '<form class="cart-drawer__form" action="/cart" method="post" novalidate>'
      + '<div id="cart-drawer-items" class="cart-drawer__items">'
      + '<div class="cart-drawer__item" id="cart-drawer-item-1">'
      + '<div class="cart-drawer__item-image">'
      + '<img src="' + esc(agcf8CardImg() || heroImg()) + '" alt="' + esc(title) + '"'
      + ' class="cart-drawer__item-image-img" width="150" height="150"></div>'
      + '<div class="cart-drawer__item-details">'
      + '<h3 class="cart-drawer__item-title">'
      + '<a href="#" class="cart-drawer__item-link">' + esc(title) + '</a></h3>'
      + '<div class="cart-drawer__item-price">' + money(effUnit) + '</div>'
      + '<div class="agcf-cart-variant">' + esc(variantRow) + '</div>'
      + propRows
      + '<div class="cart-drawer__item-quantity"><div class="quantity">'
      + '<button class="quantity__button quantity__button--minus" type="button">'
      + '<svg aria-hidden="true" focusable="false" class="icon icon-minus" viewBox="0 0 10 2"><path fill-rule="evenodd"'
      + ' clip-rule="evenodd" d="M.5 1C.5.7.8.5 1 .5h8c.3 0 .5.2.5.5s-.2.5-.5.5H1C.8'
      + ' 2 .5 1.8.5 1z" fill="currentColor"/></svg></button>'
      + '<input class="quantity__input" type="number" value="' + qty + '" min="0">'
      + '<button class="quantity__button quantity__button--plus" type="button">'
      + '<svg aria-hidden="true" focusable="false" class="icon icon-plus" viewBox="0 0 10 10"><path fill-rule="evenodd"'
      + ' clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5'
      + 'l3.5-.01a.5.5 0 00-.01-1H5.5L5.49 1a.5.5 0 00-1 .01v3.5L1 4.51z"'
      + ' fill="currentColor"/></svg></button>'
      + '</div></div></div>'
      + '<div class="cart-drawer__item-remove">'
      + '<button type="button" class="cart-drawer__item-remove-button">'
      + '<svg aria-hidden="true" focusable="false" class="icon icon-remove" viewBox="0 0 18 17"><path d="'
      + P_REMOVE + '" fill="currentColor"/></svg></button></div>'
      + '</div>'
      + sampleRows
      + '</div>'
      + '<div class="cart-drawer__footer">'
      + '<div class="cart-drawer__note">'
      + '<label for="cart-drawer-note">Order special instructions</label>'
      + '<textarea class="cart-drawer__note-textarea" id="cart-drawer-note"'
      + ' placeholder="Add a note to your order..."></textarea></div>'
      + '<div class="cart-drawer__totals">'
      + '<div class="cart-drawer__subtotal">'
      + '<span class="cart-drawer__subtotal-label">Subtotal</span>'
      + '<span class="cart-drawer__subtotal-price">' + money(total) + '</span></div>'
      + '<div class="cart-drawer__taxes"><p class="cart-drawer__taxes-note">'
      + 'Taxes and shipping calculated at checkout.</p></div>'
      + '<div class="cart-drawer__checkout">'
      + '<button type="submit" class="cart-drawer__checkout-button button'
      + ' button--primary">CHECKOUT - ' + money(total) + '</button>'
      + '</div></div></div></form>';
    content.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
    });

    var qin = content.querySelector('.quantity__input');
    var subEl = content.querySelector('.cart-drawer__subtotal-price');
    var coEl = content.querySelector('.cart-drawer__checkout-button');
    function setQty(n) {
      n = Math.max(1, isNaN(n) ? 1 : n);
      qin.value = n;

      if (qtyEl) qtyEl.value = n;
      var sc = st ? st.sampleOrder.length : 0;
      var t = money(unitPrice() * n + samplePrice() * sc);
      subEl.textContent = t;
      coEl.textContent = 'CHECKOUT - ' + t;
    }
    content.querySelector('.quantity__button--minus')
      .addEventListener('click', function () {
        setQty(parseInt(qin.value, 10) - 1);
      });
    content.querySelector('.quantity__button--plus')
      .addEventListener('click', function () {
        setQty(parseInt(qin.value, 10) + 1);
      });
    qin.addEventListener('change', function () {
      setQty(parseInt(qin.value, 10));
    });

    content.querySelectorAll('[data-agcf-sample-remove]')
      .forEach(function (b) {
        b.addEventListener('click', function () {
          unrequestSample(b.getAttribute('data-code'));
        });
      });
    return drawer;
  }
  function openDrawer() {
    if (!A8_PROTO) { a8PortDrawer(); return; }

    if (pickerOpen()) return;
    var drawer = buildDrawer();
    if (!drawer) return;
    drawer.classList.remove('cart-drawer--empty');
    drawer.classList.add('cart-drawer--open');
    document.body.classList.add('cart-drawer-open');
    var close = function () {
      drawer.classList.remove('cart-drawer--open');
      document.body.classList.remove('cart-drawer-open');
    };
    var x = drawer.querySelector('.cart-drawer__close');
    if (x && !x.getAttribute('data-agcf-wired')) {
      x.setAttribute('data-agcf-wired', '1');
      x.addEventListener('click', close);
    }
    var ov = document.getElementById('cart-drawer-overlay');
    if (ov && !ov.getAttribute('data-agcf-wired')) {
      ov.setAttribute('data-agcf-wired', '1');
      ov.addEventListener('click', close);
    }
  }

  var A8 = { base: 'http://127.0.0.1:5077', server: null, token: 0,
             generating: false, cache: {}, ledger: null, place: 'p2',
             btn: null, timer: null, exit: null, slideH: 0,
             hist: null, histPanel: null, histOn: false, histAt: 0,
             bodyLock: null, slickHooked: false, mKey: null,
             vid: null, tsReady: null, gateWidget: null,
             gateT: null, busyT: null, jobs: {}, live: {}, fbKey: null,
             gateKey: null, pv: null,
             mAdd: null, mNavShim: false, swapLatch: 0,

             smp: {}, smpP: {}, smpBusy: {}, smpOpen: false };
  var A8_JOBS_MAX = 3;

  var A8_SPACER = 'data:image/svg+xml;charset=utf-8,'
    + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg"'
      + ' width="1024" height="1024"></svg>');
  var A8_SIM = {
    pair: 'checkout-round/renders/v2/nbp_v2_pair_mb_ccw_wm1.png',
    single: 'checkout-round/renders/v2/nbp_v2_primary_flame_wm1.png'
  };

  var A8_MAG = '<span class="ag-finish-card-icon" aria-hidden="true">'
    + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" '
    + 'focusable="false"><path d="M229.66,218.34l-50.06-50.06a88,88,0,'
    + '1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,'
    + '72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path></svg></span>';

  var A8_GATE_HEAD = "Quick check before your next preview";
  var A8_GATE_SUB = "Takes only a moment";
  var A8_GATE_ERR = "That preview didn't come through";
  var A8_GATE_ERR_SUB = "Please try again";
  var A8_GATE_CAP = "Today's preview limit is reached";
  var A8_GATE_CAP_SUB = "More tomorrow";
  var A8_GATE_BUSY = "Three previews are already rendering";
  var A8_GATE_BUSY_SUB = "One moment";

  var A8_GART = {

    chal: '<path d="M14 58 H132 V64 H14 Z"/>'
      + '<path d="M28 64 V104 H84 V64"/>'
      + '<path d="M156 70 H212 V76 H156 Z"/>'
      + '<path d="M206 24 H212 V70 H206 Z"/>'
      + '<path d="M160 76 V104"/><path d="M206 76 V104"/>',

    cap: '<path d="M14 58 H226 V64 H14 Z"/>'
      + '<path d="M30 64 V104 H86 V64"/><path d="M154 64 V104 H210 V64"/>'
      + '<path d="M86 84 H154"/>'
      + '<path d="M92 46 H148 V52 H92 Z"/>'
      + '<path d="M98 18 V46"/><path d="M142 18 V46"/>',

    err: '<path d="M14 58 H226 V64 H14 Z"/>'
      + '<path d="M30 64 V104 H86 V64"/><path d="M86 84 H128"/>'
      + '<path d="M150 96 H210 V102 H150 Z"/>'
      + '<path d="M158 84 H202 V90 H158 Z"/>',

    busy: '<path d="M14 66 H74 V71 H14 Z"/>'
      + '<path d="M20 71 V102"/><path d="M68 71 V102"/>'
      + '<path d="M90 66 H150 V71 H90 Z"/>'
      + '<path d="M96 71 V102"/><path d="M144 71 V102"/>'
      + '<path d="M166 66 H226 V71 H166 Z"/>'
      + '<path d="M172 71 V102"/><path d="M220 71 V102"/>'
  };

  var A8_ART = '<path d="M14 58 H226 V64 H14 Z"/>'
    + '<path d="M30 64 V104 H86 V64"/><path d="M154 64 V104 H210 V64"/>'
    + '<path d="M86 84 H154"/>';

  var A8_SIDE_NAMES = ['Return Desk', 'Reception Configuration'];
  function a8SideSel(sfx) {
    var out = [];
    for (var i = 0; i < A8_SIDE_NAMES.length; i++) {
      out.push('input[name="' + A8_SIDE_NAMES[i] + '"]' + (sfx || ''));
    }
    return out.join(',');
  }
  function a8SideRadios(sfx) {
    return document.querySelectorAll(a8SideSel(sfx));
  }
  function a8SideValue(r) {

    return /left/i.test((r && r.value) || '') ? 'left'
      : /right/i.test((r && r.value) || '') ? 'right' : null;
  }
  function agcf8Variant() {
    var r = document.querySelector(a8SideSel(':checked'));
    if (!r) return null;
    return { id: r.getAttribute('data-variant-id') || '',
             side: a8SideValue(r) };
  }
  function a8Side() {
    var v = agcf8Variant();
    if (v && v.side) return v.side;

    var any = document.querySelector(a8SideSel(''));
    return (any && any.name === 'Return Desk') ? 'right' : 'base';
  }
  /* 2026-10-16 (Ansen): Winsor and Penfold are different pieces at each width, so their preview is per width:
     the key gains __w<inches> and the job sends &size=. Every other product's key is unchanged. */
  var A8_PER_WIDTH = { 'winsor-office-shelves-storage-with-suit-closet': 1,
                       'penfold-office-credenza-cabinet-sideboard': 1 };
  function a8Width() {
    if (!A8_PER_WIDTH[a8Handle()]) return 0;
    var s = document.querySelector('select[name="Size"]');
    var m = /(\d+)\s*[\u2032'\u2019]\s*(?:(\d+)\s*[\u2033"\u201d])?/.exec(String((s && s.value) || ''));
    return m ? (+m[1]) * 12 + (+(m[2] || 0)) : 0;
  }
  function a8WPart(k) { return (String(k || '').split('__')[4] || ''); }
  function a8Key() {
    if (!st || !st.customOn || !st.primary) return null;
    var w0 = a8Width();
    return (a8Handle() || 'proto') + '__' + st.primary.code + '__'
      + (st.accent ? st.accent.code : 'none') + '__' + a8Side()
      + (w0 ? '__w' + w0 : '');
  }
  function a8N(p, sel) { return p.querySelector('[data-agcf8-' + sel + ']'); }
  function a8KeyPair(key) {

    var parts = (key || '').split('__');
    return {
      p: BY_CODE[parts[1]] || null,
      a: (parts[2] && parts[2] !== 'none') ? (BY_CODE[parts[2]] || null) : null
    };
  }
  function a8PairLabel(key) {

    var pr = a8KeyPair(key);
    if (!pr.p) return '';
    return pr.p.name + (pr.a ? ' & ' + pr.a.name : '');
  }
  function a8KeyNames(key) {
    var lbl = a8PairLabel(key);
    return lbl ? ('Rendered finish preview · ' + lbl)
      : 'Rendered finish preview';
  }
  function a8PickLabel(key) {

    var pr = a8KeyPair(key);
    if (!pr.p) return '';
    return pr.p.name + (pr.a ? ' / ' + pr.a.name : '');
  }
  function a8PickHTML(key) {

    var pr = a8KeyPair(key);
    if (!pr.p) return '';
    return '<button type="button" class="agcf8-slide-pick"'
      + ' data-agcf8-slide-pick aria-label="Apply this finish">'
      + '<span class="agcf8-pick-box">'
      + '<img class="agcf8-pick-primary" src="'
      + esc(cdn(pr.p.image, 160)) + '" alt="" decoding="async">'
      + (pr.a
         ? '<img class="agcf8-pick-accent" src="'
           + esc(cdn(pr.a.image, 160)) + '" alt="" decoding="async">'
         : '')
      + '</span>'
      + '<span class="agcf8-pick-name">' + A8_RE_ICO
      + '<span class="agcf8-pick-txt">' + esc(a8PickLabel(key))
      + '</span></span></button>';
  }
  function a8ApplyPair(pCode, aCode, side) {

    if (!BY_CODE[pCode]) return false;
    A8.applying = true;
    assign('primary', BY_CODE[pCode]);
    if (aCode && BY_CODE[aCode]) assign('accent', BY_CODE[aCode]);
    else if (!aCode && st && st.accent) clearRole('accent');
    A8.applying = false;

    updateGhost();
    if (st && st.customOn && st.primary) {
      a8HistPut(st.primary.code, st.accent ? st.accent.code : null,
                a8ProductName());
    }
    if (side) {
      var rads = a8SideRadios('');
      for (var i = 0; i < rads.length; i++) {

        var rs = a8SideValue(rads[i]);
        if (rs === side && !rads[i].checked) {
          rads[i].checked = true;
          rads[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
    a8SelNav();
    if (drawerIsOpen()) buildDrawer();
    return true;
  }
  function agcf8CardImg() {

    var key = a8Key();
    if (!key) return '';
    if (A8.cache[key]) return A8.cache[key];
    var l = a8LedgerLoad();
    if (l.items[key] && l.items[key].url) return l.items[key].url;

    var want = key.split('__').slice(0, 3).join('__');
    for (var j = 0; j < l.order.length; j++) {
      var k2 = l.order[j];
      if (k2.split('__').slice(0, 3).join('__') === want
          && a8WPart(k2) === a8WPart(key)
          && l.items[k2] && l.items[k2].url) return l.items[k2].url;
    }
    return '';
  }

  function a8GlossOf(f) {
    if (!f) return false;
    return ((f.name || '') + ' ' + (f.material || ''))
      .toLowerCase().indexOf('gloss') >= 0;
  }
  function a8FinByName(name) {
    if (!name) return null;
    var nl = name.trim().toLowerCase();
    var keys = Object.keys(BY_CODE);
    for (var i = 0; i < keys.length; i++) {
      var f = BY_CODE[keys[i]];
      if ((f.name || '').toLowerCase() === nl) return f;
    }
    return null;
  }
  function a8PctFor(p, a, stockName) {

    if (!p) return 0;
    var stock = a8FinByName(stockName === undefined ? stockFinishName() : stockName);
    var curG = a8GlossOf(stock);
    var slot = function (t) {
      if (!t) return 0;
      if (stock && t.code === stock.code) return 0;
      if (a8GlossOf(t)) return curG ? 5 : 25;
      return curG ? 0 : 5;
    };
    return Math.max(slot(p), a ? slot(a) : 0);
  }
  function a8PriceFor(p, a, baseDollars, stockName) {

    var base = baseDollars === undefined ? unitPrice() : baseDollars;
    var pct = a8PctFor(p, a, stockName);
    if (!pct) return base;
    var v = Math.ceil((base * (1 + pct / 100)) / 20) * 20;
    if (v % 100 === 0) v += 20;
    return v;
  }
  function customPct() {
    return (st && st.customOn && st.primary)
      ? a8PctFor(st.primary, st.accent) : 0;
  }
  function customPrice() {
    return customPct() ? a8PriceFor(st.primary, st.accent) : unitPrice();
  }
  /* The same rule for ANOTHER piece (Datch 2026-10-13: a set piece added in
     the page's combo pays what its own page would charge). codes = the line
     property "_finish_codes" ("P=9012;A=LS26041;S=R"), unitCents = the
     piece's variant price, stockName = its standard finish. units = the
     surcharge line's quantity per piece under the shim's own condition (a
     whole number of A8_SUR.unit); price = what the piece is charged in the
     combo. Read by assets/ag-set-attach.js (the set card) and
     assets/cart-drawer.js (the drawer's set card). */
  function a8ComboPrice(codes, unitCents, stockName) {
    var mp = /(?:^|;)P=([^;]+)/.exec(codes || '');
    var p = mp ? BY_CODE[mp[1]] : null;
    if (!p) return null;
    var ma = /(?:^|;)A=([^;]+)/.exec(codes || '');
    var a = ma ? (BY_CODE[ma[1]] || null) : null;
    var cents = Math.max(0, Math.round(unitCents || 0));
    var base = Math.floor(cents / 100);
    var d = a8PriceFor(p, a, base, stockName || '') - base;
    var ok = A8_SUR.vid && d > 0 && d % A8_SUR.unit === 0;
    /* one line per piece at its amount when the amounts product has it
       (Datch 2026-10-14), else today's $10 units */
    var amt = ok && A8_SUR.amounts ? A8_SUR.amounts[String(d)] : 0;
    return { units: ok ? (amt ? 1 : d / A8_SUR.unit) : 0,
             vid: amt || A8_SUR.vid,
             price: cents + (ok ? d * 100 : 0) };
  }
  window.AGCF = window.AGCF || {};
  window.AGCF.comboPrice = a8ComboPrice;
  /* PDP polish (Ansen 2026-10-17, board 2A): what a finish code looks like, for the set cards' finish dots
     (ag-set-renders.js AGSR.swatch); a PANTONE code resolves from the code alone (BY_CODE's proxy) */
  window.AGCF.swatch = function (code) {
    var f = code ? BY_CODE[code] : null;
    if (!f) return null;
    return { name: f.name, hex: f.hex || '', image: f.pms ? '' : cdn(f.image, 48) };
  };

  var A8_RM_P = 'Remove as primary';
  var A8_RM_A = 'Remove as accent';
  function agcf8PopDeltas(pop, f, accentOk) {

    var cur = (st && st.customOn && st.primary) ? customPrice() : unitPrice();
    var role = roleOf(f);
    var pBtn = pop.querySelector(
      '.agcf-pop5-actions .agcf-pop5-btn:not(.agcf-pop5-btn--ghost)');
    var aBtn = pop.querySelector(
      '.agcf-pop5-actions .agcf-pop5-btn--ghost');
    var any = false;
    var write = function (btn, act, label, d) {
      if (!btn) return;
      btn.setAttribute('data-agcf-pop', act);

      btn.textContent = label;
      if (!d) return;
      var s = document.createElement('span');
      s.className = 'agcf8-pop-delta';
      s.textContent = (d > 0 ? '+' : '−') + money(Math.abs(d));
      btn.appendChild(s);
      any = true;
    };
    if (role === 'primary') {

      write(pBtn, 'remove', A8_RM_P, unitPrice() - cur);
    } else {

      var accNow = (st && st.accent
                    && st.accent.code === f.code) ? null
        : (st ? st.accent : null);
      write(pBtn, 'primary', R3.popover.set_primary,
            a8PriceFor(f, accNow) - cur);
    }
    if (role === 'accent') {

      write(aBtn, 'remove', A8_RM_A,
            ((st && st.customOn) ? a8PriceFor(st.primary, null)
                                 : unitPrice()) - cur);
    } else if (accentOk) {
      write(aBtn, 'accent', R3.popover.set_accent,
            a8PriceFor(st.primary, f) - cur);
    } else {

      write(aBtn, 'accent', R3.popover.set_accent, 0);
    }

    var rm = pop.querySelector('.agcf-pop5-remove');
    if (rm) rm.classList.toggle('agcf8-hidden', !!role);
    var row = pop.querySelector('.agcf-pop5-actions');
    if (row) {
      row.classList.toggle('agcf8-has-delta', any);
      row.classList.toggle('agcf8-has-remove', !!role);
    }

    var oldTip = pBtn ? pBtn.querySelector('.agcf-pop5-tip') : null;
    if (oldTip) oldTip.remove();
    var primaryAlreadySet = !role && !!(st && st.primary);
    if (row) row.classList.toggle('agcf8-primary-set', primaryAlreadySet);
    if (pBtn && primaryAlreadySet) {
      var tip = document.createElement('span');
      tip.className = 'agcf-pop5-tip';
      tip.setAttribute('role', 'tooltip');
      tip.textContent = 'Replaces ' + st.primary.name + ' as your primary finish';
      pBtn.appendChild(tip);
    }
  }

  var A8_LKEY = 'agcf8:ledger:v2';
  function a8LedgerLoad() {
    if (A8.ledger) return A8.ledger;
    var l = null;
    try { l = JSON.parse(localStorage.getItem(A8_LKEY)); } catch (e) {}

    if (!l || l.v !== 2 || !Array.isArray(l.order)
        || typeof l.items !== 'object' || !l.items) {
      l = { v: 2, order: [], items: {} };
    }

    try { localStorage.removeItem('agcf8:ledger:v1'); } catch (e2) {}
    l.order = l.order.filter(function (k) { return typeof k === 'string'; });

    l.order = l.order.filter(function (k3) {
      var it3 = l.items[k3];
      if (it3 && typeof it3.url === 'string'
          && it3.url.indexOf('data:') === 0) {
        delete l.items[k3];
        return false;
      }
      if (it3 && typeof it3.sib === 'string'
          && it3.sib.indexOf('data:') === 0) {
        delete it3.sib;
      }
      return true;
    });

    for (var pi = 0; pi < l.order.length; pi++) {
      var pk = l.order[pi];
      var ps = a8SibKey(pk);
      if (!ps) continue;
      var pidx = l.order.indexOf(ps);
      if (pidx > pi && l.items[ps]) {
        if (l.items[pk] && !l.items[pk].sib && l.items[ps].url) {
          l.items[pk].sib = l.items[ps].url;
        }
        l.order.splice(pidx, 1);
        delete l.items[ps];
        pi--;
      }
    }
    while (l.order.length > 5) {
      var drop = l.order.pop();
      delete l.items[drop];
    }
    A8.ledger = l;
    return l;
  }
  function a8LedgerSave() {
    try { localStorage.setItem(A8_LKEY, JSON.stringify(A8.ledger)); }
    catch (e) {

      try {
        var drop = A8.ledger.order.pop();
        if (drop) delete A8.ledger.items[drop];
        localStorage.setItem(A8_LKEY, JSON.stringify(A8.ledger));
      } catch (e2) {}
    }
  }
  function a8LedgerPut(key, url, sim, sib, inPlace) {

    try {
      if (!url || url.indexOf('data:') === 0) return;
      var l = a8LedgerLoad();
      var keep = (l.items[key] && l.items[key].sib) || null;
      var sk = a8SibKey(key);
      /* inPlace (a pick, not a new render): the key keeps its spot, or takes its other-side twin's spot */
      var was = l.items[key] || (sk && l.items[sk]) || null;
      var pos = inPlace ? l.order.indexOf(key) : -1;
      if (inPlace && pos < 0 && sk) pos = l.order.indexOf(sk);
      if (sk && l.items[sk]) {
        if (!sib && l.items[sk].url) sib = l.items[sk].url;
        l.order = l.order.filter(function (k0) { return k0 !== sk; });
        delete l.items[sk];
      }
      var rest = l.order.filter(function (k) { return k !== key; });
      if (pos >= 0) {
        rest.splice(Math.min(pos, rest.length), 0, key);
        l.order = rest;
      } else {
        l.order = [key].concat(rest);
      }
      l.items[key] = { url: url, sim: !!sim,
        ts: (pos >= 0 && was && typeof was.ts === 'number') ? was.ts : Date.now() };
      var s2 = (typeof sib === 'string' && sib) ? sib : keep;
      if (s2) l.items[key].sib = s2;
      while (l.order.length > 5) {
        var drop = l.order.pop();
        delete l.items[drop];
      }
      a8LedgerSave();
    } catch (e) {}
  }
  function a8LedgerDrop(key) {
    try {
      var l = a8LedgerLoad();
      l.order = l.order.filter(function (k) { return k !== key; });
      delete l.items[key];
      a8LedgerSave();
    } catch (e) {}
  }

  function a8SibKey(key) {

    var p = (key || '').split('__');
    if (p.length !== 4) return null;
    if (p[3] === 'left') p[3] = 'right';
    else if (p[3] === 'right') p[3] = 'left';
    else return null;
    return p.join('__');
  }
  function a8PairHit(key) {

    if (!key) return null;
    var l = a8LedgerLoad();
    if (A8.cache[key] && A8.cache[key].indexOf('data:') !== 0) {

      var it0 = l.items[key];
      return { url: A8.cache[key], sim: it0 ? !!it0.sim : false };
    }
    if (l.items[key] && l.items[key].url) {
      return { url: l.items[key].url, sim: !!l.items[key].sim };
    }
    var sk = a8SibKey(key);
    if (sk && l.items[sk] && l.items[sk].sib) {
      return { url: l.items[sk].sib, sim: !!l.items[sk].sim };
    }
    return null;
  }
  function a8SelNav() {

    var key = a8Key();
    if (!key) return;
    if (A8.jobs[key]) { a8Latch(); a8Goto(key, 500); return; }
    var hit = a8PairHit(key);
    if (hit && hit.url) {
      /* 2026-10-18 (Ansen): picking or arrowing to a saved preview keeps its place. Previews sit in the order they
         were made (newest first); moving the picked one to the top made next / prev bounce between the first two. */
      a8UpsertSlides(key, hit.url, hit.sim, true);

      a8LedgerPut(key, hit.url, hit.sim, undefined, true);
      a8Latch();
      a8Goto(key, 500);
      setTimeout(function () {
        if (a8Key() === key && a8CurrentKey() !== key) {
          a8Goto(key, 500);
        }
      }, 480);
      return;
    }

    a8SideSwap();
  }
  function a8KeyedSlideKeys() {

    var out = [];
    var gt = a8GalTrack();
    if (a8MReal() && gt) {
      var ns = gt.querySelectorAll(
        ':scope > .agcf8-mslide:not(.slick-cloned)');
      for (var i = 0; i < ns.length; i++) {
        var k = ns[i].getAttribute('data-agcf8-key');
        if (k) out.push(k);
      }
      return out;
    }
    var ss = document.querySelectorAll('.agcf8-slide[data-agcf8-key]');
    for (var j = 0; j < ss.length; j++) {
      var k2 = ss[j].getAttribute('data-agcf8-key');
      if (k2) out.push(k2);
    }
    return out;
  }
  function a8XFade(img, oldSrc, ms) {

    if (!img || !oldSrc) return;
    if (oldSrc === img.getAttribute('src')) return;
    if (oldSrc.indexOf('data:') === 0) return;
    var sl = img.closest ? img.closest('.agcf8-slide') : null;
    if (!sl || !sl.classList.contains('slick-current')) return;
    if (window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var prior = sl.querySelectorAll('[data-agcf8-xfade]');
    for (var gi = 0; gi < prior.length; gi++) {
      if (prior[gi].parentNode) {
        prior[gi].parentNode.removeChild(prior[gi]);
      }
    }
    var g = document.createElement('img');
    g.className = img.className + ' agcf8-xfade';
    g.setAttribute('data-agcf8-xfade', '');
    g.setAttribute('aria-hidden', 'true');
    g.alt = '';
    g.src = oldSrc;
    img.insertAdjacentElement('afterend', g);
    g.getBoundingClientRect();
    g.style.transition = 'opacity ' + (ms || 500) + 'ms ease';
    g.style.opacity = '0';
    var done = false;
    var kill = function () {
      if (done) return;
      done = true;
      if (g.parentNode) g.parentNode.removeChild(g);
    };
    g.addEventListener('transitionend', kill);
    setTimeout(kill, (ms || 500) + 150);
  }
  function a8SideSwap() {

    var side = a8Side();
    if (side !== 'left' && side !== 'right') return;
    var mounted = a8KeyedSlideKeys();
    for (var mi0 = 0; mi0 < mounted.length; mi0++) {
      (function (old) {
        var parts = old.split('__');
        if (parts.length !== 4 || parts[3] === side) return;
        if (parts[3] !== 'left' && parts[3] !== 'right') return;
        var key = parts.slice(0, 3).join('__') + '__' + side;
        var hit = a8PairHit(key);
        if (!hit || !hit.url) {

          if (st && st.customOn && a8Key() === key) a8Backfill(key);
          return;
        }
        var l = a8LedgerLoad();
        var oldUrl = (l.items[old] && l.items[old].url)
          || (l.items[key] && l.items[key].sib) || '';
        var im = new Image();
        im.onload = function () {
          if (a8Side() !== side) return;
          if (a8MReal()) {
            var node = a8MSlideFind(old);
            if (!node) return;
            node.setAttribute('data-agcf8-key', key);
            var ni = node.querySelector('img');
            if (ni) { ni.src = hit.url; ni.alt = a8KeyNames(key); }

            var cls = document.querySelectorAll(
              '.slick-product-gallery .slick-cloned[data-agcf8-key="'
              + a8CssKey(old) + '"]');
            for (var ci = 0; ci < cls.length; ci++) {
              cls[ci].setAttribute('data-agcf8-key', key);
            }
            a8MSyncClones(key);
            var rail = document.querySelector(
              '.slick-product-thumbnail');
            var cell = rail && rail.querySelector(
              '[data-agcf8-mcell][data-agcf8-key="' + a8CssKey(old)
              + '"]');
            if (cell) {
              cell.setAttribute('data-agcf8-key', key);
              var ci2 = cell.querySelector('img');
              if (ci2) ci2.src = hit.url;
            }
          } else if (a8MMode()) {

            if (A8.mKey === old) A8.mKey = key;
            var mc = document.querySelector(
              '[data-agcf8-mcell], .agcf8-mthumb');
            if (mc && mc.getAttribute('data-agcf8-key') === old) {
              mc.setAttribute('data-agcf8-key', key);
              var mi = mc.querySelector('img');
              if (mi) mi.src = hit.url;
            }
          } else {

            var pair = a8SlidePair(old);
            if (pair.slide) {
              pair.slide.setAttribute('data-agcf8-key', key);
              var si = pair.slide.querySelector('img');
              if (si) {

                var xf = si.getAttribute('src') || '';
                si.src = hit.url;
                si.alt = a8KeyNames(key);
                a8XFade(si, xf, 500);
              }
            }
            if (pair.thumb) {
              pair.thumb.setAttribute('data-agcf8-key', key);
              var ti = pair.thumb.querySelector('img');
              if (ti) ti.src = hit.url;
            }
          }
          A8.cache[key] = hit.url;

          a8LedgerDrop(old);
          a8LedgerPut(key, hit.url, hit.sim, oldUrl || undefined);
          a8CartProps();
          a8Button();
          if (st && st.customOn && a8Key() === key) {

            a8Latch();
            a8Goto(key, 500);
            setTimeout(function () {
              if (a8Key() === key && a8CurrentKey() !== key) {
                a8Goto(key, 500);
              }
            }, 480);
          }
        };
        im.src = hit.url;
      })(mounted[mi0]);
    }
  }
  function a8VarNavGate() {

    var vs = window.variantSelector;
    if (!vs || vs.__agcf8Wrapped
        || typeof vs.updateProductImage !== 'function') return;
    vs.__agcf8Wrapped = true;
    var orig = vs.updateProductImage;
    vs.updateProductImage = function () {
      if (A8.swapLatch && Date.now() < A8.swapLatch) return;
      return orig.apply(this, arguments);
    };
  }
  function a8Latch() {

    A8.swapLatch = Date.now() + 450;
    a8VarNavGate();
  }
  function a8Backfill(key) {

    if (!key || A8.bf === key) return;
    var parts = key.split('__');
    if (parts.length !== 4) return;
    if (parts[3] !== 'left' && parts[3] !== 'right') return;
    A8.bf = key;
    var fin = function () { A8.bf = null; };
    var commit = function (j) {
      fin();
      if (!j || j.status !== 'done' || !j.url) return;
      if (a8Side() !== parts[3]) return;
      var url = a8JobUrl(j);
      a8LedgerPut(key, url, false);

      a8Trk('bf', { url: url });
      A8.cache[key] = url;
      a8SideSwap();
    };
    var tries = 0;
    var poll = function (id) {
      if (tries++ > 8) { fin(); return; }
      setTimeout(function () {
        fetch(a8GenBase() + '/jobs/' + encodeURIComponent(id)
              + '?b=r29')
          .then(function (r) {
            if (!r.ok) throw new Error('bf ' + r.status);
            return r.json();
          })
          .then(function (j) {
            if (j && j.status === 'done' && j.url) { commit(j); return; }
            if (j && j.status === 'failed') { fin(); return; }
            poll(id);
          })
          .catch(fin);
      }, 1500);
    };
    var qs = '?primary=' + encodeURIComponent(parts[1])
      + (parts[2] && parts[2] !== 'none'
         ? '&accent=' + encodeURIComponent(parts[2]) : '')
      + '&src=' + encodeURIComponent(parts[3])
      + a8HandleQS()
      + '&vid=' + encodeURIComponent(a8Vid())
      + '&derive=1&b=r29';
    fetch(a8GenBase() + '/jobs' + qs, { method: 'POST' })
      .then(function (r) {
        if (r.status === 204) { fin(); return null; }
        if (r.status !== 200 && r.status !== 202) {
          throw new Error('bf ' + r.status);
        }
        return r.json();
      })
      .then(function (j) {
        if (!j) return;
        if (j.status === 'done' && j.url) { commit(j); return; }
        var id = j.job || j.id;
        if (id) { poll(id); return; }
        fin();
      })
      .catch(fin);
  }

  var A8_HKEY = 'agcf:finhist:v1';
  var A8_HCAP = 10;

  var A8_HICO = '<svg class="agcf8-hist-ico" viewBox="0 0 256 256"'
    + ' fill="none" stroke="currentColor" stroke-width="16"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M128 78v50l36 22"/>'
    + '<path d="M62 62A93 93 0 1 0 128 35"/>'
    + '<path d="M62 20v42h42"/></svg>';

  var A8_FAM_ICO = '<svg class="agcf8-selico" viewBox="0 0 256 256"'
    + ' fill="currentColor" aria-hidden="true"><path d="M88,180a12,12,0'
    + ',1,1-12-12A12,12,0,0,1,88,180Zm152-23.81V208a16,16,0,0,1-16,16H7'
    + '6a46.36,46.36,0,0,1-7.94-.68,44,44,0,0,1-35.43-50.95l25-143.13a1'
    + '5.94,15.94,0,0,1,18.47-13L130.84,26a16,16,0,0,1,12.92,18.52l-12.'
    + '08,69L199.49,89a16,16,0,0,1,20.45,9.52L239,150.69A18.35,18.35,0,'
    + '0,1,240,156.19ZM103,184.87,128,41.74,73.46,32l-25,143.1A28,28,0,'
    + '0,0,70.9,207.57,27.29,27.29,0,0,0,91.46,203,27.84,27.84,0,0,0,10'
    + '3,184.87ZM116.78,195,224,156.11,204.92,104,128.5,131.7l-9.78,55.'
    + '92A44.63,44.63,0,0,1,116.78,195ZM224,173.12,127.74,208H224Z"/>'
    + '</svg>';
  var A8_TONE_ICO = '<svg class="agcf8-selico" viewBox="0 0 256 256"'
    + ' fill="currentColor" aria-hidden="true"><path d="M128,24A104,104'
    + ',0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm8,16.37a86.4,86.4,0,0'
    + ',1,16,3V212.67a86.4,86.4,0,0,1-16,3Zm32,9.26a87.81,87.81,0,0,1,1'
    + '6,10.54V195.83a87.81,87.81,0,0,1-16,10.54ZM40,128a88.11,88.11,0,'
    + '0,1,80-87.63V215.63A88.11,88.11,0,0,1,40,128Zm160,50.54V77.46a87'
    + '.82,87.82,0,0,1,0,101.08Z"/></svg>';
  var A8_RE_ICO = '<svg class="agcf8-pick-ico" viewBox="0 0 256 256"'
    + ' fill="currentColor" aria-hidden="true"><path d="M224,128a96,96,'
    + '0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.'
    + '63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,'
    + '8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96'
    + ',96,0,0,1,224,128Z"/></svg>';
  function a8HistLoad() {

    var h = null;
    try { h = JSON.parse(localStorage.getItem(A8_HKEY)); } catch (e) {}
    if (!h || h.v !== 1 || !Array.isArray(h.entries)) {
      return { v: 1, entries: [] };
    }
    var out = [];
    for (var i = 0; i < h.entries.length && out.length < A8_HCAP; i++) {
      var e = h.entries[i];
      if (!e || typeof e !== 'object') continue;
      if (typeof e.p !== 'string' || !e.p) continue;
      if (e.a !== null && e.a !== undefined && typeof e.a !== 'string') continue;
      out.push({ p: e.p, a: e.a || null,
                 ts: typeof e.ts === 'number' ? e.ts : 0,
                 product: typeof e.product === 'string' ? e.product : '',
                 ph: typeof e.ph === 'string' ? e.ph : '' });
    }
    return { v: 1, entries: out };
  }
  function a8HistSave(h) {
    try { localStorage.setItem(A8_HKEY, JSON.stringify(h)); }
    catch (e) {

      try {
        h.entries.pop();
        localStorage.setItem(A8_HKEY, JSON.stringify(h));
      } catch (e2) {}
    }
  }
  function a8HistKey(p, a) { return p + '__' + (a || 'none'); }
  function a8HistPut(p, a, product) {
    try {
      if (!p) return;
      var h = a8HistLoad();
      var k = a8HistKey(p, a);
      h.entries = [{ p: p, a: a || null, ts: Date.now(),
                     product: product || '', ph: a8Handle() || '' }]
        .concat(h.entries.filter(function (e) {
          return a8HistKey(e.p, e.a) !== k;
        }));
      while (h.entries.length > A8_HCAP) h.entries.pop();
      a8HistSave(h);
      a8HistSync();
    } catch (e) {}
  }
  function a8ProductName() {
    var h = document.querySelector('.product-header h1')
      || document.querySelector('h1');
    return h ? (h.textContent || '').trim() : '';
  }
  function a8HistSync() {

    if (!A8.hist) return;
    var es = a8HistLoad().entries;
    var n = 0;
    for (var i = 0; i < es.length; i++) {

      if (!BY_CODE[es[i].p]) continue;
      if (es[i].a && !BY_CODE[es[i].a]) continue;
      n++;
    }
    A8.hist.classList.toggle('is-empty', n === 0);
  }
  function a8HistPanel() {
    if (A8.histPanel) return A8.histPanel;

    var p = document.createElement('div');
    p.className = 'agcf8-hist-panel';
    p.setAttribute('data-agcf8-hist-panel', '');
    p.setAttribute('data-agcf-orphan', '');
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-label', 'Finish history');
    (st && st.root ? st.root : document.body).appendChild(p);
    p.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('[data-agcf8-hist-x]') : null;
      if (x) { a8HistClose(true); return; }
      var b = e.target.closest
        ? e.target.closest('[data-agcf8-hist-item]') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var pc = b.getAttribute('data-p');
      var ac = b.getAttribute('data-a');
      a8HistClose();
      a8ApplyPair(pc, ac || null);
    });
    A8.histPanel = p;
    return p;
  }
  function a8HistRender(p) {
    var h = a8HistLoad();
    var rows = '';
    for (var i = 0; i < h.entries.length; i++) {
      var e = h.entries[i];

      var pf = BY_CODE[e.p];

      if (!pf) continue;
      var af = e.a ? BY_CODE[e.a] : null;
      if (e.a && !af) continue;

      rows += '<button type="button" class="agcf8-hist-item"'
        + ' data-agcf8-hist-item data-p="' + esc(e.p) + '"'
        + ' data-a="' + esc(e.a || '') + '">'
        + '<span class="agcf8-hist-thumbs">'
        + '<img class="agcf8-hist-thumb'
        + (af ? '' : ' agcf8-hist-thumb--wide') + '" src="'
        + esc(cdn(pf.image, 240)) + '" alt="" decoding="async">'
        + (af ? '<img class="agcf8-hist-thumb" src="'
                + esc(cdn(af.image, 240))
                + '" alt="" decoding="async">' : '')
        + '</span><span class="agcf8-hist-lines">'
        + '<span class="agcf8-hist-names">'
        + esc(pf.name + (af ? ' & ' + af.name : '')) + '</span>'
        + '<span class="agcf8-hist-product">' + esc(e.product || '')
        + '</span></span></button>';
    }

    p.innerHTML = '<div class="agcf8-hist-head">'
      + '<span class="agcf8-hist-title">Finish history</span>'
      + '<button type="button" class="agcf8-hist-x"'
      + ' data-agcf8-hist-x aria-label="' + esc(COPY.dialog.close) + '">'
      + '<svg class="agcf-x" viewBox="0 0 256 256" fill="currentColor"'
      + ' aria-hidden="true"><path d="' + P_X + '"/></svg></button>'
      + '</div>' + rows;
  }
  function a8HistPlace() {

    var p = A8.histPanel;
    var btn = A8.hist ? A8.hist.querySelector('.agcf8-hist-btn') : null;
    if (!p || !btn) return;
    var r = btn.getBoundingClientRect();
    var vw = window.innerWidth;
    p.style.left = Math.round(
      Math.min(Math.max(r.right - 320, 8), Math.max(8, vw - 328))) + 'px';
    p.style.top = Math.round(r.bottom + 6) + 'px';
  }
  function a8HistOpen() {

    if (drawerIsOpen() || pickerOpen()) return;

    if (document.querySelector('.agcf-pop5.is-show')) closePop(false);
    var wrap = A8.hist;
    if (!wrap) return;
    var btn = wrap.querySelector('.agcf8-hist-btn');
    var p = a8HistPanel();
    a8HistRender(p);

    if (isMobile()) void p.offsetHeight;
    p.classList.add('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (isMobile()) {

      p.style.left = '';
      p.style.top = '';
      a8Scrim('hist', true);
      a8Lock('hist', true);
    } else if (btn) {
      a8HistPlace();

      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (A8.histOn && !isMobile()) a8HistPlace();
          });
        });
      }
    }
    A8.histOn = true;
    A8.histAt = Date.now();
  }
  function a8Lock(owner, on) {

    if (!A8.lockOwners) A8.lockOwners = {};
    if (on) {
      if (!Object.keys(A8.lockOwners).length) {
        A8.bodyLock = document.body.style.overflow || ' ';
        // Compensate for the scrollbar width disappearing under overflow:hidden so the
        // page doesn't reflow wider behind the lock (measured live).
        var a8ScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (a8ScrollbarWidth > 0) document.body.style.paddingRight = a8ScrollbarWidth + 'px';
      }
      A8.lockOwners[owner] = true;
      document.body.style.overflow = 'hidden';
    } else {
      delete A8.lockOwners[owner];
      if (!Object.keys(A8.lockOwners).length && A8.bodyLock !== null) {
        document.body.style.overflow =
          (A8.bodyLock === ' ' || A8.bodyLock === 'hidden')
            ? '' : A8.bodyLock;
        document.body.style.paddingRight = '';
        A8.bodyLock = null;
      }
    }
  }
  function a8LiveDismiss() {

    var lb = document.querySelector('.ag-finish-sheet-backdrop');
    if (!lb) return;
    var lx = lb.querySelector('.ag-finish-sheet-close');
    if (lx) lx.click();
  }
  function a8HistClose(restoreFocus) {
    var p = A8.histPanel;
    if (p) p.classList.remove('is-open');
    a8Scrim('hist', false);
    a8Lock('hist', false);
    var btn = A8.hist ? A8.hist.querySelector('.agcf8-hist-btn') : null;
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      if (restoreFocus && btn.focus) {
        try { btn.focus({preventScroll: true}); } catch (err) { btn.focus(); }
      }
    }
    A8.histOn = false;
  }
  function a8HistToggle() {
    if (A8.histOn) a8HistClose(true); else a8HistOpen();
  }
  function a8HistMount() {

    var tone = document.querySelector('[data-agcf-r6] .agcf-tone');
    if (!tone || A8.hist) return;
    var wrap = document.createElement('span');
    wrap.className = 'agcf8-hist is-empty';
    wrap.setAttribute('data-agcf8-hist', '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'agcf8-hist-btn';
    btn.setAttribute('data-agcf8-hist-btn', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Finish history');

    btn.innerHTML = A8_HICO
      + '<span class="agcf8-hist-lbl">History</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      a8HistToggle();
    });
    wrap.appendChild(btn);
    tone.insertAdjacentElement('afterend', wrap);
    A8.hist = wrap;
    a8HistSync();
  }

  function a8SelWrap(sel, ico) {

    if (!sel || sel.closest('.agcf8-selwrap')) return;
    var wrap = document.createElement('span');
    wrap.className = 'agcf8-selwrap';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    wrap.insertAdjacentHTML('beforeend', ico);
    var sync = function () {
      wrap.classList.toggle('is-on', !!sel.value);
    };
    sel.addEventListener('change', sync);
    sync();
  }
  function a8FamIcons() {
    var band = document.querySelector('[data-agcf-r6]');
    if (!band) return;
    a8SelWrap(band.querySelector('.agcf-fam:not(.agcf-tone)'), A8_FAM_ICO);
    a8SelWrap(band.querySelector('.agcf-tone'), A8_TONE_ICO);
  }

  /* PANTONE round, stage 1 (Ansen 2026-10-16, canvas Rhdad4Si46FgBNB738PiP7 boards 11A + 11P): Clear sits right of
     the search bar; History, Type and Tone carry words; desktop stacks Type + Tone under History beside the
     swatches, phones put History | Type | Tone in one row under Search | Clear. Options-card PDP only. The rules
     are in theme-test/pantone-finishes/src/pf.css (embedded below by patch_pf.py). */
  var A8PF_CSS = ".ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-controls{margin-bottom:0;padding-right:0;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-rail{margin:0 !important;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell{position:static;display:inline-flex !important;flex-direction:row;align-items:center;justify-content:center;gap:6px;flex:0 0 auto !important;width:auto !important;height:36px;margin:0 !important;padding:0 12px !important;box-sizing:border-box;border:1px solid #e0e0e0;background:#fff;color:#8a8f8b;box-shadow:none;cursor:pointer;transition:border-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell::after{display:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell:hover{border-color:#242B26;color:#242B26;}.ag-optcard [data-agcf-r6].is-agcf-custom .agcf-band .agcf-band-box.is-pf .agcf8-clearcell{border-color:#242B26;color:#242B26;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell-img{width:14px !important;height:14px !important;margin:0 !important;border:0;background:none;color:inherit;display:flex;align-items:center;justify-content:center;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell-img svg{width:14px;height:14px;display:block;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell-name{font-family:'Alata',sans-serif;font-size:11px;letter-spacing:.8px;text-transform:uppercase;color:inherit;max-width:none;line-height:1;white-space:nowrap;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap{display:flex;align-items:center;justify-content:center;gap:6px;flex:0 0 auto;min-width:0;height:36px;padding:0 8px;box-sizing:border-box;position:relative;border:1px solid #e0e0e0;background:#fff;color:#242B26;cursor:pointer;transition:border-color .2s cubic-bezier(.4,0,.2,1);}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap:hover{border-color:#242B26;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap .agcf-fam{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;width:100% !important;min-width:0 !important;height:100%;margin:0;padding:0;border:0;opacity:0;color:#242B26;background:transparent;cursor:pointer;color-scheme:light;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap .agcf-fam option{color:#242B26;background:#ffffff;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selico{display:block;position:static;margin:0;width:15px;height:15px;flex:0 0 auto;pointer-events:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-word{font-family:'Alata',sans-serif;font-size:11px;letter-spacing:.8px;text-transform:uppercase;line-height:1;white-space:nowrap;pointer-events:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-caret{width:10px;height:10px;flex:0 0 auto;display:block;pointer-events:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap.is-on{background:#242B26;border-color:#242B26;color:#fff;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap.is-on .agcf-fam{background:transparent;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-selwrap:focus-within{outline:1px solid #465849;outline-offset:2px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-hist-btn{width:100%;height:36px;justify-content:center;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-hist-lbl{display:inline;}@media (min-width:769px){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf{display:grid;grid-template-columns:84px minmax(0,1fr) auto;grid-template-rows:auto auto auto 1fr auto;column-gap:10px;row-gap:8px;grid-template-areas:\"hist search clear\" \"type rail rail\" \"tone rail rail\" \". rail rail\" \". none none\";}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-controls,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-filters{display:contents;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-search{grid-area:search;min-width:0;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf8-clearcell{grid-area:clear;}.ag-optcard .agcf-band .agcf-band-box.is-pf [data-agcf8-hist]{grid-area:hist;order:0;width:auto;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-type{grid-area:type;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-tone{grid-area:tone;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-rail{grid-area:rail;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-none{grid-area:none;}}@media (max-width:768px){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf{display:flex;flex-direction:column;gap:8px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-controls{display:flex;flex-wrap:nowrap;gap:8px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-search{flex:1 1 auto;min-width:0;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-filters{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;}.ag-optcard .agcf-band .agcf-band-box.is-pf [data-agcf8-hist]{order:0;width:auto;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-rail{grid-template-columns:repeat(4,minmax(0,1fr)) !important;}}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line{display:flex;flex-direction:column;justify-content:space-between;width:100%;margin:0;padding:0;border:0;background:transparent;color:#3d443f;font-family:'Alata',sans-serif;font-size:11px;letter-spacing:.4px;text-align:left;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door{position:relative;display:flex;align-items:center;gap:8px;min-height:44px;padding:6px 6px 6px 8px;box-sizing:border-box;border:1px solid #242B26;cursor:pointer;background:linear-gradient(90deg,rgba(238,36,51,.10),rgba(251,197,5,.12) 36%,rgba(17,116,60,.09) 68%,rgba(32,66,108,.11));}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door:hover .agcf-pf-line-t{color:#242B26;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dots{position:relative;display:block;width:54px;height:12px;flex:0 0 auto;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dots i{position:absolute;top:0;left:50%;width:12px;height:12px;margin-left:-6px;transform:translateX(var(--r));transition:transform .3s ease;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dots b{display:block;width:100%;height:100%;border-radius:50%;box-shadow:0 0 0 1.5px #fff;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t{flex:1 1 auto;min-width:0;font-size:11px;letter-spacing:0;line-height:1.35;text-wrap:balance;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t em{font-style:normal;color:#242B26;white-space:nowrap;border-bottom:1px solid rgba(36,43,38,.35);}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-infow{display:inline-flex;vertical-align:middle;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-infow .agcf-pf-info{width:24px;height:24px;margin:-6px -4px -6px -2px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-infow .agcf-pf-info svg{width:14px;height:14px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-tip{width:min(244px,calc(100vw - 40px));cursor:default;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line svg,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back svg{width:12px;height:12px;flex:0 0 auto;display:block;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-go{display:flex;align-items:center;gap:6px;flex:0 0 auto;height:30px;margin:0;padding:0 10px 0 12px;border:0;border-radius:0;background:#242B26;color:#fff;font-family:'Alata',sans-serif;font-size:10.5px;letter-spacing:.9px;text-transform:uppercase;cursor:pointer;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-go svg{width:11px;height:11px;transition:transform .22s ease;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-go:focus-visible{outline:2px solid #465849;outline-offset:2px;}@media (max-width:768px){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door{gap:6px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-go{padding:0 8px 0 10px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-infow{position:static;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line-t .agcf-pf-tip{left:0;right:auto;top:calc(100% + 2px);}}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-shine{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;pointer-events:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-shine::after{content:\"\";position:absolute;top:0;bottom:0;left:-40%;width:35%;opacity:0;background:linear-gradient(100deg,rgba(255,255,255,0),rgba(255,255,255,.8),rgba(255,255,255,0));}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-label{display:flex;align-items:center;gap:8px;margin:10px 0 0;font-family:'Alata',sans-serif;font-size:10px;line-height:1.4;letter-spacing:1.1px;text-transform:uppercase;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-label::after{content:\"\";flex:1 1 auto;height:1px;background:#e6e7e6;}@media (hover:hover){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door:hover .agcf-pf-dots i{transform:translateX(var(--s));}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door:hover .agcf-pf-go svg{transform:translateX(3px);}}@keyframes agcfPfFan{0%,100%{transform:translateX(var(--r));}25%,75%{transform:translateX(var(--s));}}@keyframes agcfPfSheen{0%{opacity:1;transform:translateX(0);}100%{opacity:1;transform:translateX(430%);}}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door.is-hello .agcf-pf-dots i{animation:agcfPfFan 1.6s ease-in-out 1;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door.is-hello .agcf-pf-shine::after{animation:agcfPfSheen 1s ease-out .3s 1;}@media (prefers-reduced-motion:reduce){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door.is-hello .agcf-pf-dots i,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-door.is-hello .agcf-pf-shine::after{animation:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dots i,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-go svg{transition:none;}}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back{display:none;align-items:center;justify-content:space-between;min-height:34px;border-bottom:1px solid #e6e7e6;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back button{display:flex;align-items:center;gap:4px;margin:0;padding:0;border:0;background:none;color:#242B26;font-family:'Alata',sans-serif;font-size:11px;letter-spacing:.8px;text-transform:uppercase;cursor:pointer;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back span{font-family:'Alata',sans-serif;font-size:11px;letter-spacing:.8px;text-transform:uppercase;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back .agcf-pf-back-r{display:flex;align-items:center;gap:2px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow{position:relative;display:flex;flex:0 0 auto;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-info{display:flex;align-items:center;justify-content:center;width:30px;height:30px;margin:0;padding:0;border:0;background:transparent;color:#6b6b6b;cursor:pointer;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-info svg{width:15px;height:15px;flex:0 0 auto;display:block;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-info:hover,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow.is-open .agcf-pf-infow .agcf-pf-info{color:#242B26;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-info:focus-visible{outline:1px solid #465849;outline-offset:-3px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-tip{display:none;position:absolute;top:calc(100% + 2px);right:0;z-index:30;width:244px;padding:9px 11px;box-sizing:border-box;background:#fff;border:1px solid #e0e0e0;box-shadow:0 6px 18px rgba(36,43,38,.12);font-family:'Alata',sans-serif;font-size:10.5px;line-height:1.55;letter-spacing:.2px;text-transform:none;color:#3d443f;text-align:left;white-space:normal;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow .agcf-pf-info:focus-visible+.agcf-pf-tip,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow.is-open .agcf-pf-tip{display:block;}@media (hover:hover){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-infow:hover .agcf-pf-tip{display:block;}}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-pms{display:none;position:relative;min-width:0;max-height:344px;overflow-x:hidden;overflow-y:auto;padding:0 2px 8px;-webkit-mask-image:linear-gradient(to bottom,#000 calc(100% - 32px),transparent);mask-image:linear-gradient(to bottom,#000 calc(100% - 32px),transparent);scrollbar-width:thin;scrollbar-color:rgba(36,43,38,.25) transparent;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-grp{padding-bottom:14px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-grp-h{display:flex;justify-content:space-between;align-items:baseline;margin:0 0 8px;padding-top:4px;font-family:'Playfair Display',serif;font-weight:400;font-size:17px;line-height:1.2;color:#242B26;letter-spacing:0;text-transform:none;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-grp-h span{font-family:'Alata',sans-serif;font-size:10px;letter-spacing:.8px;text-transform:uppercase;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-shade{margin:0 0 10px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-shade-h{margin:0 0 6px;font-family:'Alata',sans-serif;font-size:10px;letter-spacing:1px;text-transform:uppercase;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));column-gap:8px;row-gap:12px;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-chip{display:block;border:1px solid rgba(0,0,0,.12);}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-note{margin:4px 0 36px;font-family:'Alata',sans-serif;font-size:10px;line-height:1.5;letter-spacing:.2px;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-nomatch{display:none;margin:18px 0;font-family:'Alata',sans-serif;font-size:11px;color:#6b6b6b;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-pms.is-empty .agcf-pf-nomatch{display:block;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-shade-h .agcf-pf-temp{display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;vertical-align:0;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-temp.is-warm{background:#d9894a;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-temp.is-cool{background:#6f8fb3;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-hexhits .agcf-pf-hexh{justify-content:flex-start;gap:8px;align-items:center;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-hexhits .agcf-pf-hexh .agcf-pf-hexdot{display:inline-block;width:16px;height:16px;flex:0 0 auto;border:1px solid rgba(0,0,0,.15);}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-groups{display:none;flex-direction:column;gap:1px;padding-top:6px;border-top:1px solid #e6e7e6;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-gbtn{display:flex;align-items:center;gap:7px;height:27px;margin:0;padding:0 6px;border:0;border-left:2px solid transparent;background:transparent;color:#242B26;font-family:'Alata',sans-serif;font-size:10.5px;letter-spacing:.5px;text-transform:uppercase;text-align:left;cursor:pointer;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-gbtn.is-on{border-left-color:#242B26;background:#fff;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-gbtn i,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dot i{display:block;border-radius:50%;border:1px solid rgba(0,0,0,.12);box-sizing:border-box;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-gbtn i{width:12px;height:12px;flex:0 0 auto;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dotbar{display:none;position:sticky;top:0;z-index:4;justify-content:space-between;gap:2px;margin:0 0 4px;padding:4px 0 8px;background:#f9fafb;border-bottom:1px solid #e6e7e6;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dot{display:flex;align-items:center;justify-content:center;width:30px;height:30px;margin:0;padding:0;border:2px solid transparent;border-radius:50%;background:#fff;box-sizing:border-box;cursor:pointer;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dot.is-on{border-color:#242B26;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-dot i{width:20px;height:20px;}.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-pf-line,.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-rail,.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-none{display:none !important;}.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-pf-back{display:flex;}.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-pf-pms{display:block;}@media (min-width:769px){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf{grid-template-rows:auto auto auto 1fr auto;grid-template-areas:\"hist search clear\" \"type line line\" \"tone rail rail\" \"list rail rail\" \". none none\";}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-line,.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-back{grid-area:line;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-groups{grid-area:list;align-self:start;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-pms{grid-area:rail;}.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-pf-groups{display:flex;}.ag-optcard .agcf-band .agcf-band-box.is-pf:not(.is-pms) .agcf-pf{grid-template-areas:\"hist search clear\" \"type line line\" \"tone line line\" \"list rail rail\" \". none none\";}}@media (max-width:768px){.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-groups{display:none !important;}.ag-optcard .agcf-band .agcf-band-box.is-pf.is-pms .agcf-pf-dotbar{display:flex;}.ag-optcard .agcf-band .agcf-band-box.is-pf .agcf-pf-grid{grid-template-columns:repeat(4,minmax(0,1fr));}}";
  var A8PF_CARET = '<svg class="agcf-pf-caret" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">'
    + '<path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69'
    + 'l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>';
  function a8PfBox() {
    var box = document.querySelector('[data-agcf-r6] .agcf-band-box');
    return box && box.closest && box.closest('.ag-optcard') ? box : null;
  }
  function a8PfWord(wrap, word, cls) {
    if (!wrap) return;
    wrap.classList.add(cls);
    if (wrap.querySelector('.agcf-pf-word')) return;
    wrap.insertAdjacentHTML('beforeend',
      '<span class="agcf-pf-word" aria-hidden="true">' + word + '</span>' + A8PF_CARET);
  }
  function a8PfLayout() {
    var box = a8PfBox();
    if (!box) return;
    var ctrls = box.querySelector('.agcf-controls');
    var rail = box.querySelector('.agcf-rail');
    if (!ctrls || !rail) return;
    if (!document.getElementById('agcf-pf-css')) {
      var s = document.createElement('style');
      s.id = 'agcf-pf-css';
      s.textContent = A8PF_CSS;
      document.head.appendChild(s);
    }
    var pf = box.querySelector('.agcf-pf');
    if (!pf) {
      pf = document.createElement('div');
      pf.className = 'agcf-pf';
      box.insertBefore(pf, ctrls);
      pf.appendChild(ctrls);
      var fl0 = document.createElement('div');
      fl0.className = 'agcf-pf-filters';
      pf.appendChild(fl0);
      pf.appendChild(rail);
      var none = box.querySelector('.agcf-none');
      if (none) pf.appendChild(none);
      box.classList.add('is-pf');
    }
    var fl = pf.querySelector('.agcf-pf-filters');
    var hist = box.querySelector('[data-agcf8-hist]');
    var fam = box.querySelector('.agcf-fam:not(.agcf-tone)');
    var tone = box.querySelector('.agcf-tone');
    var tw = fam && fam.closest('.agcf8-selwrap');
    var nw = tone && tone.closest('.agcf8-selwrap');
    a8PfWord(tw, 'Type', 'agcf-pf-type');
    a8PfWord(nw, 'Tone', 'agcf-pf-tone');
    [hist, tw, nw].forEach(function (el) {
      if (el && el.parentNode !== fl) fl.appendChild(el);
    });
    var cell = box.querySelector('[data-agcf8-clear]');
    var search = ctrls.querySelector('.agcf-search');
    if (cell && cell.parentNode !== ctrls) {
      if (search && search.parentNode === ctrls) search.insertAdjacentElement('afterend', cell);
      else ctrls.appendChild(cell);
    }
    a8PmsMount(box, pf, fl);
  }
  /* PANTONE round, stage 2 (Ansen 2026-10-16, canvas Rhdad4Si46FgBNB738PiP7 boards 9B, 11A, 11P/4F): the 1,122
     PANTONE Solid Coated colors as their own kind of finish. One quiet line above our swatches opens them, and
     so does PANTONE in the Type list; Type stays and turns dark while they are open (2c). Desktop lists the 10
     color groups down the left column under Tone, phones get a sticky row of color dots.
     A PANTONE color is picked as main or accent like any finish. assets/agcf-pantone.json loads
     only when PANTONE is first opened, and the groups render as the shopper scrolls. */
  var A8PMS_V = 'pms2';
  var A8PMS_GROUPS = [['R', 'Reds', '#c42a33'], ['K', 'Pinks', '#e986a8'], ['O', 'Oranges', '#ef7d22'],
    ['Y', 'Yellows', '#f7c600'], ['G', 'Greens', '#3f9a48'], ['T', 'Teals', '#0f8f8b'], ['B', 'Blues', '#245aa8'],
    ['P', 'Purples', '#6b3fa0'], ['N', 'Browns', '#7a4a2a'], ['A', 'Grays', '#8c8c8c']];
  var A8PMS_SHADE = { L: 'Light', M: 'Medium', D: 'Dark' };
  var A8PMS_ST = { on: false, rows: null, loading: null, upto: 0, active: 'R', ph: '', sig: '' };
  var A8PMS_CL = '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M165.66,202.34a8,8,0,0,'
    + '1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>';
  var A8PMS_CR = '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M181.66,133.66l-80,80a8,'
    + '8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>';
  /* 2d (Ansen 2026-10-17): the PANTONE notice behind a small "i" at the end of the quiet line and the back line;
     hover, keyboard focus or a tap shows it */
  var A8PMS_INFO = '<span class="agcf-pf-infow"><button type="button" class="agcf-pf-info" data-agcf-pf-info'
    + ' aria-label="About PANTONE colors" aria-expanded="false">'
    + '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M128,24A104,104,0,1,0,232,128,'
    + '104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,'
    + '1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,'
    + '84Z"/></svg></button><span class="agcf-pf-tip" role="tooltip">PANTONE&reg; colors on screen are a guide'
    + ' only.<br>PANTONE&reg; is a registered trademark of Pantone LLC.<br>Arc Grove is not affiliated with or'
    + ' endorsed by Pantone LLC.</span></span>';
  function a8PmsUrl() {
    var s = document.querySelector('script[src*="/agcf.js"]');
    var src = s ? (s.getAttribute('src') || '') : '';
    return src ? src.replace(/agcf\.js(\?[^#]*)?$/, 'agcf-pantone.json?v=' + A8PMS_V) : '';
  }
  function a8PmsLoad() {
    if (A8PMS_ST.rows) return Promise.resolve(A8PMS_ST.rows);
    if (A8PMS_ST.loading) return A8PMS_ST.loading;
    var url = a8PmsUrl();
    if (!url || !window.fetch) return Promise.resolve([]);
    A8PMS_ST.loading = fetch(url).then(function (r) { return r.ok ? r.json() : []; }).then(function (rows) {
      A8PMS_ST.rows = (rows || []).map(function (r) {
        var f = a8PmsFin('PMS-' + String(r[0]).replace(/ /g, '_') + '-' + String(r[1]).toUpperCase(),
          A8PMS_SHADE[r[3]] || '', r[2]);
        if (f && !f.temp) f.temp = r[4] === 'C' ? 'Cool' : 'Warm';
        return f;
      }).filter(Boolean);
      return A8PMS_ST.rows;
    }, function () { A8PMS_ST.loading = null; return []; });
    return A8PMS_ST.loading;
  }
  function a8PmsTile(f) {
    return '<button type="button" class="agcf-sw agcf-pf-sw" data-agcf-sw'
      + ' data-code="' + esc(f.code) + '" data-name="' + esc(f.name) + '"'
      + ' data-family="PANTONE" data-gloss="1" data-tone="' + esc(f.tone || '') + '"'
      + ' data-temp="' + esc(f.temp || '') + '"'
      + ' aria-label="' + esc(f.name) + '">'
      + '<span class="agcf-sw-img agcf-pf-chip" style="background:' + esc(f.hex) + '"></span>'
      + '<span class="agcf-sw-role" aria-hidden="true"></span>'
      + '<span class="agcf-sw-name">' + esc(f.num) + '</span>'
      + '<span class="agcf-sw-code">' + esc(String(f.hex || '').toUpperCase()) + '</span></button>';
  }
  function a8PmsRender(upto) {
    var box = a8PfBox();
    var wrap = box && box.querySelector('.agcf-pf-pms-list');
    if (!wrap || !A8PMS_ST.rows) return;
    var want = Math.min(A8PMS_GROUPS.length, upto);
    if (want <= A8PMS_ST.upto) return;
    var html = '';
    for (var gi = A8PMS_ST.upto; gi < want; gi++) {
      var g = A8PMS_GROUPS[gi];
      var items = A8PMS_ST.rows.filter(function (f) { return f.group === g[0]; });
      html += '<section class="agcf-pf-grp" data-agcf-pf-grp="' + g[0] + '">'
        + '<h4 class="agcf-pf-grp-h">PANTONE ' + g[1] + '<span>' + items.length + ' colors</span></h4>';
      ['L', 'M', 'D'].forEach(function (t) {
        ['Warm', 'Cool'].forEach(function (w) {   /* 2f (5A): each shade split into a warm row, then a cool row */
          var sub = items.filter(function (f) { return f.tone === A8PMS_SHADE[t] && (f.temp || 'Warm') === w; });
          if (!sub.length) return;
          html += '<div class="agcf-pf-shade"><p class="agcf-pf-shade-h"><i class="agcf-pf-temp is-' + w.toLowerCase()
            + '" aria-hidden="true"></i>' + A8PMS_SHADE[t] + ' ' + g[1].toLowerCase() + ' &middot; ' + w.toLowerCase()
            + '</p><div class="agcf-pf-grid">' + sub.map(a8PmsTile).join('') + '</div></div>';
        });
      });
      html += '</section>';
    }
    wrap.insertAdjacentHTML('beforeend', html);
    A8PMS_ST.upto = want;
    updateTiles();
  }
  function a8PmsLab(h) {   /* 2f: sRGB hex (6 digits) -> CIE Lab, for the closest-color search */
    var v = [0, 2, 4].map(function (i) {
      var c = parseInt(h.substr(i, 2), 16) / 255;
      return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    });
    var X = (v[0] * 0.4124 + v[1] * 0.3576 + v[2] * 0.1805) / 0.95047, Y = v[0] * 0.2126 + v[1] * 0.7152 + v[2] * 0.0722,
      Z = (v[0] * 0.0193 + v[1] * 0.1192 + v[2] * 0.9505) / 1.08883;
    var t = function (x) { return x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116; };
    return [116 * t(Y) - 16, 500 * (t(X) - t(Y)), 200 * (t(Y) - t(Z))];
  }
  function a8PmsFilter() {
    var box = a8PfBox();
    var list = box && box.querySelector('.agcf-pf-pms');
    if (!list) return;
    var input = box.querySelector('.agcf-search input');
    var tone = box.querySelector('.agcf-tone');
    var qv = ((input && input.value) || '').toLowerCase().replace(/pantone/g, '').replace(/\s+/g, '');
    var tv = tone ? tone.value : '';
    var tKey = (tv === 'Warm' || tv === 'Cool') ? 'data-temp' : 'data-tone';
    var old = list.querySelector('.agcf-pf-hexhits');
    if (old) old.parentNode.removeChild(old);
    var hx = /^#?([0-9a-f]{6})$/i.exec(((input && input.value) || '').trim());
    if (hx && A8PMS_ST.rows) {   /* 2f (3A): a hex shows the exact match or the 8 closest PANTONE colors */
      var want = a8PmsLab(hx[1]);
      var scored = A8PMS_ST.rows.filter(function (f) {
        return !tv || (tKey === 'data-temp' ? f.temp === tv : f.tone === tv);
      }).map(function (f) {
        var l = a8PmsLab(String(f.hex).replace('#', ''));
        return { f: f, d: Math.sqrt(Math.pow(l[0] - want[0], 2) + Math.pow(l[1] - want[1], 2) + Math.pow(l[2] - want[2], 2)) };
      }).sort(function (a, b) { return a.d - b.d; }).slice(0, 8);
      var exact = scored.length && scored[0].d < 1;
      var head = (exact ? 'Exact match for #' : 'Closest to #') + hx[1].toUpperCase();
      var hl = list.querySelector('.agcf-pf-pms-list');
      if (hl) {
        hl.insertAdjacentHTML('beforebegin', '<section class="agcf-pf-grp agcf-pf-hexhits" aria-label="' + head + '">'
          + '<h4 class="agcf-pf-grp-h agcf-pf-hexh"><span class="agcf-pf-hexdot" style="background:#' + hx[1] + '"></span>'
          + head + '</h4><div class="agcf-pf-grid">' + scored.map(function (s) { return a8PmsTile(s.f); }).join('')
          + '</div></section>');
        hl.querySelectorAll('.agcf-pf-grp').forEach(function (g) { g.style.display = 'none'; });
      }
      list.classList.toggle('is-empty', !scored.length);
      updateTiles();
      if (A8PMS_ST.sig !== 'hex|' + hx[1] + '|' + tv) { A8PMS_ST.sig = 'hex|' + hx[1] + '|' + tv; list.scrollTop = 0; }
      return;
    }
    if ((qv || tv) && A8PMS_ST.upto < A8PMS_GROUPS.length) a8PmsRender(A8PMS_GROUPS.length);
    var shown = 0;
    list.querySelectorAll('.agcf-pf-grp').forEach(function (g) {
      var gn = 0;
      g.querySelectorAll('.agcf-pf-shade').forEach(function (sh) {
        var n = 0;
        sh.querySelectorAll('[data-agcf-sw]').forEach(function (b) {
          var hit = (!tv || b.getAttribute(tKey) === tv) && (!qv
            || b.getAttribute('data-name').toLowerCase().replace(/pantone/g, '').replace(/\s+/g, '').indexOf(qv) > -1);
          b.style.display = hit ? '' : 'none';
          if (hit) n += 1;
        });
        sh.style.display = n ? '' : 'none';
        gn += n;
      });
      g.style.display = gn ? '' : 'none';
      shown += gn;
    });
    list.classList.toggle('is-empty', !!A8PMS_ST.rows && shown === 0);
    var sig = qv + '|' + tv;
    if (sig !== A8PMS_ST.sig) {   /* a new search or tone: start at the top, light up the first group shown */
      A8PMS_ST.sig = sig;
      if (qv || tv) {
        list.scrollTop = 0;
        var fv = list.querySelector('.agcf-pf-grp:not([style*="none"])');
        if (fv) { A8PMS_ST.active = fv.getAttribute('data-agcf-pf-grp'); a8PmsSync(); }
      }
    }
  }
  function a8PmsSync() {
    var box = a8PfBox();
    if (!box) return;
    box.querySelectorAll('[data-agcf-pf-go]').forEach(function (b) {
      b.classList.toggle('is-on', A8PMS_ST.on && b.getAttribute('data-agcf-pf-go') === A8PMS_ST.active);
    });
  }
  function a8PmsScroll(list) {
    if (list.scrollTop + list.clientHeight > list.scrollHeight - 240 && A8PMS_ST.upto < A8PMS_GROUPS.length) {
      a8PmsRender(A8PMS_ST.upto + 2);
      a8PmsFilter();
    }
    var bar = list.querySelector('.agcf-pf-dotbar');
    var off = (bar && bar.offsetHeight ? bar.offsetHeight : 0) + 12;
    var cur = A8PMS_ST.active;
    list.querySelectorAll('.agcf-pf-grp').forEach(function (g) {
      if (g.style.display !== 'none' && g.offsetTop - off <= list.scrollTop) cur = g.getAttribute('data-agcf-pf-grp');
    });
    if (cur !== A8PMS_ST.active) { A8PMS_ST.active = cur; a8PmsSync(); }
  }
  function a8PmsJump(k) {
    var box = a8PfBox();
    if (!box) return;
    var idx = -1;
    for (var i = 0; i < A8PMS_GROUPS.length; i++) if (A8PMS_GROUPS[i][0] === k) idx = i;
    if (idx < 0) return;
    a8PmsLoad().then(function () {
      a8PmsRender(idx + 2);
      a8PmsFilter();
      var list = box.querySelector('.agcf-pf-pms');
      var g = list && list.querySelector('[data-agcf-pf-grp="' + k + '"]');
      if (!g) return;
      var bar = list.querySelector('.agcf-pf-dotbar');
      list.scrollTop = Math.max(0, g.offsetTop - ((bar && bar.offsetHeight ? bar.offsetHeight : 0) + 4));
      A8PMS_ST.active = k;
      a8PmsSync();
    });
  }
  function a8PmsMode(on) {
    var box = a8PfBox();
    if (!box) return;
    on = !!on;
    if (A8PMS_ST.on === on) return;
    A8PMS_ST.on = on;
    box.classList.toggle('is-pms', on);
    var fam = box.querySelector('.agcf-fam:not(.agcf-tone)');
    if (fam && (fam.value === 'PANTONE') !== on) {   /* Type shows PANTONE (dark) while open, All types after */
      fam.value = on ? 'PANTONE' : '';
      fam.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var input = box.querySelector('.agcf-search input');
    if (input) {
      if (!A8PMS_ST.ph) A8PMS_ST.ph = input.getAttribute('placeholder') || 'Search';
      input.setAttribute('placeholder', on ? 'PANTONE number or hex' : A8PMS_ST.ph);
      if (input.value) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    a8PmsSync();
    if (!on) return;
    var list = box.querySelector('.agcf-pf-pms');
    if (list) list.scrollTop = 0;
    a8PmsLoad().then(function () {
      a8PmsRender(2);
      a8PmsFilter();
      a8PmsSync();
    });
  }
  function a8PmsMount(box, pf, fl) {
    if (pf.querySelector('.agcf-pf-line')) return;
    var rail = pf.querySelector('.agcf-rail');
    if (!rail) return;
    rail.insertAdjacentHTML('beforebegin',
      '<div class="agcf-pf-line"><div class="agcf-pf-door" data-agcf-pf-open>'   /* 2j: the whole door opens PANTONE */
      + '<span class="agcf-pf-dots" aria-hidden="true">'   /* --r = resting place, --s = fanned out */
      + '<i style="--r:-13.5px;--s:-21px"><b style="background:#ee2433"></b></i>'
      + '<i style="--r:-4.5px;--s:-7px"><b style="background:#fbc505"></b></i>'
      + '<i style="--r:4.5px;--s:7px"><b style="background:#11743c"></b></i>'
      + '<i style="--r:13.5px;--s:21px"><b style="background:#20426c"></b></i></span>'
      + '<span class="agcf-pf-line-t">Need a brand color? We match <em>1,122 PANTONE&reg; colors</em>'
      + A8PMS_INFO + '</span>'
      + '<button type="button" class="agcf-pf-go" aria-label="Browse 1,122 PANTONE colors">Browse' + A8PMS_CR
      + '</button><span class="agcf-pf-shine" aria-hidden="true"></span></div>'
      + '<div class="agcf-pf-label">Our finishes</div></div>'
      + '<div class="agcf-pf-back"><button type="button" data-agcf-pf-close>' + A8PMS_CL + 'Our finishes</button>'
      + '<span class="agcf-pf-back-r"><span>PANTONE&reg; colors</span>' + A8PMS_INFO + '</span></div>');
    rail.insertAdjacentHTML('afterend',
      '<div class="agcf-pf-pms" aria-label="PANTONE colors">'
      + '<div class="agcf-pf-dotbar">' + A8PMS_GROUPS.map(function (g) {
        return '<button type="button" class="agcf-pf-dot" data-agcf-pf-go="' + g[0] + '" aria-label="'
          + g[1] + '"><i style="background:' + g[2] + '"></i></button>';
      }).join('') + '</div>'
      + '<div class="agcf-pf-pms-list"></div>'
      + '<p class="agcf-pf-nomatch">No PANTONE color matches. Try another number.</p>'
      + '<p class="agcf-pf-note">PANTONE&reg; colors on screen are a guide only; we paint to the physical'
      + ' PANTONE chip. PANTONE&reg; is a registered trademark of Pantone LLC. Arc Grove is not affiliated with'
      + ' or endorsed by Pantone LLC.</p></div>');
    var fam = box.querySelector('.agcf-fam:not(.agcf-tone)');
    if (fam && !fam.querySelector('option[value="PANTONE"]')) {   /* PANTONE is one of the Type options (2c) */
      fam.insertAdjacentHTML('beforeend', '<option value="PANTONE">PANTONE&reg;</option>');
      fam.addEventListener('change', function () {
        if (fam.value === 'PANTONE') a8PmsMode(true);
        else if (A8PMS_ST.on) a8PmsMode(false);
      });
    }
    var toneSel = box.querySelector('.agcf-tone');
    if (toneSel && !toneSel.querySelector('option[value="Warm"]')) {   /* 2f (4C): Warm and Cool in the Tone list */
      var shades = Array.prototype.slice.call(toneSel.querySelectorAll('option')).filter(function (o) { return o.value; });
      var og = document.createElement('optgroup');
      og.label = 'Shade';
      shades.forEach(function (o) { og.appendChild(o); });
      toneSel.appendChild(og);
      toneSel.insertAdjacentHTML('beforeend',
        '<optgroup label="Temperature"><option value="Warm">Warm</option><option value="Cool">Cool</option></optgroup>');
    }
    fl.insertAdjacentHTML('beforeend', '<div class="agcf-pf-groups">' + A8PMS_GROUPS.map(function (g) {
      return '<button type="button" class="agcf-pf-gbtn" data-agcf-pf-go="' + g[0] + '"><i style="background:'
        + g[2] + '"></i>' + g[1] + '</button>';
    }).join('') + '</div>');
    box.addEventListener('click', function (e) {
      var t = e.target.closest
        ? e.target.closest('[data-agcf-pf-open],[data-agcf-pf-close],[data-agcf-pf-go]') : null;
      if (!t || !box.contains(t)) return;
      if (e.target.closest('.agcf-pf-infow')) return;   /* 2j: the "i" sits inside the door */
      e.preventDefault();
      if (t.hasAttribute('data-agcf-pf-open')) a8PmsMode(true);
      else if (t.hasAttribute('data-agcf-pf-close')) a8PmsMode(false);
      else a8PmsJump(t.getAttribute('data-agcf-pf-go'));
    });
    (function a8PfDoorHello() {   /* 2j (6B): the dots fan out and a light sweeps across */
      var door = pf.querySelector('.agcf-pf-door');
      if (!door || !window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var last = 0, inView = false, tm = 0;
      function hello(always) {
        var now = Date.now();
        if (box.classList.contains('is-pms') || (!always && now - last < 20000)) return;
        last = now;
        door.classList.remove('is-hello');
        void door.offsetWidth;
        door.classList.add('is-hello');
        clearTimeout(tm);
        tm = setTimeout(function () { door.classList.remove('is-hello'); }, 1900);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting && !inView) setTimeout(function () { hello(false); }, 250);
            inView = en.isIntersecting;
          });
        }, { threshold: 0.9 }).observe(door);
      }
      if (matchMedia('(hover: hover)').matches) door.addEventListener('mouseenter', function () { hello(true); });
    })();
    function a8PmsInfoClose(keep) {
      box.querySelectorAll('.agcf-pf-infow.is-open').forEach(function (w) {
        if (w === keep) return;
        w.classList.remove('is-open');
        var b = w.querySelector('[data-agcf-pf-info]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var ib = e.target.closest ? e.target.closest('[data-agcf-pf-info]') : null;
      if (ib && !box.contains(ib)) ib = null;
      var w = ib ? ib.parentNode : null;
      a8PmsInfoClose(w);
      if (!ib) return;
      e.preventDefault();
      var on = !w.classList.contains('is-open');
      w.classList.toggle('is-open', on);
      ib.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') a8PmsInfoClose(null); });
    var list = pf.querySelector('.agcf-pf-pms');
    list.addEventListener('scroll', function () { a8PmsScroll(list); }, { passive: true });
    var input = box.querySelector('.agcf-search input');
    var tone = box.querySelector('.agcf-tone');
    var clr = box.querySelector('.agcf-clear');
    /* after wireFilter's own pass (200ms debounce / same change event): the PANTONE tiles follow this rule, so a
       Type filter left on from our finishes never hides them */
    if (input) input.addEventListener('input', debounce(function () {
      if (!A8PMS_ST.on && /^#?[0-9a-f]{6}$/i.test((input.value || '').trim())) {   /* 2f: a hex opens PANTONE */
        var hv = input.value;
        a8PmsMode(true);
        input.value = hv;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
      if (A8PMS_ST.on) a8PmsFilter();
    }, 230));
    if (tone) tone.addEventListener('change', function () { if (A8PMS_ST.on) a8PmsFilter(); });
    if (clr) clr.addEventListener('click', function () { if (A8PMS_ST.on) setTimeout(a8PmsFilter, 0); });
  }
  function a8PfBoot() {
    var box = a8PfBox();
    if (!box) return;
    a8PfLayout();
    if (!window.MutationObserver) return;
    /* the Clear cell mounts when the rail first fills and the options card's liftClear moves it out of the
       rail - follow it into the search row (a8PfLayout only moves what is out of place, so it settles) */
    new MutationObserver(function () { a8PfLayout(); }).observe(box, { childList: true, subtree: true });
  }

  function a8ClearHTML() {
    return '<button type="button" class="agcf8-clearcell"'
      + ' data-agcf8-clear aria-label="Clear custom finish selection">'
      + '<span class="agcf8-clearcell-img">'
      + '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">'
      + '<path d="' + P_X + '"/></svg></span>'
      + '<span class="agcf8-clearcell-name">Clear</span></button>';
  }
  function a8ClearMount(rail) {
    if (rail.querySelector('[data-agcf8-clear]')) return;
    rail.insertAdjacentHTML('afterbegin', a8ClearHTML());
    var cell = rail.querySelector('[data-agcf8-clear]');
    cell.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      clearRole('primary');
    });
  }
  function a8ClearCell() {

    var rail = document.querySelector('[data-agcf-r6] .agcf-rail');
    if (!rail) return;
    if (rail.children.length) { a8ClearMount(rail); return; }
    var mo = new MutationObserver(function () {
      if (!rail.children.length) return;
      mo.disconnect();
      a8ClearMount(rail);
    });
    mo.observe(rail, { childList: true });
  }

  function a8SwipeBar() {

    var rail = document.querySelector('[data-agcf-r6] .agcf-rail');
    if (!rail || A8.swipebar) return;
    var bar = document.createElement('div');
    bar.className = 'agcf8-swipebar';
    bar.setAttribute('data-agcf8-swipebar', '');
    bar.setAttribute('aria-hidden', 'true');
    bar.appendChild(document.createElement('i'));
    rail.insertAdjacentElement('afterend', bar);
    A8.swipebar = bar;
    var raf = false;
    function paint() {
      raf = false;
      var track = rail.scrollWidth;
      var still = track <= rail.clientWidth + 4;
      bar.classList.toggle('is-static', still);
      if (still) return;
      var th = bar.firstElementChild;
      th.style.width = Math.max(12, rail.clientWidth / track * 100) + '%';
      th.style.left = (rail.scrollLeft / track * 100) + '%';
    }
    function queue() {
      if (raf) return;
      raf = true;
      requestAnimationFrame(paint);
    }
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(rail, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'hidden', 'class']
    });
    paint();
  }

  var A8_CR = 'M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,'
    + '90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z';
  var A8_CL = 'M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,'
    + '0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z';
  function a8RailBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'agcf8-railnav-b agcf8-railnav-b--' + dir;
    b.setAttribute('data-agcf8-rail-' + dir, '');
    b.setAttribute('aria-label', dir === 'prev'
      ? 'Scroll finishes back' : 'Scroll finishes forward');
    b.innerHTML = '<svg viewBox="0 0 256 256" fill="currentColor"'
      + ' aria-hidden="true"><path d="'
      + (dir === 'prev' ? A8_CL : A8_CR) + '"/></svg>';
    return b;
  }
  function a8RailNav() {

    var rail = document.querySelector('[data-agcf-r6] .agcf-rail');
    if (!rail || A8.railnav) return;
    if (!document.body.hasAttribute('data-agcf14-railopt')) {
      document.body.setAttribute('data-agcf14-railopt', 'endrow');
    }
    var nav = document.createElement('div');
    nav.className = 'agcf8-railnav';
    nav.setAttribute('data-agcf8-railnav', '');
    var prev = a8RailBtn('prev');
    var next = a8RailBtn('next');
    nav.appendChild(prev);
    nav.appendChild(next);

    (A8.swipebar || rail).insertAdjacentElement('afterend', nav);
    A8.railnav = nav;
    function page(sign) {
      rail.scrollBy({
        left: sign * Math.max(200, Math.round(rail.clientWidth * 0.9)),
        behavior: 'smooth'
      });
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    var raf = false;
    function paint() {
      raf = false;
      var track = rail.scrollWidth;
      var live = !isMobile() && track > rail.clientWidth + 4;
      nav.classList.toggle('is-live', live);
      if (!live) return;
      var max = track - rail.clientWidth;
      prev.classList.toggle('is-off', rail.scrollLeft <= 2);
      next.classList.toggle('is-off', rail.scrollLeft >= max - 2);
      if (document.body.getAttribute('data-agcf14-railopt')
          === 'arrows') {

        var nr = nav.getBoundingClientRect();
        var rr = rail.getBoundingClientRect();
        var top = Math.round(rr.top - nr.top + 6);
        prev.style.top = top + 'px';
        next.style.top = top + 'px';
        var cell = rail.querySelector('.agcf8-clearcell');
        prev.style.left = Math.round(
          (cell ? cell.getBoundingClientRect().right : rr.left)
          - nr.left) + 'px';
        next.style.right = Math.round(nr.right - rr.right) + 'px';
      } else {
        prev.style.top = ''; next.style.top = '';
        prev.style.left = ''; next.style.right = '';
      }
    }
    function queue() {
      if (raf) return;
      raf = true;
      requestAnimationFrame(paint);
    }
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(rail, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'hidden', 'class']
    });
    var band = document.querySelector('[data-agcf-r6] .agcf-band');
    if (band) band.addEventListener('transitionend', queue);
    A8.railnavPaint = queue;

    function dragOn() {
      return !isMobile() && document.body
        .getAttribute('data-agcf14-railopt') === 'dragbar';
    }
    var bar = A8.swipebar;
    if (bar && !bar.hasAttribute('data-agcf8-drag')) {
      bar.setAttribute('data-agcf8-drag', '');
      var th = bar.firstElementChild;
      var drag = null;
      bar.addEventListener('pointerdown', function (e) {
        if (!dragOn()) return;
        e.preventDefault();
        if (e.target === th) {
          drag = { x: e.clientX, left: rail.scrollLeft };
          try { bar.setPointerCapture(e.pointerId); } catch (err) {}
        } else {
          var thr = th.getBoundingClientRect();
          page(e.clientX < thr.left ? -1 : 1);
        }
      });
      bar.addEventListener('pointermove', function (e) {
        if (!drag || !dragOn()) return;
        var bw = bar.clientWidth || 1;
        rail.scrollLeft = drag.left
          + (e.clientX - drag.x) * (rail.scrollWidth / bw);
      });
      var up = function () { drag = null; };
      bar.addEventListener('pointerup', up);
      bar.addEventListener('pointercancel', up);
    }
    paint();
  }

  function a8Scrim(owner, on) {

    if (!A8.scrimOwners) A8.scrimOwners = {};
    A8.scrimOwners[owner] = !!on;
    var any = !!(A8.scrimOwners.pop || A8.scrimOwners.hist);
    var el = A8.scrimEl;
    if (!el) {
      if (!any) return;
      el = document.createElement('div');
      el.className = 'agcf8-scrim';
      el.setAttribute('data-agcf8-scrim', '');
      el.addEventListener('click', function () {
        if (A8.scrimOwners.pop) closePop(true);
        if (A8.scrimOwners.hist) a8HistClose(true);
      });
      document.body.appendChild(el);

      void el.offsetHeight;
      A8.scrimEl = el;
    }
    el.classList.toggle('is-on', any);
  }

  function a8PopSheet(pop) {

    if (!isMobile()) return;
    if (pop.querySelector('.agcf8-pop-grid')) return;
    var sw = pop.querySelector('.agcf-pop5-swatch');
    var body = pop.querySelector('.agcf-pop5-body');
    if (!sw || !body) return;
    var grid = document.createElement('div');
    grid.className = 'agcf8-pop-grid';
    pop.insertBefore(grid, sw);
    grid.appendChild(sw);
    grid.appendChild(body);
    var tail = ['.agcf-pop5-actions', '.agcf-pop5-sample',
                '.agcf-pop5-remove'];
    for (var i = 0; i < tail.length; i++) {
      var n = body.querySelector(tail[i]);
      if (n) pop.appendChild(n);
    }
  }

  function a8StockCards() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[data-agcf-r6] .ag-finish-row .ag-finish-card'));
  }
  function a8SheetCards() {

    var sel = a8StockCards();
    if (sel.length) return sel;
    return Array.prototype.slice.call(document.querySelectorAll(
      '[data-agcf-r6] .ag-finish-display-list .ag-finish-card--display'));
  }
  function a8StockSheet() {

    document.addEventListener('click', function (e) {
      if (!(window.matchMedia
            && window.matchMedia('(max-width: 991px)').matches)) return;
      var card = e.target.closest ? e.target.closest(
        '[data-agcf-r6] .ag-finish-row .ag-finish-card,'
        + ' [data-agcf-r6] .ag-finish-display-list'
        + ' .ag-finish-card--display') : null;
      if (card) { a8PickSettle(); return; }

      var g29 = e.target.closest
        ? e.target.closest('[data-agcf-r6] .agcf-ghost') : null;
      if (!g29 || !st || !st.primary) return;
      a8PickSettle();
    });
  }
  function a8FocusGate() {

    document.addEventListener('focus', function (e) {
      var t = e.target;
      if (!t || !t.closest
          || !t.closest('[data-agcf-r6] .ag-finish-card')) return;
      try {
        if (t.matches && t.matches(':focus-visible')) return;
      } catch (err) { return;   }
      e.stopPropagation();
    }, true);

    function a8DeskDialogBand() {
      return window.matchMedia
        && window.matchMedia('(min-width: 768px)').matches
        && window.matchMedia('(hover: hover)').matches;
    }
    document.addEventListener('click', function (e) {
      if (!a8DeskDialogBand()) return;
      var card = e.target.closest ? e.target.closest(
        '[data-agcf-r6] .ag-finish-display-list .ag-finish-card--display')
        : null;
      if (!card) return;
      e.stopPropagation();
      closePop();
      selectStockSide(card.getAttribute('data-finish-name-primary')
        || card.getAttribute('data-finish-name') || '');
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!a8DeskDialogBand()) return;
      var card = e.target.closest ? e.target.closest(
        '[data-agcf-r6] .ag-finish-display-list .ag-finish-card--display')
        : null;
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      closePop();
      selectStockSide(card.getAttribute('data-finish-name-primary')
        || card.getAttribute('data-finish-name') || '');
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        if (!a8DeskDialogBand()) return;
        for (var mi = 0; mi < muts.length; mi++) {
          var ad = muts[mi].addedNodes;
          for (var mj = 0; mj < ad.length; mj++) {
            var mn = ad[mj];
            if (mn.nodeType === 1 && mn.classList
                && mn.classList.contains('ag-finish-sheet-backdrop')) {
              document.dispatchEvent(new KeyboardEvent('keydown',
                { key: 'Escape', bubbles: true }));
              return;
            }
          }
        }
      }).observe(document.body, { childList: true });
    }

    var sp0 = document.querySelector(
      '[data-agcf-r6] .ag-finish-panel:not([data-agcf-ghost-panel])');
    if (sp0 && window.MutationObserver) {
      new MutationObserver(function () {
        if (sp0.hidden) return;
        var hov = document.querySelector(
          '[data-agcf-r6] .ag-finish-card:hover,'
          + ' [data-agcf-r6] .agcf-ghost-box:hover');
        var kb = null;
        try {
          kb = document.querySelector(
            '[data-agcf-r6] .ag-finish-card:focus-visible');
        } catch (err) { return;   }
        if (!hov && !kb) sp0.hidden = true;
      }).observe(sp0, { attributes: true, attributeFilter: ['hidden'] });
    }
  }
  function a8LiveSheet() {

    if (A8_PROTO) return;
    function lChip() {

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ag-finish-card agcf8-lchip';
      b.setAttribute('data-agcf8-lchip', '');
      b.setAttribute('aria-label', COPY.ghost + ': ' + st.primary.name
        + (st.accent ? (' with ' + st.accent.name + ' accent') : ''));
      var w = document.createElement('span');
      w.className = 'ag-finish-card-img-wrap';
      w.setAttribute('data-has-accent', st.accent ? 'true' : 'false');
      var im = document.createElement('img');
      im.className = 'ag-finish-card-img ag-finish-card-img--primary';
      im.src = cdn(st.primary.image, 260);
      im.alt = '';
      w.appendChild(im);
      if (st.accent) {
        var ia = document.createElement('img');
        ia.className = 'ag-finish-card-img ag-finish-card-img--accent';
        ia.src = cdn(st.accent.image, 260);
        ia.alt = '';
        w.appendChild(ia);
      }

      w.insertAdjacentHTML('beforeend', A8_MAG);
      b.appendChild(w);
      return b;
    }
    function lGhostClone() {
      var gp = ghostPanel();
      if (!gp) return null;
      var c = gp.cloneNode(true);
      c.classList.remove('agcf-ghost-panel');
      c.removeAttribute('data-agcf-ghost-panel');
      c.hidden = false;
      c.removeAttribute('style');
      c.removeAttribute('role');
      return c;
    }
    function lAugment(backdrop) {
      if (!st || !st.primary) return;
      if (window.matchMedia
          && window.matchMedia('(min-width: 768px)').matches
          && window.matchMedia('(hover: hover)').matches) {

        return;
      }
      var sheet = backdrop.querySelector('.ag-finish-sheet');
      if (!sheet || sheet.querySelector('[data-agcf8-lchip]')) return;
      var panel = sheet.querySelector('.ag-finish-panel');
      if (!panel) return;
      panel.setAttribute('data-agcf8-live-orig', '');
      A8.lOrig = panel;
      A8.lGhost = null;
      var row = sheet.querySelector('.ag-finish-sheet-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'ag-finish-sheet-row';
        row.setAttribute('data-agcf8-lrow', '');
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', 'All finishes');
        var cs = a8SheetCards();
        for (var i = 0; i < cs.length; i++) {
          row.appendChild(cs[i].cloneNode(true));
        }
        sheet.insertBefore(row, panel.nextSibling);
      }
      row.appendChild(lChip());
    }
    function lSwapIn(sheet) {
      if (!A8.lOrig || !A8.lOrig.parentNode) return;
      var g = A8.lGhost || lGhostClone();
      if (!g) return;
      A8.lGhost = g;
      A8.lOrig.parentNode.replaceChild(g, A8.lOrig);
      var row = sheet ? sheet.querySelector('.ag-finish-sheet-row') : null;
      if (row) {
        var sc = row.querySelectorAll('.ag-finish-card--selectable');
        for (var i = 0; i < sc.length; i++) {
          sc[i].classList.remove('is-selected');
        }
        var cc = row.querySelector('[data-agcf8-lchip]');
        if (cc) cc.classList.add('is-agcf-on');
      }
    }
    function lSwapBack(sheet) {
      if (!A8.lGhost || !A8.lGhost.parentNode || !A8.lOrig) return;
      A8.lGhost.parentNode.replaceChild(A8.lOrig, A8.lGhost);
      var cc = sheet ? sheet.querySelector('[data-agcf8-lchip]') : null;
      if (cc) cc.classList.remove('is-agcf-on');
    }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var add = muts[i].addedNodes;
        for (var j = 0; j < add.length; j++) {
          var n = add[j];
          if (n && n.classList
              && n.classList.contains('ag-finish-sheet-backdrop')) {
            lAugment(n);
          }
        }
      }
    }).observe(document.body, { childList: true });
    document.addEventListener('click', function (e) {
      var row = e.target.closest
        ? e.target.closest('.ag-finish-sheet-row') : null;
      if (!row) return;
      var sheet = row.closest('.ag-finish-sheet');

      var m91 = !!(window.matchMedia
        && window.matchMedia('(max-width: 991px)').matches);
      var cu = e.target.closest('[data-agcf8-lchip]');
      if (cu) {

        e.stopPropagation();
        selectCustomSide();
        if (m91) { a8PickSettle(); } else { lSwapIn(sheet); }
        return;
      }

      lSwapBack(sheet);
      if (row.hasAttribute('data-agcf8-lrow')) {

        var clone = e.target.closest('.ag-finish-card');
        if (!clone || clone.hasAttribute('data-agcf8-lchip')) return;
        var pageCard = null;
        if (clone.classList.contains('ag-finish-card--display')) {
          pageCard = document.querySelector('[data-agcf-r6]'
            + ' .ag-finish-display-list .ag-finish-card--display');
        } else if (clone.getAttribute('data-variant-value')) {
          var cs2 = a8SheetCards();
          for (var k = 0; k < cs2.length; k++) {
            if (cs2[k].getAttribute('data-variant-value')
                === clone.getAttribute('data-variant-value')) {
              pageCard = cs2[k];
              break;
            }
          }
        }
        if (pageCard) {
          pageCard.click();

          if (m91) a8PickSettle();
        }
      } else if (m91) {

        setTimeout(a8PickSettle, 0);
      }
    }, true);
  }
  function a8PopFx() {

    var root = document.querySelector('[data-agcf-r6]');
    if (!root) return;
    function wire(pop) {
      var amo = new MutationObserver(function () {
        var on = pop.classList.contains('is-show') && isMobile();
        a8Scrim('pop', on);
        if (on) a8PopSheet(pop);
      });
      amo.observe(pop, { attributes: true, attributeFilter: ['class'] });
      if (pop.classList.contains('is-show') && isMobile()) {

        pop.style.transition = 'none';
        pop.style.transform = 'translateY(100%)';
        void pop.offsetHeight;
        pop.style.transition = '';
        pop.style.transform = '';
        a8Scrim('pop', true);
        a8PopSheet(pop);
      }
    }
    var pop = root.querySelector('.agcf-pop5');
    if (pop) { wire(pop); return; }
    var mo = new MutationObserver(function () {
      var p = root.querySelector('.agcf-pop5');
      if (!p) return;
      mo.disconnect();
      wire(p);
    });
    mo.observe(root, { childList: true, subtree: true });
  }
  function a8AgspSkin() {

    var mq = window.matchMedia('(max-width:560px)');
    function reskin() {

      var btn = document.querySelector('.agsp-backdrop .agsp-close');
      if (!btn) return;
      var svg = btn.querySelector('svg');
      if (mq.matches && !svg) {
        btn.innerHTML = '<svg class="agcf-x" viewBox="0 0 256 256"'
          + ' fill="currentColor" aria-hidden="true"><path d="'
          + P_X + '"/></svg>';
      } else if (!mq.matches && svg) {
        btn.textContent = '×';
      }
    }
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('agsp-backdrop'))
              || (n.querySelector && n.querySelector('.agsp-backdrop'))) {
            reskin();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true });
    if (mq.addEventListener) mq.addEventListener('change', reskin);
    else if (mq.addListener) mq.addListener(reskin);
  }

  function a8BadgeAlign() {

    if (A8.alignRaf) return;
    A8.alignRaf = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        A8.alignRaf = false;
        a8BadgeAlignNow();
      });
    });
  }
  function a8BadgeAlignNow() {

    var root = document.querySelector('.slick-product-gallery');
    var list = document.querySelector('.slick-product-gallery .slick-list');
    if (!root || !list) return;
    if (window.innerWidth <= 991) {
      root.style.removeProperty('--agcf8-wm-b');
      root.style.removeProperty('--agcf8-wm-s');
      root.style.removeProperty('--agcf8-wm-h');
      return;
    }
    var r = list.getBoundingClientRect();
    if (!(r.width > 50)) return;
    var scale = Math.max(r.width, r.height) / 2048;
    var disp = 2048 * scale;
    var cropX = (disp - r.width) / 2;
    var cropY = (disp - r.height) / 2;
    var inset = 63 * scale;
    root.style.setProperty('--agcf8-wm-b',
      Math.max(6, Math.round(inset - cropY)) + 'px');
    root.style.setProperty('--agcf8-wm-s',
      Math.max(6, Math.round(inset - cropX)) + 'px');
    root.style.setProperty('--agcf8-wm-h',
      Math.round(130 * scale) + 'px');
  }

  function a8ScrollGhost() {

    var g = document.querySelector('[data-agcf-r6] .agcf-ghost')
      || document.querySelector('[data-agcf-r6] .agcf-ghost-box');
    if (!g) return;
    var rm = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      g.scrollIntoView({ behavior: rm ? 'auto' : 'smooth',
                         block: 'center' });
    } catch (err) { g.scrollIntoView(); }
  }
  /* 2g (Ansen 2026-10-17): the Finish preview ID - FP-XXXXXX from the combination (the render service's
     render_core.fp_id is the same function; service/qa_fp.py pins them). A Copy + Call box takes the
     "Finish preview" pill's place at the top-left of the photo (phones: the same box, smaller -
     board 22C); the cart line carries it as "Finish preview ID". */
  function a8FpId(handle, p, a, side, width) {
    var s = [handle, p, a || 'none', side, width ? 'w' + parseInt(width, 10) : ''].join('|');
    var u = unescape(encodeURIComponent(s)), h = 0x811c9dc5;
    for (var i = 0; i < u.length; i++) { h ^= u.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    var A = '23456789ABCDEFGHJKMNPQRSTVWXYZ', n = h % 729000000, out = '';
    for (var k = 0; k < 6; k++) { out = A.charAt(n % 30) + out; n = Math.floor(n / 30); }
    return 'FP-' + out;
  }
  function a8FpOfKey(key) {
    var x = String(key || '').split('__');
    if (x.length < 4 || !x[0] || !x[1]) return '';
    var w = /^w(\d+)$/.exec(x[4] || '');
    return a8FpId(x[0], x[1], x[2] === 'none' ? '' : x[2], x[3], w ? w[1] : '');
  }
  var A8FP_CSS = ".slick-product-gallery .agcf-fpbox{position:absolute;left:16px;top:16px;z-index:6;width:308px;box-sizing:border-box;overflow:hidden;background:rgba(255,255,255,.96);border:1px solid rgba(36,43,38,.14);box-shadow:0 4px 14px rgba(36,43,38,.12);font-family:'Inter Tight',sans-serif;color:#242B26;transition:width .55s cubic-bezier(.3,.7,.2,1);}.slick-product-gallery .agcf-fpbox.is-folded{width:30px;}.agcf-fpbox-in{width:306px;box-sizing:border-box;padding:10px 38px 10px 12px;display:flex;flex-direction:column;gap:7px;transition:opacity .3s ease .25s;}.agcf-fpbox.is-folded .agcf-fpbox-in{opacity:0;visibility:hidden;transition:opacity .2s ease,visibility 0s linear .2s;}.agcf-fpbox-fold{position:absolute;top:0;right:0;bottom:0;width:28px;display:flex;align-items:center;justify-content:center;margin:0;padding:0;border:0;background:transparent;color:#242B26;cursor:pointer;}.agcf-fpbox-fold svg{width:13px;height:18px;display:block;transition:transform .55s cubic-bezier(.3,.7,.2,1);}.agcf-fpbox.is-folded .agcf-fpbox-fold svg{transform:rotate(180deg);}@media (prefers-reduced-motion:reduce){.agcf-fpbox,.agcf-fpbox-in,.agcf-fpbox-fold svg{transition:none !important;}}.slick-product-gallery.agcf-has-fp .agcf-preview-chip{display:none !important;}.agcf-fpbox-top{display:flex;align-items:baseline;justify-content:space-between;gap:8px;}.agcf-fpbox-l{font-family:'Alata',sans-serif;font-size:9.5px;letter-spacing:1px;text-transform:uppercase;color:#5d655f;}.agcf-fpbox-id{font-family:'Alata',sans-serif;font-size:15px;letter-spacing:.5px;}.agcf-fpbox-t{margin:0;font-size:11.5px;line-height:1.4;color:#3d443f;}.agcf-fpbox-b{display:flex;gap:6px;}.agcf-fpbox-copy,.agcf-fpbox-call{flex:1 1 0;height:30px;display:flex;align-items:center;justify-content:center;box-sizing:border-box;margin:0;padding:0 6px;font-family:'Alata',sans-serif;font-size:10.5px;letter-spacing:.5px;text-transform:uppercase;text-decoration:none;white-space:nowrap;cursor:pointer;}.agcf-fpbox-copy{border:1px solid #242B26;background:#fff;color:#242B26;}.agcf-fpbox-call{flex-grow:1.4;background:#242B26;color:#fff !important;border:1px solid #242B26;}@media (max-width:768px){.slick-product-gallery .agcf-fpbox{left:12px;top:12px;width:236px;box-shadow:0 3px 10px rgba(36,43,38,.12);}.slick-product-gallery .agcf-fpbox.is-folded{width:26px;}.agcf-fpbox-in{width:234px;padding:8px 30px 8px 10px;gap:6px;}.agcf-fpbox-fold{width:24px;}.agcf-fpbox-fold svg{width:12px;height:16px;}.agcf-fpbox-l{font-size:8.5px;}.agcf-fpbox-id{font-size:13.5px;}.agcf-fpbox-t{font-size:10.5px;line-height:1.35;}.agcf-fpbox-copy,.agcf-fpbox-call{height:26px;font-size:9.5px;}}";
  var A8FP_COPY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">'
    + '<rect x="8" y="8" width="12" height="12"/><path d="M16 8V4H4v12h4"/></svg>';
  var A8FP_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">'
    + '<path d="M5 12l5 5 9-10"/></svg>';
  function a8FpCss() {
    if (document.getElementById('agcf-fp-css')) return;
    var s = document.createElement('style');
    s.id = 'agcf-fp-css';
    s.textContent = A8FP_CSS;
    document.head.appendChild(s);
  }
  function a8FpCopy(btn, fp, icon) {
    var done = function () {
      var was = btn.innerHTML;
      btn.innerHTML = icon ? A8FP_OK : 'Copied';
      setTimeout(function () { btn.innerHTML = was; }, 1600);
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(fp).then(done, function () {});
        return;
      }
    } catch (e) {}
    try {
      var ta = document.createElement('textarea');
      ta.value = fp;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
      done();
    } catch (e2) {}
  }
  var A8FP_ARROW = '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M165.66,202.34a8,8,0,0,1'
    + '-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>';
  /* board 28 (Ansen 2026-10-17): a plain arrow on the box's right edge folds it to the left into a thin white strip of the
     same height; after each render the box opens out to the right. Folded stays folded while the shopper is on this
     page (even for a new finish); a fresh visit opens it again (this flag is not stored anywhere). */
  var A8FP_FOLDED = false;
  function a8FpFold(box, folded) {
    box.classList.toggle('is-folded', folded);
    var b = box.querySelector('.agcf-fpbox-fold');
    if (b) {
      b.setAttribute('aria-expanded', folded ? 'false' : 'true');
      b.setAttribute('aria-label', folded ? 'Show the Finish preview ID' : 'Fold the Finish preview ID away');
    }
  }
  function a8FpBox(g, key) {
    var gal = g && g.querySelector('.slick-product-gallery');
    if (!gal) return;
    var box = gal.querySelector('[data-agcf-fpbox]');
    var fp = key ? a8FpOfKey(key) : '';
    /* the box takes the "Finish preview" pill's place (Ansen 2026-10-17); a simulated preview keeps its pill */
    var chip = gal.querySelector('.agcf-preview-chip');
    var sim = !!chip && /simulated/i.test(chip.textContent || '');
    gal.classList.toggle('agcf-has-fp', !!fp && !sim);
    if (!fp || sim) { if (box) box.remove(); return; }
    if (box && box.getAttribute('data-fp') === fp) return;
    a8FpCss();
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-agcf-fpbox', '');
      box.className = 'agcf-fpbox';
      gal.appendChild(box);
    }
    box.setAttribute('data-fp', fp);
    box.innerHTML = '<div class="agcf-fpbox-in">'
      + '<div class="agcf-fpbox-top"><span class="agcf-fpbox-l">Finish preview ID</span>'
      + '<span class="agcf-fpbox-id">' + fp + '</span></div>'
      + '<p class="agcf-fpbox-t">Questions about this finishing? Call us and give our team this ID.</p>'
      + '<div class="agcf-fpbox-b"><button type="button" class="agcf-fpbox-copy">Copy ID</button>'
      + '<a class="agcf-fpbox-call" href="tel:+18334880005">Call (833) 488-0005</a></div></div>'
      + '<button type="button" class="agcf-fpbox-fold">' + A8FP_ARROW + '</button>';
    var cb = box.querySelector('.agcf-fpbox-copy');
    cb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); a8FpCopy(cb, fp, false); });
    var fb = box.querySelector('.agcf-fpbox-fold');
    fb.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      clearTimeout(box._agcfOpen);
      A8FP_FOLDED = !box.classList.contains('is-folded');
      a8FpFold(box, A8FP_FOLDED);
    });
    /* a new render: start folded (no animation), then open out to the right once it is in (unless folded on this page) */
    clearTimeout(box._agcfOpen);
    box.style.transition = 'none';
    a8FpFold(box, true);
    void box.offsetWidth;
    box.style.transition = '';
    if (!A8FP_FOLDED) {
      box._agcfOpen = setTimeout(function () { if (!A8FP_FOLDED) a8FpFold(box, false); }, 650);
    }
  }
  /* 2h (Ansen 2026-10-17, SRM 185: "when was it last opened by them, how many times did they look at the
     finish"). Each time a custom-finish preview becomes the current slide (on a page the shopper can see),
     agcf-track.js is told its Finish preview ID; it counts one ID at most once per 10 s, keeps the newest 20 and
     sends them with its beacon ("po"). A tab coming back into view on a preview counts as another look. */
  var A8PO_KEY = null;
  function a8PoSend(key, tries) {
    if (!key || key.split('__')[0] !== a8Handle()) return;
    if (document.visibilityState === 'hidden') return;
    var fp = a8FpOfKey(key);
    if (!fp) return;
    if (!window.__agcfTrack) {
      /* agcf-track.js loads after this file: wait for it (5 s at most) while the same preview is still showing */
      if ((tries || 0) < 10) {
        setTimeout(function () { if ((a8CurrentKey() || '') === key) a8PoSend(key, (tries || 0) + 1); }, 500);
      }
      return;
    }
    a8Trk('po', { fp: fp });
  }
  function a8PoSeen(key) {
    if (key === A8PO_KEY) return;
    A8PO_KEY = key;
    a8PoSend(key, 0);
  }
  document.addEventListener('visibilitychange', function () {
    try { if (document.visibilityState === 'visible') a8PoSend(a8CurrentKey() || '', 0); } catch (e) {}
  });
  /* photo picks (Ansen 2026-10-17, canvas 65fhQBKaMeFeQ13A3mHNQw board 1E): a custom finish preview the SHOPPER moves
     to - a swipe, an arrow, a thumbnail or the keys - picks its finish by itself, as the Apply button used to (that
     button and the phone bar under the picture are gone). Our own photos only browse. A move is the shopper's when a
     pointer, touch or key event hit the gallery or its thumbnails in the last 2.5 s, so agcf's own moves (a render
     landing, the Preview button, a pick from the panel) never pick again. Same pair and side = nothing to do. */
  var A8AP = { seen: null, user: 0 };
  function a8AutoPickGesture(e) {
    var t = e && e.target;
    if (t && t.closest && t.closest('.slick-product-gallery-container, .slick-product-thumbnail, .product_thumbnail-wrapper, .agcf8-thumb, .agcf8-mthumb, .agcf8-mcell')) {
      A8AP.user = Date.now();
    }
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, a8AutoPickGesture, { capture: true, passive: true });
  });
  function a8AutoPick(key) {
    var was = A8AP.seen;
    A8AP.seen = key || null;
    if (!key || key === was || A8.applying) return;
    if (Date.now() - A8AP.user > 2500) return;
    var parts = key.split('__');
    if (parts[0] !== a8Handle()) return;
    var cur = a8Key();
    if (cur && cur.split('__').slice(0, 4).join('__') === parts.slice(0, 4).join('__')) return;
    if (a8ApplyPair(parts[1], (parts[2] && parts[2] !== 'none') ? parts[2] : null, parts[3])) {
      a8SetEvent(); /* the set pieces render in this pair too, as after the Apply button */
    }
  }
  function a8DockSync() {

    var g = document.querySelector('.slick-product-gallery-container');
    if (!g) return;
    var bar = g.querySelector('[data-agcf8-dockbar]');

    var key = a8CurrentKey() || '';
    a8FpBox(g, key);   /* 2g: the Copy + Call box on the photo, in the pill's place */
    a8PoSeen(key);     /* 2h: tell agcf-track.js which Finish preview is showing */
    a8AutoPick(key);   /* photo picks: a preview the shopper moves to picks its finish */
    /* photo picks ("no bar"): the phone bar under the preview, with its Apply button, is gone; the pick is automatic */
    if (bar) bar.remove();
  }

  function a8RailTrack() {
    return document.querySelector('.slick-product-thumbnail .slick-track');
  }
  function a8GalTrack() {
    return document.querySelector('.slick-product-gallery .slick-track');
  }
  function a8Slick() {

    return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick
      && document.querySelector('.slick-product-gallery.slick-initialized'));
  }
  function a8Park(slide, ms) {

    if (!slide) return;
    slide.style.transition = ms ? ('opacity ' + ms + 'ms ease') : 'none';
    slide.style.opacity = '0';
    slide.style.zIndex = '998';
    slide.classList.remove('slick-current');
    slide.classList.remove('slick-active');
    slide.setAttribute('aria-hidden', 'true');
    var key = slide.getAttribute('data-agcf8-key');
    var pr = key ? a8SlidePair(key) : { thumb: null };
    if (pr.thumb) {
      pr.thumb.classList.remove('slick-current');
      pr.thumb.classList.remove('slick-active');
      pr.thumb.setAttribute('aria-hidden', 'true');
    }
  }
  function a8SlickHooks() {

    if (A8.slickHooked || !a8Slick()) return;
    var $g = window.jQuery('.slick-product-gallery');
    if (!$g.length) return;
    A8.slickHooked = true;
    $g.on('beforeChange.agcf8', function () {

      a8MPark(500);
      var gt = a8GalTrack();
      if (!gt) return;
      var rs = gt.querySelectorAll('.agcf8-slide');
      for (var i = 0; i < rs.length; i++) {
        a8Park(rs[i], rs[i].classList.contains('slick-current') ? 500 : 0);
      }
    });
    $g.on('afterChange.agcf8', function () {
      var gt = a8GalTrack();
      if (gt) {
        var ss = gt.querySelectorAll('.slick-slide:not(.agcf8-slide)');
        for (var i = 0; i < ss.length; i++) {
          if (ss[i].style.transition) ss[i].style.transition = '';
        }
      }

      if (a8MReal()) a8MCellsCur(a8CurrentKey());
      a8Numbers();
      a8Button();
    });
    $g.on('breakpoint.agcf8', function () {

      setTimeout(function () {
        a8MPark(0);
        a8MThumbUnmount();

        agcf8Hide();
        var gtm = a8GalTrack();
        if (gtm) {
          var ms2 = gtm.querySelectorAll(
            ':scope > .agcf8-mslide:not(.slick-cloned)');
          var keys2 = [];
          for (var im2 = 0; im2 < ms2.length; im2++) {
            keys2.push(ms2[im2].getAttribute('data-agcf8-key'));
          }
          keys2.sort(function (a, b) {
            var na = parseInt((a8MSlideFind(a) || {getAttribute:
              function () { return '0'; }})
              .getAttribute('data-slick-index'), 10) || 0;
            var nb = parseInt((a8MSlideFind(b) || {getAttribute:
              function () { return '0'; }})
              .getAttribute('data-slick-index'), 10) || 0;
            return nb - na;
          });
          for (var jm2 = 0; jm2 < keys2.length; jm2++) {
            a8MRemove(keys2[jm2]);
          }
        }
        var gt2 = a8GalTrack();
        if (gt2) {
          var rs2 = gt2.querySelectorAll('.agcf8-slide');
          for (var i2 = 0; i2 < rs2.length; i2++) {
            if (rs2[i2].parentNode) rs2[i2].parentNode.removeChild(rs2[i2]);
          }
        }
        var rt2 = a8RailTrack();
        if (rt2) {
          var ts2 = rt2.querySelectorAll('.agcf8-thumb');
          for (var j2 = 0; j2 < ts2.length; j2++) {
            if (ts2[j2].parentNode) ts2[j2].parentNode.removeChild(ts2[j2]);
          }
        }

        var num2 = document.querySelector('.slides-numbers');
        if (num2 && gt2) {
          var t2 = num2.querySelector('.total');
          var k2 = [].filter.call(gt2.children, function (n) {
            return n.classList && n.classList.contains('slick-slide');
          }).length;
          if (t2 && k2) t2.textContent = (k2 < 10 ? '0' : '') + k2;
        }
        a8BootLedger();
        a8Numbers();
        a8Button();
      }, 0);
    });
  }

  function a8MFallback() {

    return !A8_PROTO && !!(window.matchMedia
      && window.matchMedia('(max-width: 991px)').matches);
  }
  function a8MMode() {

    if (!a8Slick()) return a8MFallback();
    try {
      var s = window.jQuery('.slick-product-gallery').slick('getSlick');
      if (s && s.options) return s.options.fade === false;
      return a8MFallback();
    } catch (e) { return a8MFallback(); }
  }
  function a8MLayer() {

    var g = gallery();
    if (!g) return null;
    var L = g.querySelector('[data-agcf8-mlayer]');
    if (L) return L;
    L = document.createElement('div');
    L.className = 'agcf8-mlayer';
    L.setAttribute('data-agcf8-mlayer', '');
    L.setAttribute('aria-hidden', 'true');
    L.innerHTML = '<img class="agcf8-mlayer-img" alt="" decoding="async">'
      + '<span class="agcf-preview-chip" data-agcf8-mchip></span>';
    g.appendChild(L);
    return L;
  }
  function a8MShow(key, url, sim, ms) {
    var L = a8MLayer();
    if (!L) return;
    var img = L.querySelector('img');
    if (img && img.getAttribute('src') !== url) {

      img.onerror = function () { a8PruneSlide(key); };
      img.src = url;
    }
    var chip = L.querySelector('[data-agcf8-mchip]');
    if (chip) {
      chip.textContent = sim ? 'Finish preview · simulated'
        : 'Finish preview';
    }
    L.style.transition = ms ? ('opacity ' + ms + 'ms ease') : 'none';

    void L.offsetHeight;
    L.classList.add('is-on');
    L.setAttribute('aria-hidden', 'false');
    A8.mKey = key;
    var c = document.querySelector('.slick-product-gallery-container');
    if (c) c.classList.add('agcf8-mshow');
    var mt = a8MThumb();
    if (mt) mt.classList.add('is-cur');
    a8Numbers();
    a8Button();
  }
  function a8MPark(ms) {
    if (!A8.mKey) return;
    A8.mKey = null;
    var g = gallery();
    var L = g && g.querySelector('[data-agcf8-mlayer]');
    if (L) {
      L.style.transition = ms ? ('opacity ' + ms + 'ms ease') : 'none';
      L.classList.remove('is-on');
      L.setAttribute('aria-hidden', 'true');
    }
    var c = document.querySelector('.slick-product-gallery-container');
    if (c) c.classList.remove('agcf8-mshow');
    var mt = a8MThumb();
    if (mt) mt.classList.remove('is-cur');
    a8Numbers();
    a8Button();
  }
  function a8MThumb() {
    var rail = document.querySelector('.slick-product-thumbnail');
    return rail ? rail.querySelector('[data-agcf8-mthumb]') : null;
  }
  function a8MRailComp() {

    try {
      window.jQuery('.slick-product-thumbnail').slick('setPosition');
    } catch (e) {}
  }
  function a8MThumbMount(key, url) {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    var slickRail = rail.classList.contains('slick-initialized');
    var b = rail.querySelector('[data-agcf8-mthumb]');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'agcf8-mthumb'
        + (slickRail ? '' : ' agcf8-mthumb--flow');
      b.setAttribute('data-agcf8-mthumb', '');
      b.setAttribute('aria-label', 'Finish preview');
      b.innerHTML = '<img class="product_thumbnail-image" alt=""'
        + ' decoding="async">'
        + '<span class="agcf8-thumb-tag" aria-hidden="true">Preview</span>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        a8Goto(b.getAttribute('data-agcf8-key') || '', 500);
      });

      b.querySelector('img').onerror = function () {
        a8PruneSlide(b.getAttribute('data-agcf8-key') || '');
      };
      if (slickRail) {
        rail.appendChild(b);
        rail.classList.add('agcf8-railcomp');
        a8MRailComp();
      } else {
        rail.insertBefore(b, rail.firstElementChild);
      }
    }
    b.setAttribute('data-agcf8-key', key);
    var im = b.querySelector('img');
    if (im && im.getAttribute('src') !== url) im.src = url;
    if (A8.mKey) b.classList.toggle('is-cur', A8.mKey === key);
  }
  function a8MThumbUnmount() {
    var rail = document.querySelector('.slick-product-thumbnail');
    var b = rail && rail.querySelector('[data-agcf8-mthumb]');
    if (b && b.parentNode) b.parentNode.removeChild(b);
    if (rail && rail.classList.contains('agcf8-railcomp')) {
      rail.classList.remove('agcf8-railcomp');
      a8MRailComp();
    }
  }
  function a8MUpsert(key, url, sim) {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail || !(rail.classList.contains('slick-initialized')
                   || rail.classList.contains('mobile-freeflow-thumbs'))) {
      return false;
    }
    if (a8MReal()) {

      var g = document.querySelector('.slick-product-gallery');
      if (!g || !g.classList.contains('slick-initialized')) return false;
      var node = a8MSlideFind(key);
      if (node) {
        var im = node.querySelector('img');
        if (im && im.getAttribute('src') !== url) im.src = url;
        node.classList.remove('is-ph');
        a8MSyncClones(key);
      } else {
        node = a8MBuild(key, url, sim, false);
        if (!a8MAdd(node)) {
          if (A8.mAdd !== 'fallback') return false;

          A8.cache[key] = A8.cache[key] || url;
          a8MThumbMount(key, url);
          a8Numbers();
          return true;
        }
        var ri = node.querySelector('img');
        if (ri) {
          ri.onerror = function () { a8PruneSlide(key); };
        }
      }
      A8.cache[key] = A8.cache[key] || url;
      a8MCellMount(key, url, false);
      a8MTotal();
      a8Numbers();
      return true;
    }
    A8.cache[key] = A8.cache[key] || url;
    a8MThumbMount(key, url);
    a8Numbers();
    return true;
  }
  function a8MFieldGuard() {

    var g = gallery();
    if (!g) return;
    g.addEventListener('click', function (e) {
      if (!A8.mKey) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function a8MReal() {

    if (!(a8MMode() && a8Slick() && A8.mAdd !== 'fallback')) return false;
    try {
      var s = window.jQuery('.slick-product-gallery').slick('getSlick');
      return !!s && typeof s.slideCount === 'number';
    } catch (e) { return false; }
  }
  function a8MOffset() {

    var gt = a8GalTrack();
    if (!gt) return 0;
    return gt.querySelectorAll(
      ':scope > .agcf8-mslide:not(.slick-cloned)').length;
  }
  function a8MSlideFind(key) {

    var gt = a8GalTrack();
    if (!gt) return null;
    return gt.querySelector(':scope > .agcf8-mslide[data-agcf8-key="'
      + a8CssKey(key) + '"]:not(.slick-cloned)');
  }
  function a8MBuild(key, url, sim, ph) {

    var d = document.createElement('div');
    d.className = 'agcf8-mslide' + (ph ? ' is-ph' : '');
    d.setAttribute('data-agcf8-key', key);
    d.innerHTML = '<div><div class="slick-slide sub-slick-slide">'
      + '<div class="product-header_gallery-lightbox">'
      + '<picture><img class="product-header_gallery-image'
      + ' agcf8-mslide-img" alt="" decoding="async"></picture>'
      + '<span class="agcf-preview-chip" data-agcf8-slide-chip></span>'
      + (ph ? a8PhLoadHTML() : '')
      + '</div></div></div>';
    var im = d.querySelector('img');
    im.alt = a8KeyNames(key);
    im.src = url || A8_SPACER;
    d.querySelector('[data-agcf8-slide-chip]').textContent =
      sim ? 'Finish preview · simulated' : 'Finish preview';
    return d;
  }
  function a8MAdd(node) {

    if (!a8Slick()) return false;
    var g0 = document.querySelector('.slick-product-gallery');
    if (!g0 || !g0.classList.contains('slick-initialized')) return false;
    var $g, s;
    try {
      $g = window.jQuery('.slick-product-gallery');
      s = $g.slick('getSlick');
    } catch (e0) { return false; }
    if (!s || typeof s.slideCount !== 'number') return false;
    var before = s.slideCount;
    var cur = s.currentSlide;
    var entered = false;
    try {
      $g.slick('slickAdd', node, 0, true);
      entered = !!(node.parentNode);
      var s2 = $g.slick('getSlick');
      var gt = a8GalTrack();
      if (!(gt && gt.contains(node)
            && node.classList.contains('slick-slide')
            && node.getAttribute('data-slick-index') === '0'
            && s2.slideCount === before + 1)) {
        throw new Error('slickAdd verify failed');
      }

      $g.slick('slickGoTo', cur + 1, true);
      a8MNavShimArm();

      var pcl = document.querySelectorAll(
        '.slick-product-gallery .slick-cloned [data-agcf-preview]');
      for (var pi = 0; pi < pcl.length; pi++) {
        if (pcl[pi].parentNode) pcl[pi].parentNode.removeChild(pcl[pi]);
      }
      return true;
    } catch (e1) {
      try {
        if (node.parentNode) node.parentNode.removeChild(node);
        var k = node.getAttribute('data-agcf8-key') || '';
        var cls = document.querySelectorAll(
          '.slick-product-gallery .slick-cloned[data-agcf8-key="'
          + a8CssKey(k) + '"]');
        for (var i = 0; i < cls.length; i++) {
          if (cls[i].parentNode) cls[i].parentNode.removeChild(cls[i]);
        }

        if (entered) $g.slick('setPosition');
      } catch (e2) {}
      A8.mAdd = 'fallback';
      return false;
    }
  }
  function a8MRemove(key) {
    var node = a8MSlideFind(key);
    a8MCellRemove(key);
    if (!node) { a8MTotal(); return false; }
    try {
      var $g = window.jQuery('.slick-product-gallery');
      var s = $g.slick('getSlick');
      var cur = s.currentSlide;

      var idx = parseInt(node.getAttribute('data-slick-index'), 10);
      $g.slick('slickRemove', idx);
      if (cur > idx) {
        try { $g.slick('slickGoTo', cur - 1, true); } catch (e0) {}
      }
    } catch (e1) {
      if (node.parentNode) node.parentNode.removeChild(node);
    }
    a8MTotal();
    return true;
  }
  function a8MSyncClones(key) {

    var real = a8MSlideFind(key);
    if (!real || real.classList.contains('is-ph')
        || real.querySelector('[data-agcf-preview]')) return;
    var cls = document.querySelectorAll(
      '.slick-product-gallery .slick-cloned[data-agcf8-key="'
      + a8CssKey(key) + '"]');
    for (var i = 0; i < cls.length; i++) {
      if (cls[i].querySelector('[data-agcf-preview]')) continue;
      cls[i].innerHTML = real.innerHTML;
      cls[i].classList.remove('is-ph');
    }
  }
  function a8MTotal() {

    if (!a8MMode()) return;
    var t = document.querySelector('.slides-numbers .total');
    if (!t) return;
    var n = 0;
    try {
      n = window.jQuery('.slick-product-gallery')
        .slick('getSlick').slideCount;
    } catch (e) { return; }
    if (n) t.textContent = (n < 10 ? '0' : '') + n;
  }
  function a8MCellSize() {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    var w = rail.querySelector('.product_thumbnail-wrapper');
    var r = null;
    try { r = w && w.getBoundingClientRect(); } catch (e0) {}
    if (r && r.width > 20 && r.height > 20) {
      rail.style.setProperty('--agcf8-cell-w', r.width + 'px');
      rail.style.setProperty('--agcf8-cell-h', r.height + 'px');
    } else {
      rail.style.removeProperty('--agcf8-cell-w');
      rail.style.removeProperty('--agcf8-cell-h');
    }
    if (!A8.mCellRs) {
      A8.mCellRs = true;
      var t = null;
      var re = function () {
        if (t) clearTimeout(t);
        t = setTimeout(a8MCellSize, 150);
      };
      window.addEventListener('resize', re);
      window.addEventListener('orientationchange', re);
    }
  }
  function a8MCellMount(key, url, ph) {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    a8MCellSize();
    var b = rail.querySelector('[data-agcf8-mcell][data-agcf8-key="'
      + a8CssKey(key) + '"]');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'agcf8-mthumb agcf8-mthumb--flow agcf8-mcell';
      b.setAttribute('data-agcf8-mcell', '');
      b.setAttribute('data-agcf8-key', key);
      b.setAttribute('aria-label', 'Finish preview');
      b.innerHTML = '<img class="product_thumbnail-image" alt=""'
        + ' decoding="async">'
        + '<span class="agcf8-thumb-tag" aria-hidden="true">Preview</span>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        a8Goto(b.getAttribute('data-agcf8-key') || '', 500);
      });
      b.querySelector('img').onerror = function () {
        a8PruneSlide(b.getAttribute('data-agcf8-key') || '');
      };
      rail.insertBefore(b, rail.firstElementChild);
    }
    b.classList.toggle('is-ph', !!ph);
    var tag = b.querySelector('.agcf8-thumb-tag');
    if (tag) {
      tag.textContent = ph ? 'Rendering…' : 'Preview';
    }
    var im = b.querySelector('img');
    if (im && url && im.getAttribute('src') !== url) im.src = url;
  }
  function a8MCellRemove(key) {
    var rail = document.querySelector('.slick-product-thumbnail');
    var b = rail && rail.querySelector(
      '[data-agcf8-mcell][data-agcf8-key="' + a8CssKey(key) + '"]');
    if (b && b.parentNode) b.parentNode.removeChild(b);
  }
  /* stage C (2026-10-17): centre a thumbnail in its strip by sliding the strip sideways only. scrollIntoView with
     block 'nearest' also scrolled the page whenever the strip was not fully on screen (the nudge after Preview). */
  function a8RailCenter(el) {
    var rail = el && el.closest ? el.closest('.slick-product-thumbnail') : null;
    if (!rail) return;
    var rr = rail.getBoundingClientRect(), er = el.getBoundingClientRect();
    var left = rail.scrollLeft + (er.left - rr.left) - (rail.clientWidth - er.width) / 2;
    left = Math.max(0, Math.min(left, rail.scrollWidth - rail.clientWidth));
    try { rail.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { rail.scrollLeft = left; }
  }
  function a8MCellsCur(key) {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    var cells = rail.querySelectorAll('[data-agcf8-mcell]');
    for (var i = 0; i < cells.length; i++) {
      var on = !!key
        && cells[i].getAttribute('data-agcf8-key') === key;
      cells[i].classList.toggle('is-cur', on);
      if (on) a8RailCenter(cells[i]);   /* stage C: the strip only, never the page */
    }
  }
  function a8MNavShimArm() {

    if (A8.mNavShim) return;
    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    A8.mNavShim = true;
    rail.addEventListener('click', function (e) {
      if (!a8MReal()) return;

      if (A8.swapLatch && Date.now() < A8.swapLatch) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var off = a8MOffset();
      if (!off) return;
      var w = e.target && e.target.closest
        ? e.target.closest('.product_thumbnail-wrapper') : null;
      if (!w || !rail.contains(w)) return;
      var all = rail.querySelectorAll('.product_thumbnail-wrapper');
      var i = [].indexOf.call(all, w);
      if (i < 0) return;
      e.preventDefault();
      e.stopPropagation();
      try {
        window.jQuery('.slick-product-gallery')
          .slick('slickGoTo', i + off);
      } catch (e2) {}
    }, true);
    try {
      var $g = window.jQuery('.slick-product-gallery');
      $g.off('afterChange.mobileFreeflow');
      $g.on('afterChange.mobileFreeflow', function (ev, sl, cur) {
        var off2 = a8MOffset();
        var ws = document.querySelectorAll(
          '.slick-product-thumbnail .product_thumbnail-wrapper');
        var t = (cur - off2 >= 0) ? ws[cur - off2] : null;
        if (t) a8RailCenter(t);   /* stage C: the strip only, never the page */
      });
    } catch (e4) {}
  }

  function a8PhIsCurrent(key) {

    if (a8MReal()) {
      var n = a8MSlideFind(key);
      return !!(n && n.classList.contains('slick-current'));
    }
    if (!a8MMode() && a8Slick()) {
      var pair = a8SlidePair(key);
      return !!(pair.slide
        && pair.slide.classList.contains('slick-current'));
    }
    return true;
  }
  function a8PhMount(key, sim) {

    if (a8MReal()) {
      var node = a8MSlideFind(key);
      if (!node) {
        node = a8MBuild(key, '', sim, true);
        if (!a8MAdd(node)) return false;
        var ri = node.querySelector('img');
        if (ri) {
          ri.onerror = function () { a8PruneSlide(key); };
        }
      } else {
        node.classList.add('is-ph');
        if (!node.querySelector('[data-agcf8-phload]')) {
          var lbx = node.querySelector(
            '.product-header_gallery-lightbox');
          if (lbx) lbx.insertAdjacentHTML('beforeend', a8PhLoadHTML());
        }
      }
      a8MCellMount(key, '', true);
      a8MTotal();
      a8Goto(key, 500);
      return true;
    }
    if (!a8MMode() && a8Slick()) {
      var rt = a8RailTrack(), gt = a8GalTrack();
      if (!rt || !gt) return false;
      var pair = a8SlidePair(key);
      if (!pair.slide) {
        var built = a8BuildPair(key, A8_SPACER, sim, true);
        if (!built) return false;
        rt.insertBefore(built.thumb, rt.firstElementChild);
        gt.insertBefore(built.slide, gt.firstElementChild);
        pair = { thumb: built.thumb, slide: built.slide };
      } else {
        pair.slide.classList.add('is-ph');
        if (pair.thumb) pair.thumb.classList.add('is-ph');
        if (!pair.slide.querySelector('[data-agcf8-phload]')) {
          var lb3 = pair.slide.querySelector(
            '.product-header_gallery-lightbox');
          if (lb3) lb3.insertAdjacentHTML('beforeend', a8PhLoadHTML());
        }
      }
      a8Numbers();
      a8Goto(key, 500);
      return true;
    }
    return false;
  }
  function a8PhSettle(key) {

    if (A8.gateKey === key) a8GateHome();
    if (a8MReal()) a8MSyncClones(key);
  }
  function a8PhQuiet(pv) {

    if (!pv) return;
    var keep = pv.style.transition;
    pv.style.transition = 'none';
    pv.classList.remove('is-show');
    pv.classList.remove('is-fade');
    var load = a8N(pv, 'load');
    if (load) load.classList.remove('is-on');
    var chip = a8N(pv, 'chip');
    if (chip) chip.textContent = '';
    void pv.offsetHeight;
    pv.style.transition = keep;
  }
  function a8PhUnmount(key) {

    if (!key) return;
    a8PhSettle(key);

    var phc = !!(A8.cache[key] && A8.cache[key].indexOf('data:') !== 0);
    if (a8MReal()) {
      if (!phc) a8MRemove(key);
      else a8MSyncClones(key);
      a8Numbers();
      return;
    }
    if (!a8MMode() && a8Slick() && !phc) {
      var pair = a8SlidePair(key);
      if (pair.thumb && pair.thumb.parentNode) {
        pair.thumb.parentNode.removeChild(pair.thumb);
      }
      if (pair.slide && pair.slide.parentNode) {
        pair.slide.parentNode.removeChild(pair.slide);
      }
      a8Numbers();
    }
  }

  function a8TokDead(t) {
    return !A8.live[t];
  }
  function a8JobCount() {
    return Object.keys(A8.jobs).length;
  }
  function a8JobNode(key) {
    return a8MReal() ? a8MSlideFind(key) : a8SlidePair(key).slide;
  }
  function a8StagesFor(key) {

    var parts = (key || '').split('__');
    var pf = BY_CODE[parts[1]] || null;
    var af = (parts[2] && parts[2] !== 'none')
      ? (BY_CODE[parts[2]] || null) : null;
    return a8StagesFrom(pf ? pf.name : 'your finish',
                        af ? af.name : null);
  }
  function a8PhLoadHTML() {

    return '<span class="agcf8-phload" data-agcf8-phload>'
      + '<span class="agcf-preview-chip agcf8-phchip">Rendering</span>'
      + '<span class="agcf8-art" aria-hidden="true">'
      + '<svg aria-hidden="true" focusable="false" viewBox="0 0 240 120">' + A8_ART + '</svg></span>'
      + '<span class="agcf8-stage"><i class="is-on"'
      + ' data-agcf8-phstage></i></span>'
      + '<span class="agcf8-bar"><i data-agcf8-phfill></i></span>'
      + '<button type="button" class="agcf8-phset" data-agcf8-phset hidden></button>'
      + '</span>';
  }
  /* PDP polish (Ansen 2026-10-17, board 3P5): on phones the set card is far below the picture, so while its pieces render
     the rendering picture says so under its bar - the pieces' own pulsing pictures and "Also rendering your Winsor +
     Penfold"; a tap scrolls to the set card. Painted from the set card's rows (ag-set-attach.js marks a rendering row
     .is-rendering) on every tick; gone with the rendering picture. */
  function a8PhSet(node) {
    var el = node && node.querySelector('[data-agcf8-phset]');
    if (!el) return;
    var names = [], pics = [];
    var stacked = !window.matchMedia || window.matchMedia('(max-width: 991px)').matches;
    var card = stacked ? document.querySelector('[data-agsa-card]') : null;
    if (card && !card.hidden) {
      var rows = card.querySelectorAll('[data-agsa-row].is-rendering');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].hidden) continue;
        var nm = rows[i].querySelector('.ag-name');
        var name = nm ? nm.textContent.replace(/\s+/g, ' ').split('\u00b7')[0].trim() : '';
        if (!name) continue;
        names.push(name);
        var im = rows[i].querySelector('[data-agsa-img]');
        var src = im ? (im.currentSrc || im.getAttribute('src') || '') : '';
        if (src && pics.length < 3) pics.push(src);
      }
    }
    var sig = names.join('|') + '#' + pics.join('|');
    if (el.getAttribute('data-agcf8-sig') !== sig) {
      el.setAttribute('data-agcf8-sig', sig);
      var list = names.length < 3 ? names.join(' + ')
        : names.slice(0, -1).join(', ') + ' + ' + names[names.length - 1];
      el.innerHTML = names.length
        ? '<span class="agcf8-phset-pics" aria-hidden="true">'
          + pics.map(function (s) { return '<img src="' + esc(s) + '" alt="" width="26" height="26">'; }).join('')
          + '</span><span>Also rendering your <u>' + esc(list) + '</u> <span aria-hidden="true">&darr;</span></span>'
        : '';
      el.setAttribute('aria-label', names.length ? 'Also rendering your ' + names.join(' and ') + '. Show them' : '');
    }
    el.hidden = !names.length;
  }
  function a8PhSetGo() {
    var card = document.querySelector('[data-agsa-card]');
    if (!card) return;
    var hdr = document.querySelector('.section_navbar');
    var off = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 60;
    var y = card.getBoundingClientRect().top + (window.pageYOffset || 0) - off - 12;
    var rm = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: Math.max(0, y), behavior: rm ? 'auto' : 'smooth' }); }
    catch (err) { window.scrollTo(0, Math.max(0, y)); }
  }
  /* the line sits inside the gallery's slide: take the tap before the gallery (lightbox, swipe) sees it */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-agcf8-phset]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    a8PhSetGo();
  }, true);
  function a8PhTickArm() {
    if (A8.timer) return;
    A8.timer = setInterval(a8PhTick, 150);
  }
  function a8PhTick() {

    var keys = Object.keys(A8.jobs);
    if (!keys.length) { clearInterval(A8.timer); A8.timer = null; return; }
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], job = A8.jobs[k];

      if (job.hold) continue;
      var x = 0.95 * (1 - Math.exp(-(Date.now() - job.t0) / 15000));
      var adv = job.li < job.stages.length - 1
        && x >= job.stages[job.li + 1][0]
        && Date.now() - job.lastAt >= 5000;
      if (adv) { job.li++; job.lastAt = Date.now(); }
      if (A8.fbKey === k) {
        var p = ensurePreview();
        if (!p) continue;
        var f0 = a8N(p, 'fill');
        if (f0) f0.style.width = (x * 100).toFixed(1) + '%';
        if (adv) a8SetStage(p, job.stages[job.li][1]);
        continue;
      }
      var node = a8JobNode(k);
      if (!node) continue;
      var fl = node.querySelector('[data-agcf8-phfill]');
      if (fl) fl.style.width = (x * 100).toFixed(1) + '%';
      a8PhSet(node);
      if (adv) {
        var stg = node.querySelector('[data-agcf8-phstage]');
        if (stg) stg.textContent = job.stages[job.li][1];
      }
    }
  }
  function a8PhRestart(key) {

    var job = A8.jobs[key];
    if (!job) return;
    job.t0 = Date.now();
    job.li = 0;
    job.lastAt = Date.now();
    var node = a8JobNode(key);
    if (node) {
      var stg = node.querySelector('[data-agcf8-phstage]');
      if (stg) stg.textContent = job.stages[0][1];
      var fl = node.querySelector('[data-agcf8-phfill]');
      if (fl) fl.style.width = '0%';
    }
    a8PhTickArm();
  }
  function a8PhCalm(key) {

    if (A8.fbKey === key) { a8PhQuiet(ensurePreview()); return; }
    var node = a8JobNode(key);
    var ph = node && node.querySelector('[data-agcf8-phload]');
    if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
  }
  function a8PhExit(key, done) {

    var job = A8.jobs[key];
    if (job) job.hold = true;
    if (A8.fbKey === key) {
      var p = ensurePreview();
      if (p) { a8LoaderExit(p, done); return; }
      done();
      return;
    }
    var node = a8JobNode(key);
    var ph = node && node.querySelector('[data-agcf8-phload]');
    if (!ph) { done(); return; }
    var fl = ph.querySelector('[data-agcf8-phfill]');
    if (fl) fl.style.width = '100%';
    var ex = setTimeout(function () {
      ph.style.transition = 'opacity 350ms ease';
      ph.style.opacity = '0';
      done();
      setTimeout(function () {
        if (ph.parentNode) ph.parentNode.removeChild(ph);
      }, 400);
    }, 250);
    if (job) job.exit = ex;
  }
  function a8FailClear() {

    var p = ensurePreview();
    if (!p) return;
    p.classList.remove('is-show');
    p.classList.remove('is-fade');
    var load = a8N(p, 'load');
    if (load) load.classList.remove('is-on');
    var chip = a8N(p, 'chip');
    if (chip) chip.textContent = '';
    a8GateReset(p);
  }
  function a8GateHome() {

    A8.gateKey = null;
    var g = gallery();
    var p = ensurePreview();
    if (p && g && p.parentNode !== g) g.appendChild(p);
  }
  function a8GateHost(key) {

    if (A8.gateKey && A8.gateKey !== key) a8JobKill(A8.gateKey);
    if (!key || A8.fbKey === key) return;
    var node = a8JobNode(key);
    var lb = node && node.querySelector(
      '.product-header_gallery-lightbox');
    var p = ensurePreview();
    if (lb && p && p.parentNode !== lb) lb.appendChild(p);
    A8.gateKey = key;
  }
  function a8JobEnd(key) {

    var job = A8.jobs[key];
    if (job) {
      if (job.exit) { clearTimeout(job.exit); job.exit = null; }
      delete A8.live[job.tok];
    }
    delete A8.jobs[key];
    if (A8.fbKey === key) A8.fbKey = null;
    if (A8.gateKey === key) a8GateHome();
    A8.generating = a8JobCount() > 0;
  }
  function a8JobKill(key) {

    var job = A8.jobs[key];
    if (!job) return;
    if (job.exit) { clearTimeout(job.exit); job.exit = null; }
    delete A8.live[job.tok];
    delete A8.jobs[key];
    if (A8.fbKey === key) {
      A8.fbKey = null;
      a8FailClear();
      a8StopTimers();
    } else {
      if (A8.gateKey === key) { a8GateHome(); a8FailClear(); }
      a8PhUnmount(key);
    }
    A8.generating = a8JobCount() > 0;
    a8Button();
  }
  function a8ScrollGen() {

    if (!(window.matchMedia
          && window.matchMedia('(max-width: 991px)').matches)) return;
    var g = gallery();
    if (!g) return;
    var r = g.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (r.top >= 0 && r.bottom <= vh) return;
    var rm = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      g.scrollIntoView({ behavior: rm ? 'auto' : 'smooth',
                         block: 'center' });
    } catch (err) { g.scrollIntoView(); }
  }
  function a8ScrollSel() {

    if (!(window.matchMedia
          && window.matchMedia('(max-width: 991px)').matches)) return;

    if (A8G && A8G.open) return;
    var g = document.querySelector('.slick-product-gallery-container')
      || gallery();
    if (!g) return;
    var r = g.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (r.top >= 0 && r.top < vh * 0.3) return;
    var y = r.top + (window.pageYOffset || 0) - 12;
    var rm = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' });
    } catch (err) { window.scrollTo(0, y); }
  }
  function a8PickScroll() {

    if (!(window.matchMedia
          && window.matchMedia('(max-width: 991px)').matches)) return;
    a8LiveDismiss();
    setTimeout(a8ScrollSel, 80);
  }
  function a8PickSettle() {

    a8PickScroll();
    document.documentElement.classList.add('agcf8-sso');
    setTimeout(function () {
      document.documentElement.classList.remove('agcf8-sso');
    }, 450);
  }
  function a8GalW() {

    var list = document.querySelector('.slick-product-gallery .slick-list');
    var lw = list ? list.getBoundingClientRect().width : 0;
    if (!(lw > 50)) lw = (list && list.clientWidth) || 717;
    var baked = document.querySelector(
      '.slick-product-gallery .slick-track > div:not(.agcf8-slide)');
    var bw = baked ? baked.getBoundingClientRect().width : 0;
    if (bw > 50 && bw >= lw && bw <= lw + 2) return bw;
    return lw;
  }
  function a8SyncSlideW() {
    var w = a8GalW() + 'px';
    document.querySelectorAll('.agcf8-slide').forEach(function (s) {
      s.style.width = w;
    });
  }
  function a8CssKey(key) {

    return (window.CSS && CSS.escape) ? CSS.escape(key)
      : String(key).replace(/["\\]/g, '\\$&');
  }
  function a8SlidePair(key) {
    var sel = '.slick-slide[data-agcf8-key="' + a8CssKey(key) + '"]';
    var rt = a8RailTrack(), gt = a8GalTrack();
    return {
      thumb: rt ? rt.querySelector(sel) : null,
      slide: gt ? gt.querySelector(sel) : null
    };
  }
  function a8BuildPair(key, url, sim, ph) {
    var rt = a8RailTrack(), gt = a8GalTrack();
    if (!rt || !gt) return null;
    var refT = rt.querySelector('.slick-slide:not([data-agcf8-key])');
    var refS = gt.querySelector('.slick-slide:not([data-agcf8-key])');
    if (!refT || !refS) return null;
    if (!A8.slideH) {

      var bh = parseFloat(rt.style.height || '0');
      var n = rt.children.length;
      A8.slideH = (bh && n) ? Math.round(bh / n) : refT.offsetHeight;
    }
    var alt = a8KeyNames(key);
    var thumb = document.createElement('div');
    thumb.className = 'slick-slide agcf8-thumb';
    thumb.setAttribute('data-agcf8-key', key);
    thumb.setAttribute('aria-hidden', 'false');
    thumb.setAttribute('tabindex', '-1');
    thumb.style.width = refT.style.width || '80px';
    thumb.innerHTML = '<div><div class="product_thumbnail-wrapper"'
      + ' data-media-type="image"'
      + ' style="width: 100%; display: inline-block;">'
      + '<img class="product_thumbnail-image" alt="" width="150"'
      + ' height="150" decoding="async">'
      + '<span class="agcf8-thumb-tag" aria-hidden="true">Preview</span>'
      + '</div></div>';
    var ti = thumb.querySelector('img');
    ti.alt = alt;
    ti.src = url;

    var slide = document.createElement('div');
    slide.className = 'slick-slide agcf8-slide';
    slide.setAttribute('data-agcf8-key', key);
    slide.setAttribute('aria-hidden', 'true');
    slide.setAttribute('tabindex', '-1');
    slide.style.cssText = 'position:absolute;left:0;top:0;z-index:998;'
      + 'opacity:0;width:' + a8GalW() + 'px;';
    slide.innerHTML = '<div class="product-header_gallery-lightbox">'
      + '<img class="agcf8-slide-img" alt="" decoding="async">'
      + '<span class="agcf-preview-chip" data-agcf8-slide-chip></span>'
      + a8PickHTML(key)
      + '</div>';
    var si = slide.querySelector('img');
    si.alt = alt;
    si.onload = function () {

      if (!ph && url && url.indexOf('data:') !== 0) A8.cache[key] = url;
    };
    si.onerror = function () { a8PruneSlide(key); };
    si.src = url;
    slide.querySelector('[data-agcf8-slide-chip]').textContent =
      sim ? 'Finish preview · simulated' : 'Finish preview';

    var pk = slide.querySelector('[data-agcf8-slide-pick]');
    if (pk) {
      pk.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var parts = (slide.getAttribute('data-agcf8-key') || '').split('__');
        a8ApplyPair(parts[1],
                    (parts[2] && parts[2] !== 'none') ? parts[2] : null,
                    parts[3]);
        a8SetEvent(); /* 2026-10-16 round 3: the set pieces render in this pair too */
      });
    }
    if (ph) {

      thumb.classList.add('is-ph');
      slide.classList.add('is-ph');
      var lb0 = slide.querySelector('.product-header_gallery-lightbox');
      if (lb0) lb0.insertAdjacentHTML('beforeend', a8PhLoadHTML());
      var ptag = thumb.querySelector('.agcf8-thumb-tag');
      if (ptag) ptag.textContent = 'Rendering…';
    }
    return { thumb: thumb, slide: slide };
  }
  function a8UpsertSlides(key, url, sim, keep) {
    a8SlickHooks();

    if (a8MMode()) {

      var srb = document.querySelectorAll(
        '.agcf8-slide[data-agcf8-key="' + a8CssKey(key) + '"],'
        + ' .agcf8-thumb[data-agcf8-key="' + a8CssKey(key) + '"]');
      for (var sri = 0; sri < srb.length; sri++) {
        if (srb[sri].parentNode) {
          srb[sri].parentNode.removeChild(srb[sri]);
        }
      }
      return a8MUpsert(key, url, sim);
    }
    var rt = a8RailTrack(), gt = a8GalTrack();
    if (!rt || !gt) return false;
    var pair = a8SlidePair(key);
    if (pair.thumb && pair.slide) {

      if (!keep && rt.firstElementChild !== pair.thumb) {
        rt.insertBefore(pair.thumb, rt.firstElementChild);
      }
      if (!keep && gt.firstElementChild !== pair.slide) {
        gt.insertBefore(pair.slide, gt.firstElementChild);
      }
      var img = pair.slide.querySelector('img');
      if (img && img.getAttribute('src') !== url) img.src = url;

      var tim = pair.thumb.querySelector('img');
      if (tim && tim.getAttribute('src') !== url) tim.src = url;

      if (pair.slide.classList.contains('is-ph')) {
        pair.slide.classList.remove('is-ph');
        pair.thumb.classList.remove('is-ph');
        var ptag2 = pair.thumb.querySelector('.agcf8-thumb-tag');
        if (ptag2) ptag2.textContent = 'Preview';
      }
    } else {
      var built = a8BuildPair(key, url, sim);
      if (!built) return false;
      rt.insertBefore(built.thumb, rt.firstElementChild);
      gt.insertBefore(built.slide, gt.firstElementChild);

      if (!a8Slick()) {
        var h = parseFloat(rt.style.height || '0');
        if (h && A8.slideH) rt.style.height = (h + A8.slideH) + 'px';
      }
    }

    if (!a8Slick()) {
      rt.style.transform = 'translate3d(0px, 0px, 0px)';
    }
    a8Numbers();
    return true;
  }
  function a8PruneSlide(key) {

    if (a8MReal()) {

      a8LedgerDrop(key);
      delete A8.cache[key];
      a8PhSettle(key);
      a8MRemove(key);
      a8Numbers();
      a8Button();
      return;
    }
    if (a8MMode()) {

      if (A8.mKey === key) a8MPark(0);
      a8LedgerDrop(key);
      delete A8.cache[key];
      var mt = a8MThumb();
      if (mt && mt.getAttribute('data-agcf8-key') === key) {
        var l2 = a8LedgerLoad();
        var mine2 = (a8Handle() || 'proto') + '__';
        var nk = null;
        for (var i2 = 0; i2 < l2.order.length; i2++) {
          var k3 = l2.order[i2];
          if (k3.indexOf(mine2) === 0 && l2.items[k3]
              && l2.items[k3].url) { nk = k3; break; }
        }
        if (nk) { a8MThumbMount(nk, l2.items[nk].url); }
        else { a8MThumbUnmount(); }
      }
      a8Numbers();
      a8Button();
      return;
    }
    var rt = a8RailTrack();
    var pair = a8SlidePair(key);
    var wasCurrent = pair.slide
      && pair.slide.classList.contains('slick-current');
    if (pair.thumb && pair.thumb.parentNode) {
      pair.thumb.parentNode.removeChild(pair.thumb);
      if (rt && A8.slideH) {
        var h = parseFloat(rt.style.height || '0');
        if (h) rt.style.height = Math.max(0, h - A8.slideH) + 'px';
      }
    }
    if (pair.slide && pair.slide.parentNode) {
      pair.slide.parentNode.removeChild(pair.slide);
    }
    a8LedgerDrop(key);
    delete A8.cache[key];
    if (wasCurrent) {
      if (a8Slick()) {

        try {
          var $g = window.jQuery('.slick-product-gallery');
          var ci = $g.slick('slickCurrentSlide') || 0;
          var tgt = a8GalTrack() && a8GalTrack().querySelector(
            '.slick-slide[data-slick-index="' + ci + '"]');
          if (tgt) {
            tgt.style.transition = 'none';
            tgt.style.opacity = '1';
            tgt.style.zIndex = '1000';
            tgt.classList.add('slick-current');
            tgt.classList.add('slick-active');
            tgt.setAttribute('aria-hidden', 'false');
          }
        } catch (e) {}
      } else {
        var back = a8RailTrack() && a8RailTrack().querySelector(
          '.slick-slide[data-slick-index="2"]');
        if (back) a8Goto(back, 500);
      }
    }
    a8Numbers();
    a8Button();
  }
  function a8GalSlideFor(thumb) {
    var gt = a8GalTrack();
    if (!gt) return null;
    var key = thumb.getAttribute('data-agcf8-key');
    if (key) {
      return gt.querySelector(
        '.slick-slide[data-agcf8-key="' + a8CssKey(key) + '"]');
    }
    var w = thumb.querySelector('[data-media-id]');
    var id = w && w.getAttribute('data-media-id');
    if (!id) return null;
    var inner = gt.querySelector('[data-media-id="' + id + '"]');
    if (!inner) return null;
    return inner.closest('.slick-track > .slick-slide') || inner;
  }
  function a8CurrentKey() {

    if (a8MReal()) {
      var gt7 = a8GalTrack();
      var c7 = gt7 && gt7.querySelector(
        ':scope > .agcf8-mslide.slick-current:not(.slick-cloned)');
      return c7 ? c7.getAttribute('data-agcf8-key') : null;
    }
    if (a8MMode()) return A8.mKey || null;
    var gt = a8GalTrack();
    var cur = gt && gt.querySelector('.slick-slide.slick-current');
    return cur ? cur.getAttribute('data-agcf8-key') : null;
  }
  function a8BadgeSync() {

    var on = !!a8CurrentKey();
    document.querySelectorAll('.product_badge').forEach(function (b) {
      b.classList.toggle('agcf8-badge-off', on);
    });
    a8DockSync();
    a8BadgeAlign();
  }
  function a8Numbers() {
    a8BadgeSync();
    a8ArrowSync();

    if (a8MMode()) return;
    var gt = a8GalTrack();
    var num = document.querySelector('.slides-numbers');
    if (!gt || !num) return;
    var kids = [].filter.call(gt.children, function (n) {
      return n.classList && n.classList.contains('slick-slide');
    });
    var cur = gt.querySelector('.slick-slide.slick-current');
    var outer = cur ? (cur.closest('.slick-track > .slick-slide') || cur)
      : null;
    var idx = Math.max(1, kids.indexOf(outer) + 1);
    var z = function (n) { return (n < 10 ? '0' : '') + n; };
    var a = num.querySelector('.active'), t = num.querySelector('.total');
    if (a) a.textContent = z(idx);
    if (t) t.textContent = z(kids.length);
  }
  function a8Goto(target, ms) {
    if (a8MReal()) {

      var mk9 = (typeof target === 'string') ? target
        : (target && target.getAttribute
           ? target.getAttribute('data-agcf8-key') : null);
      if (mk9) {
        var nd9 = a8MSlideFind(mk9);
        if (!nd9) {

          var it9 = a8LedgerLoad().items[mk9] || null;
          var u9 = A8.cache[mk9] || (it9 && it9.url);
          if (u9 && a8MUpsert(mk9, u9, it9 ? !!it9.sim : false)) {
            nd9 = a8MSlideFind(mk9);
          }
        }
        if (nd9) {
          var ix9 = parseInt(nd9.getAttribute('data-slick-index'), 10);
          try {
            window.jQuery('.slick-product-gallery')
              .slick('slickGoTo', ix9);
          } catch (e9) {}
        }
      }
      return;
    }
    if (a8MMode()) {

      var mk = (typeof target === 'string') ? target
        : (target && target.getAttribute
           ? target.getAttribute('data-agcf8-key') : null);
      if (mk) {
        var mit = a8LedgerLoad().items[mk] || null;
        var mu = A8.cache[mk] || (mit && mit.url);
        if (mu) a8MShow(mk, mu, mit ? !!mit.sim : false, ms || 500);
      } else {
        a8MPark(ms || 500);
      }
      return;
    }
    var rt = a8RailTrack(), gt = a8GalTrack();
    if (!rt || !gt) return;
    var thumb = target;
    if (typeof target === 'string') thumb = a8SlidePair(target).thumb;
    if (!thumb || !rt.contains(thumb)) return;
    var slide = a8GalSlideFor(thumb);
    if (!slide) return;
    var fade = 'opacity ' + (ms || 500) + 'ms ease';
    var oldT = rt.querySelector('.slick-slide.slick-current');
    var curEl = gt.querySelector('.slick-slide.slick-current');
    var oldS = curEl
      ? (curEl.closest('.slick-track > .slick-slide') || curEl) : null;
    if (oldS && oldS !== slide) {

      oldS.style.transition = fade;
      oldS.style.opacity = '0';
      oldS.style.zIndex = '998';
      oldS.classList.remove('slick-current');
      oldS.classList.remove('slick-active');
      oldS.setAttribute('aria-hidden', 'true');
    }
    if (curEl && curEl !== oldS && curEl !== slide) {
      curEl.classList.remove('slick-current');
      curEl.classList.remove('slick-active');
    }
    if (slide !== oldS) {
      slide.style.transition = fade;

      slide.getBoundingClientRect();
      slide.style.opacity = '1';

      slide.style.zIndex = !a8Slick() ? '999'
        : (slide.classList.contains('agcf8-slide') ? '1001' : '1000');
    }
    slide.classList.add('slick-current');
    slide.classList.add('slick-active');
    slide.setAttribute('aria-hidden', 'false');
    if (oldT && oldT !== thumb) {
      oldT.classList.remove('slick-current');
      oldT.classList.remove('slick-active');
      oldT.setAttribute('aria-hidden', 'true');
    }
    thumb.classList.add('slick-current');
    thumb.classList.add('slick-active');
    thumb.setAttribute('aria-hidden', 'false');
    a8RailTop(thumb);
    a8Numbers();
    a8Button();
  }
  /* 2026-10-18 (Ansen, previews keep their place): on a computer the strip is a slick slider that scrolls to the
     photo showing, so it can sit a row down with the newest preview hidden above it. While a preview shows, the
     strip goes back to its top, where every preview sits; the next photo move hands it back to slick. */
  function a8RailTop(thumb) {
    if (!a8Slick() || a8MMode() || !thumb || !thumb.classList.contains('agcf8-thumb')) return;
    var rt = a8RailTrack();
    if (!rt || !rt.querySelector('.agcf8-thumb')) return;
    rt.style.transform = 'translate3d(0px, 0px, 0px)';
  }
  function a8NavShim() {

    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return;
    rail.addEventListener('click', function (e) {
      if (!a8Slick()) return;
      var s = e.target.closest ? e.target.closest('.slick-slide') : null;
      if (!s || !rail.contains(s)) return;
      if (!s.getAttribute('data-agcf8-key')) return;
      e.preventDefault();
      e.stopPropagation();
      a8Goto(s, 500);
    }, true);
    rail.addEventListener('click', function (e) {
      var s = e.target.closest('.slick-slide');
      if (!s || !rail.contains(s)) return;
      if (a8Slick()) {
        if (s.getAttribute('data-agcf8-key')) return;
        if (!a8CurrentKey()) return;
        a8Goto(s, 500);
        return;
      }
      a8Goto(s, 500);
    });
  }
  function a8ArrowPos() {

    if (!a8Slick() || a8MMode()) return null;
    var rt = a8RailTrack();
    var rs = rt ? [].filter.call(rt.children, function (nd) {
      return nd.getAttribute && nd.getAttribute('data-agcf8-key');
    }) : [];
    var gt = a8GalTrack();
    if (!gt) return null;
    var n = 0;
    [].forEach.call(gt.children, function (nd) {
      if (nd.classList && nd.classList.contains('slick-slide')
          && !(nd.getAttribute && nd.getAttribute('data-agcf8-key'))) {
        n++;
      }
    });
    var ci = 0;
    try {
      ci = window.jQuery('.slick-product-gallery')
        .slick('slickCurrentSlide') || 0;
    } catch (e) { return null; }
    var ck = a8CurrentKey();
    var p = null;
    if (ck) {
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].getAttribute('data-agcf8-key') === ck) { p = i; break; }
      }
      if (p === null) return null;
    } else {
      p = rs.length + ci;
    }
    return { rs: rs, k: rs.length, n: n, ci: ci, p: p };
  }
  function a8ArrowStep(dir) {

    var s = a8ArrowPos();
    if (!s) return { act: 'pass' };
    var q = s.p + dir;
    if (q < 0 || q > s.k + s.n - 1) return { act: 'noop' };
    if (s.p >= s.k) {
      if (q >= s.k) return { act: 'pass' };
      return { act: 'goto', node: s.rs[q] };
    }
    if (q < s.k) return { act: 'goto', node: s.rs[q] };

    if (s.ci === 0) {

      var rt2 = a8RailTrack();
      var pt = rt2 && rt2.querySelector(
        '.slick-slide[data-slick-index="0"]:not(.slick-cloned)');
      return pt ? { act: 'goto', node: pt } : { act: 'pass' };
    }
    return { act: 'slick', ti: 0 };
  }
  function a8ArrowShim() {

    var g = document.querySelector('.slick-product-gallery');
    if (!g) return;
    var run = function (dir, e) {
      if (!a8Slick() || a8MMode()) return;
      var d = a8ArrowStep(dir);
      if (d.act === 'pass') return;
      e.preventDefault();
      e.stopPropagation();
      if (d.act === 'goto') { a8Goto(d.node, 500); }
      else if (d.act === 'slick') {
        try {
          window.jQuery('.slick-product-gallery')
            .slick('slickGoTo', d.ti);
        } catch (e2) {}
      }
    };
    g.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.slick-arrow') : null;
      if (!a || !g.contains(a)) return;
      run(a.classList.contains('slick-next') ? 1 : -1, e);
    }, true);
    g.addEventListener('keydown', function (e) {
      if (e.keyCode !== 37 && e.keyCode !== 39) return;
      run(e.keyCode === 39 ? 1 : -1, e);
    }, true);
  }
  function a8ArrowSync() {

    var c = document.querySelector('.slick-product-gallery-container');
    var g = document.querySelector('.slick-product-gallery');
    if (!c || !g) return;
    var prev = g.querySelector('.slick-prev');
    var next = g.querySelector('.slick-next');
    var mark = function (el, on) {
      if (!el) return;
      el.classList.toggle('agcf8-off', !!on);
      if (on) { el.setAttribute('aria-disabled', 'true'); }
      else { el.removeAttribute('aria-disabled'); }
    };
    var s = a8ArrowPos();
    if (!s || !s.k) {
      c.classList.remove('agcf8-has-r');
      mark(prev, false);
      mark(next, false);
      return;
    }
    c.classList.add('agcf8-has-r');
    mark(prev, s.p === 0);
    mark(next, s.p === s.k + s.n - 1);
  }
  function a8BootLedger() {

    var l = a8LedgerLoad();
    var mine = (a8Handle() || 'proto') + '__';
    var want = 0, did = 0;
    var cs = a8Side();
    for (var i = l.order.length - 1; i >= 0; i--) {

      try {
        var k = l.order[i];
        if (k.indexOf(mine) !== 0) continue;
        var it = l.items[k];
        if (!it || !it.url) continue;
        want++;

        var bk = k, bu = it.url, bs2 = it.sim;
        var kp = k.split('__');
        if (it.sib && kp.length === 4 && kp[3] !== cs
            && (cs === 'left' || cs === 'right')
            && (kp[3] === 'left' || kp[3] === 'right')) {
          bk = kp.slice(0, 3).join('__') + '__' + cs;
          bu = it.sib;
        }
        if (a8UpsertSlides(bk, bu, bs2)) did++;
      } catch (e) {}
    }
    try {
      var xs = window.AGSR && window.AGSR.forHandle
        ? window.AGSR.forHandle(a8Handle(), cs, a8Width()) : [];
      for (var xi = 0; xi < xs.length; xi++) {
        if (l.items[xs[xi].key]) continue;
        want++;
        if (a8UpsertSlides(xs[xi].key, xs[xi].url, false)) did++;
      }
    } catch (e3) {}
    return { want: want, did: did };
  }
  /* 2026-10-16 round 5 (Ansen: "if we're clicking on a product from a custom finish, pre-enter that custom finish"):
     a link from a custom-finish cart line or set card opens this page in that finish -
     ?variant=<size>&agf=<primary>.<accent|none>.<side>&agl=<the piece it came from>. The finish is picked with the
     Custom Finishing panel left closed; its preview shows as the main picture, or, when none is saved, renders here
     with the Generate animation as a set piece (free for the shopper; the service needs the lead's pair saved). */
  function a8CarryParse() {
    var q = window.location.search || '';
    var m = /[?&]agf=([^&#]+)/.exec(q);
    if (!m) return null;
    var parts = decodeURIComponent(m[1]).split('.');
    var l = /[?&]agl=([^&#]+)/.exec(q);
    return { p: parts[0] || '', a: (parts[1] && parts[1] !== 'none') ? parts[1] : null,
             side: parts[2] || '', lead: l ? decodeURIComponent(l[1]) : '' };
  }
  function a8CarryClean() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('agf');
      u.searchParams.delete('agl');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function a8CarryOn(key) { return !!(A8.carry && key && A8.carry.key === key); }
  function a8CarryName(h) {
    var rows = document.querySelectorAll('[data-agsa-handle]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-agsa-handle') !== h) continue;
      var nm = rows[i].querySelector('.ag-name');
      var t = nm ? (nm.textContent || '').trim() : '';
      var cut = t.indexOf('·');
      if (cut > 0) t = t.slice(0, cut).trim();
      if (t) return t;
    }
    var w = String(h || '').split('-')[0];
    return w ? w.charAt(0).toUpperCase() + w.slice(1) : '';
  }
  /* Ansen 2026-10-16: the Generate animation's lines, led by "Building your Winsor to match your Hershey" */
  function a8CarryStages(key) {
    var parts = (key || '').split('__');
    var pf = BY_CODE[parts[1]] || null;
    var af = (parts[2] && parts[2] !== 'none') ? (BY_CODE[parts[2]] || null) : null;
    var p = pf ? pf.name : 'your finish', n = a8ShortName();
    var lead = A8.carry && A8.carry.leadName;
    var out = [[0, lead ? 'Building your ' + n + ' to match your ' + lead
                        : 'Building your preview to match your finishing'],
               [0.16, 'Loading the ' + n + ' model'],
               [0.30, 'Loading ' + p + (af ? ' and ' + af.name : '') + ' into the studio']];
    if (lead) out.push([0.44, 'Building your preview to match your finishing']);
    out.push([0.58, af ? 'Applying each finish to its surfaces'
                       : 'Applying ' + p + ' to the primary surfaces']);
    out.push([0.74, 'Setting the studio lighting']);
    out.push([0.88, 'Verifying the finish match']);
    return out;
  }
  function a8CarryShow(key) {
    if (a8PairHit(key)) return;              /* a8ApplyPair's a8SelNav has already put it on screen */
    var SR = window.AGSR, i;
    var xs = SR && SR.forHandle ? SR.forHandle(a8Handle(), a8Side(), a8Width()) : [];
    var put = function (u) {
      A8.cache[key] = u;
      a8LedgerPut(key, u, false);
      a8SelNav();
      a8CartProps();
    };
    for (i = 0; i < xs.length; i++) {
      if (xs[i].key === key) { put(xs[i].url); return; }
    }
    if (!SR || typeof SR.want !== 'function') { a8Generate(); return; }
    /* still being made (started in this browser, e.g. the line was added mid-render): join that render, the bar
       carrying on from where it is */
    var ago = typeof SR.elapsed === 'function' ? SR.elapsed(key) : 0;
    if (ago > 0 && ago < 300000) { A8.carry.t0 = Date.now() - ago; a8Generate(); return; }
    SR.want({ handle: a8Handle(), p: st.primary.code, a: st.accent ? st.accent.code : '',
              side: a8Side(), size: a8Width() ? String(a8Width()) : '', lead: A8.carry.lead }, { probe: true })
      .then(function (u) {
        if (a8Key() !== key) return;
        if (u) { put(u); return; }
        a8Generate();
      }, function () { if (a8Key() === key) a8Generate(); });
  }
  function a8CarryBoot() {
    var c = a8CarryParse();
    if (!c || !c.p) return;
    a8CarryClean();
    var tries = 0;
    var run = function () {
      try {
        if (!st) throw new Error('agcf not ready');
        if (!BY_CODE[c.p] || (c.a && !BY_CODE[c.a])) return;
        var side = (c.side === 'left' || c.side === 'right') ? c.side : null;
        if (!a8ApplyPair(c.p, c.a, side)) return;
        var key = a8Key();
        if (!key) return;
        var lead = /^[a-z0-9-]+$/.test(c.lead || '') ? c.lead : a8Handle();
        A8.carry = { key: key, lead: lead, t0: 0,
                     leadName: lead !== a8Handle() ? a8CarryName(lead) : '' };
        a8CartProps();
        a8CarryShow(key);
      } catch (e) {
        if (++tries < 12) setTimeout(run, 300);
      }
    };
    run();
  }
  function a8BootRestore() {

    var r = a8BootLedger();
    if (!r.want || r.did >= r.want) return;
    var tries = 0;
    var again = function () {
      var r2 = a8BootLedger();
      if (r2.did >= r2.want || ++tries >= 20) return;
      setTimeout(again, 300);
    };
    setTimeout(again, 300);
  }

  function agcf8Hide() {

    var keys = Object.keys(A8.jobs);
    for (var i = 0; i < keys.length; i++) a8JobKill(keys[i]);
    a8FailClear();
    a8StopTimers();

    if (A8.gateT) { clearTimeout(A8.gateT); A8.gateT = null; }
    A8.live = {};
    A8.generating = false;
    a8Button();
  }
  function a8StopTimers() {
    if (A8.timer) { clearInterval(A8.timer); A8.timer = null; }
    if (A8.exit) { clearTimeout(A8.exit); A8.exit = null; }
  }
  function agcf8OnPick() {
    if (A8.carry && a8Key() !== A8.carry.key) A8.carry = null;
    if (A8.fbKey && a8Key() !== A8.fbKey) {

      a8JobKill(A8.fbKey);
    }

    if (st && st.customOn && st.primary && !A8.applying) {
      a8HistPut(st.primary.code, st.accent ? st.accent.code : null,
                a8ProductName());
    }

    a8CartProps();

    if (!A8_PROTO) {
      try {
        customAdditions().forEach(function (f) { a8SampleFetch(f.code); });
      } catch (e) {}
    }
    a8Button();
  }
  /* 2e + 2e2 (Ansen 2026-10-17): a product keeps its custom finish. The pick is kept for this product in this browser
     (30 days) each time the cart fields are written, and any visit to the product puts it back with a8ApplyPair (a
     saved preview shows, no render starts). A fresh visit to a ?variant= address keeps that variant's side; Back /
     Forward puts the side back too. A carried finish (?agf=) wins; Clear forgets it. A8STICK.ready stays false until
     the restore has run, so the boot's own empty write cannot wipe the pick first. */
  var A8STICK = { pre: 'agcf:pick:', ready: false, maxAge: 30 * 24 * 3600 * 1000,
                  carried: /[?&]agf=/.test(window.location.search || '') };   /* read before a8CarryClean strips it */
  function a8StickSave() {
    if (!A8STICK.ready) return;
    try {
      var h = a8Handle();
      if (!h) return;
      if (!st || !st.customOn || !st.primary) { localStorage.removeItem(A8STICK.pre + h); return; }
      localStorage.setItem(A8STICK.pre + h, JSON.stringify({ p: st.primary.code,
        a: st.accent ? st.accent.code : null, side: a8Side() || '', t: Date.now() }));
    } catch (e) {}
  }
  function a8StickBack() {
    try {
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (nav) return nav.type === 'back_forward';
      return !!(performance.navigation && performance.navigation.type === 2);
    } catch (e) { return false; }
  }
  function a8StickBoot() {
    var c = null;
    var back = a8StickBack();
    if (!A8STICK.carried && !a8CarryParse()) {
      try { c = JSON.parse(localStorage.getItem(A8STICK.pre + a8Handle()) || 'null'); } catch (e) { c = null; }
      if (c && (!c.p || Date.now() - (c.t || 0) > A8STICK.maxAge)) c = null;
    }
    var keepSide = !back && /[?&]variant=/.test(window.location.search || '');
    if (!c) { A8STICK.ready = true; return; }
    var tries = 0;
    var run = function () {
      try {
        if (!st) throw new Error('agcf not ready');
        if (BY_CODE[c.p] && (!c.a || BY_CODE[c.a])) {
          var side = (!keepSide && (c.side === 'left' || c.side === 'right')) ? c.side : null;
          if (a8ApplyPair(c.p, c.a, side)) { A8STICK.ready = true; a8CartProps(); return; }
        }
        A8STICK.ready = true;
      } catch (e) {
        if (++tries < 12) setTimeout(run, 300);
        else A8STICK.ready = true;
      }
    };
    run();
  }
  function a8CartProps() {
    a8StickSave();

    var atcBtn = document.getElementById('add-to-cart-btn');
    var form = atcBtn && atcBtn.closest ? atcBtn.closest('form') : null;
    if (!form) return;
    var names = ['Custom Finishing', '_finish_codes', '_preview', 'Finish preview ID'];   /* 2g: + the ID */
    if (!st || !st.customOn || !st.primary) {
      for (var i = 0; i < names.length; i++) {
        var old = form.querySelector(
          'input[data-agcf14-prop="' + names[i] + '"]');
        if (old) old.parentNode.removeChild(old);
      }
      return;
    }
    var side = a8Side();
    var vis = st.primary.name + (st.accent ? ' & ' + st.accent.name : '');
    var codes = 'P=' + st.primary.code
      + (st.accent ? ';A=' + st.accent.code : '')
      + ';S=' + (side === 'left' ? 'L' : side === 'right' ? 'R' : 'NA');
    var url = '';
    var key = a8Key();
    if (key) {
      if (A8.cache[key]) { url = A8.cache[key]; }
      else {
        var l = a8LedgerLoad();
        if (l.items[key] && l.items[key].url) { url = l.items[key].url; }
        else {

          var want = key.split('__').slice(0, 3).join('__');
          for (var j = 0; j < l.order.length; j++) {
            var k2 = l.order[j];
            if (k2.split('__').slice(0, 3).join('__') === want
                && a8WPart(k2) === a8WPart(key)
                && l.items[k2] && l.items[k2].url) {
              url = l.items[k2].url;
              break;
            }
          }
        }
      }
    }
    if (!url && key && A8.jobs[key] && window.AGSR && window.AGSR.predict) {
      url = window.AGSR.predict({ handle: a8Handle(), p: st.primary.code,
        a: st.accent ? st.accent.code : '', side: a8Side(),
        size: a8Width() ? String(a8Width()) : '' }) || '';
    }
    if (url) a8Prewarm(url);
    var vals = { 'Custom Finishing': vis, '_finish_codes': codes,
                 '_preview': url,
                 'Finish preview ID': a8FpOfKey(key) };
    for (var n = 0; n < names.length; n++) {
      var nm = names[n];
      var inp = form.querySelector(
        'input[data-agcf14-prop="' + nm + '"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + nm + ']';
        inp.setAttribute('data-agcf14-prop', nm);
        form.appendChild(inp);
      }
      inp.value = vals[nm];
    }
  }

  function a8ShortName() {

    var n = a8ProductName();
    var cut = n.indexOf('·');
    if (cut < 0) cut = n.indexOf(' - ');
    if (cut > 0) n = n.slice(0, cut);
    return n.trim() || 'product';
  }
  function a8BtnLabel() {
    var name = a8ShortName();
    if (st && st.primary && st.accent) {
      return 'Preview the ' + name
        + ' in your selected finishings of ' + st.primary.name
        + ' (PRIMARY) and ' + st.accent.name + ' (ACCENT)';
    }
    if (st && st.primary) {
      return 'Preview the ' + name
        + ' in your selected finishing of ' + st.primary.name;
    }
    return 'Preview the ' + name + ' with your selected custom finishing';
  }
  function a8Stages() {
    return a8StagesFrom(st.primary.name,
                        st.accent ? st.accent.name : null);
  }
  function a8StagesFrom(p, a) {

    var n = a8ShortName();
    if (a) {
      return [[0, 'Opening the finishing studio'],
              [0.16, 'Loading the ' + n + ' model'],
              [0.30, 'Loading ' + p + ' into the studio'],
              [0.44, 'Loading ' + a + ' into the studio'],
              [0.58, 'Applying each finish to its surfaces'],
              [0.74, 'Setting the studio lighting'],
              [0.88, 'Verifying the finish match']];
    }
    return [[0, 'Opening the finishing studio'],
            [0.20, 'Loading the ' + n + ' model'],
            [0.38, 'Loading ' + p + ' into the studio'],
            [0.58, 'Applying ' + p + ' to the primary surfaces'],
            [0.76, 'Setting the studio lighting'],
            [0.88, 'Verifying the finish match']];
  }
  function a8SetStage(p, text) {

    var s0 = a8N(p, 's0'), s1 = a8N(p, 's1');
    if (!s0 || !s1) return;
    var showing = s0.classList.contains('is-on') ? s0 : s1;
    var hidden = showing === s0 ? s1 : s0;
    hidden.textContent = text;
    hidden.classList.add('is-on');
    showing.classList.remove('is-on');
  }
  function a8Loading(on) {

    var p = ensurePreview();
    if (!p) return null;
    a8N(p, 'load').classList.toggle('is-on', !!on);
    p.classList.remove('is-fade');
    a8N(p, 'chip').textContent = on ? 'Rendering' : '';
    if (on) {
      p.classList.add('is-show');
      var art = a8N(p, 'art');
      var fill = a8N(p, 'fill'), eta = a8N(p, 'eta');

      art.innerHTML = '<svg viewBox="0 0 240 120" aria-hidden="true">'
        + A8_ART + '</svg>';
      fill.style.width = '0%';
      eta.textContent = 'About a minute · add to cart anytime';

      if (A8.gateT) { clearTimeout(A8.gateT); A8.gateT = null; }
      var job = A8.fbKey ? A8.jobs[A8.fbKey] : null;
      if (job) {
        job.t0 = Date.now();
        job.li = 0;
        job.lastAt = Date.now();
        a8SetStage(p, job.stages[0][1]);
      } else {
        a8SetStage(p, a8Stages()[0][1]);
      }
      a8PhTickArm();
    } else { a8StopTimers(); }
    return p;
  }
  function a8LoaderExit(p, done) {

    var load = a8N(p, 'load');
    if (!load || !load.classList.contains('is-on')
        || !p.classList.contains('is-show')) { done(); return; }
    a8N(p, 'fill').style.width = '100%';
    A8.exit = setTimeout(function () {
      p.classList.add('is-fade');
      done();
      A8.exit = setTimeout(function () {
        p.classList.remove('is-show');
        p.classList.remove('is-fade');
        load.classList.remove('is-on');
        a8N(p, 'chip').textContent = '';
      }, 400);
    }, 250);
  }

  function a8Vid() {

    if (A8.vid) return A8.vid;
    var v = null;
    try { v = localStorage.getItem('agcf8:vid'); } catch (e) {}

    if (typeof v !== 'string' || v.length < 8 || v.length > 64
        || /[^A-Za-z0-9-]/.test(v)) {
      v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : ('v' + Date.now().toString(36)
           + Math.random().toString(36).slice(2, 12));
      try { localStorage.setItem('agcf8:vid', v); } catch (e2) {}
    }
    A8.vid = v;
    return v;
  }
  function a8Turnstile() {

    if (A8.tsReady) return A8.tsReady;
    A8.tsReady = new Promise(function (resolve, reject) {
      if (window.turnstile) { resolve(window.turnstile); return; }
      var tsT = setTimeout(function () {
        A8.tsReady = null;
        reject(new Error('widget timeout'));
      }, 20000);
      window.agcf8TsReady = function () {
        clearTimeout(tsT);
        resolve(window.turnstile);
      };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
        + '?onload=agcf8TsReady&render=explicit';
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        clearTimeout(tsT);
        A8.tsReady = null;
        reject(new Error('widget unavailable'));
      };
      document.head.appendChild(s);
    });
    return A8.tsReady;
  }
  function a8GateArt(p, scene) {

    if (!p) return;
    var a = a8N(p, 'gate-art');
    if (!a) return;
    a.innerHTML = A8_GART[scene]
      ? '<svg aria-hidden="true" focusable="false" viewBox="0 0 240 120">' + A8_GART[scene] + '</svg>' : '';
  }
  function a8GateReset(p) {

    if (!p) return;
    var load = a8N(p, 'load');
    if (load) load.classList.remove('is-gate');
    var ga = a8N(p, 'gate-art');
    if (ga) ga.innerHTML = '';
    var gc = a8N(p, 'gate-copy');
    if (gc) gc.textContent = '';
    var gs = a8N(p, 'gate-sub');
    if (gs) gs.textContent = '';
    if (A8.gateWidget !== null && window.turnstile) {
      try { window.turnstile.remove(A8.gateWidget); } catch (e) {}
    }
    A8.gateWidget = null;
    var gb = a8N(p, 'gate-box');
    if (gb) gb.innerHTML = '';
  }
  function a8GateBusy() {

    var p = ensurePreview();
    if (!p) return;
    if (p.classList.contains('is-show')) return;
    var load = a8N(p, 'load');
    if (!load) return;
    load.classList.add('is-on');
    load.classList.add('is-gate');
    p.classList.add('is-show');
    p.classList.remove('is-fade');
    var chip = a8N(p, 'chip');
    if (chip) chip.textContent = '';
    var copy = a8N(p, 'gate-copy');
    if (copy) copy.textContent = A8_GATE_BUSY;
    var sub = a8N(p, 'gate-sub');
    if (sub) sub.textContent = A8_GATE_BUSY_SUB;
    var gb = a8N(p, 'gate-box');
    if (gb) gb.innerHTML = '';
    a8GateArt(p, 'busy');
    if (A8.busyT) clearTimeout(A8.busyT);
    A8.busyT = setTimeout(function () {
      A8.busyT = null;

      var lp = a8N(p, 'load');
      if (!lp || !lp.classList.contains('is-gate')) return;
      a8GateReset(p);
      p.classList.remove('is-show');
      lp.classList.remove('is-on');
      a8Button();
    }, 4000);
  }
  function a8GateFail(token, why) {

    var key = A8.live[token];
    if (key) a8GateHost(key);
    var p = ensurePreview();
    if (!p) return;
    if (!key || A8.fbKey === key) a8StopTimers();
    var load = a8N(p, 'load');
    if (load) { load.classList.add('is-on'); load.classList.add('is-gate'); }
    p.classList.add('is-show');
    p.classList.remove('is-fade');
    var chip = a8N(p, 'chip');
    if (chip) chip.textContent = '';
    var copy = a8N(p, 'gate-copy');
    if (copy) copy.textContent = (why === 'cap') ? A8_GATE_CAP : A8_GATE_ERR;

    var gs = a8N(p, 'gate-sub');
    if (gs) {
      gs.textContent = (why === 'cap') ? A8_GATE_CAP_SUB : A8_GATE_ERR_SUB;
    }
    a8GateArt(p, (why === 'cap') ? 'cap' : 'err');

    if (A8.gateWidget !== null && window.turnstile) {
      try { window.turnstile.remove(A8.gateWidget); } catch (e) {}
    }
    A8.gateWidget = null;
    var gb = a8N(p, 'gate-box');
    if (gb) gb.innerHTML = '';
    var jb0 = key ? A8.jobs[key] : null;
    if (jb0) jb0.tap = false;

    if (A8.gateT) clearTimeout(A8.gateT);
    A8.gateT = setTimeout(function () {
      A8.gateT = null;
      if (key && A8.jobs[key]) { a8JobKill(key); return; }
      a8FailClear();
      a8Button();
    }, 7000);
  }
  function a8Gate(token, sitekey, retryFn) {
    var key = A8.live[token];
    if (key) a8GateHost(key);
    var p = ensurePreview();
    if (!p) return;
    var load = a8N(p, 'load');
    if (!load) return;

    if (!key || A8.fbKey === key) a8StopTimers();

    load.classList.add('is-on');
    load.classList.add('is-gate');
    p.classList.add('is-show');
    var copy = a8N(p, 'gate-copy'), sub = a8N(p, 'gate-sub');
    var box = a8N(p, 'gate-box');
    if (copy) copy.textContent = A8_GATE_HEAD;
    if (sub) sub.textContent = A8_GATE_SUB;
    a8GateArt(p, 'chal');
    if (box) box.innerHTML = '';
    a8Turnstile().then(function (ts) {
      if (a8TokDead(token) || !box) return;
      A8.gateWidget = ts.render(box, {
        sitekey: sitekey,
        appearance: 'interaction-only',
        callback: function (cfToken) {
          if (a8TokDead(token)) return;
          a8GateReset(p);

          if (!key || A8.fbKey === key) {
            a8Loading(true);
          } else {

            load.classList.remove('is-on');
            p.classList.remove('is-show');
            a8GateHome();
            a8PhRestart(key);
          }
          retryFn(cfToken);
        },
        'error-callback': function () { a8GateFail(token); },
        'expired-callback': function () {
          try { ts.reset(A8.gateWidget); } catch (e) {}
        }
      });
    }, function () { a8GateFail(token); });
  }
  function a8Usage(j) {

    var badge = document.querySelector('[data-agcf8-server]');
    if (!badge || !j || typeof j.used !== 'number') return;
    badge.textContent = 'fal: live · ' + j.used + '/' + (j.limit || 3)
      + ' today';
  }
  function a8JobUrl(j) {

    var u = (j && j.url) || '';
    return /^https?:/i.test(u) ? u : a8GenBase() + u;
  }
  function a8JobFetch(token, qs, cfToken, done, onGate, onErr) {

    var deadline = Date.now() + 300000;

    var pollMiss = 0;
    var poll = function (id) {
      if (a8TokDead(token)) return;
      if (Date.now() > deadline) { onErr(); return; }
      setTimeout(function () {
        if (a8TokDead(token)) return;
        fetch(a8GenBase() + '/jobs/' + encodeURIComponent(id) + '?b=r29')
          .then(function (r) {
            if (!r.ok) throw new Error('job ' + r.status);
            return r.json();
          })
          .then(function (j) {
            if (a8TokDead(token)) return;
            pollMiss = 0;
            if (j && j.status === 'done' && j.url) {
              a8Usage(j); done(a8JobUrl(j), false, j); return;
            }
            if (j && j.status === 'failed') { onErr(); return; }
            poll(id);
          })
          .catch(function () {
            if (a8TokDead(token)) return;
            pollMiss += 1;
            if (pollMiss > 2) { onErr(); return; }
            poll(id);
          });
      }, 2500);
    };

    var ac = (typeof AbortController === 'function')
      ? new AbortController() : null;
    var settled = false;
    var watchdog = setTimeout(function () {
      if (settled) return;
      settled = true;
      if (ac) { try { ac.abort(); } catch (e) {} }
      if (a8TokDead(token)) return;
      onErr();
    }, 15000);
    fetch(a8GenBase() + '/jobs' + qs
          + (cfToken ? '&cf_token=' + encodeURIComponent(cfToken) : ''),
          ac ? { method: 'POST', signal: ac.signal } : { method: 'POST' })
      .then(function (r) {
        if (settled) return;
        settled = true;
        clearTimeout(watchdog);
        if (r.status === 429) {
          r.json().then(function (j) {
            if (a8TokDead(token)) return;
            onGate(j);
          }, function () {
            if (a8TokDead(token)) return;
            onGate(null);
          });
          return;
        }
        /* 2026-10-27: a refusal (400 unknown handle, 503, 500) or an answer with no job ends the render here. It
           used to throw into the .catch below, which returns at once because this answer already set `settled`, so
           onErr never ran and the Generate animation froze with no picture and no message (the Idyll set piece). */
        if (!r.ok) { if (!a8TokDead(token)) onErr(); return; }
        return r.json().then(function (j) {
          if (a8TokDead(token)) return;
          if (j && j.status === 'done' && j.url) {

            a8Usage(j); done(a8JobUrl(j), false, j); return;
          }
          var id = j && (j.job || j.id);
          if (id) { poll(id); return; }
          onErr();
        }, function () { if (!a8TokDead(token)) onErr(); });
      })
      .catch(function () {
        if (settled) return;
        settled = true;
        clearTimeout(watchdog);
        if (a8TokDead(token)) return;
        onErr();
      });
  }
  function a8Retry(token, qs, cfToken, done, fallback, again) {

    a8JobFetch(token, qs, cfToken, done, function (j) {
      if (a8TokDead(token)) return;
      if (!again) {

        if (window.turnstile) {
          try { window.turnstile.reset(A8.gateWidget); } catch (e) {}
        }
        a8Gate(token, j && j.sitekey, function (t2) {
          a8Retry(token, qs, t2, done, fallback, 1);
        });
        return;
      }
      a8GateFail(token);
    }, function () { a8GateFail(token); });
  }
  function a8Reveal(key, url, simulated) {
    var job = A8.jobs[key];
    var commit = function () {

      var ph = !!job && A8.fbKey !== key;
      if (ph && !a8PhIsCurrent(key)) {

        a8PhCalm(key);
        a8PhSettle(key);
        a8UpsertSlides(key, url, simulated);
        if (job) job.tap = false;
        a8JobEnd(key);
        a8Button();
        if (typeof drawerIsOpen === 'function' && drawerIsOpen()) {
          buildDrawer();
        }
        return;
      }
      a8PhExit(key, function () {
        a8UpsertSlides(key, url, simulated);
        if (ph) {

          setTimeout(function () { a8PhSettle(key); }, 700);
        } else {
          a8Goto(key, 800);
        }
        if (job && job.tap) {
          job.tap = false;

          a8ScrollGen();
        }
        a8JobEnd(key);
        a8Button();

        if (typeof drawerIsOpen === 'function' && drawerIsOpen()) {
          buildDrawer();
        }
      });
    };

    var im = new Image();
    im.onload = function () {
      if (im.decode) { im.decode().then(commit, commit); } else { commit(); }
    };
    im.onerror = function () {

      a8LedgerDrop(key);
      delete A8.cache[key];
      a8GateFail(job ? job.tok : 0);
    };
    im.src = url;
  }

  function a8Trk(k, d) {
    try {
      document.dispatchEvent(new CustomEvent(
        'agcf:track', { detail: { k: k, d: d } }));
    } catch (e) {}
  }
  function a8SetEvent() {
    if (!st || !st.primary) return;
    try {
      window.dispatchEvent(new CustomEvent('agcf:generate', { detail: {
        handle: a8Handle(), p: st.primary.code,
        a: st.accent ? st.accent.code : '',
        name: st.primary.name + (st.accent ? ' & ' + st.accent.name : '') } }));
    } catch (e) {}
  }
  /* 2026-10-16: a width change on a per-width product. A known preview shows at once; else, when the shopper
     already has a real preview of this pair at another width, this width renders too, free, as they watch. */
  function a8WidthChange() {
    if (!a8Width() || !st || !st.customOn || !st.primary) return;
    var key = a8Key();
    if (!key) return;
    a8CartProps();
    if (A8.jobs[key] || a8PairHit(key)) { a8SelNav(); a8Button(); return; }
    var pre = key.split('__').slice(0, 3).join('__') + '__';
    var l = a8LedgerLoad(), had = false;
    for (var j = 0; j < l.order.length && !had; j++) {
      var k2 = l.order[j];
      if (k2.indexOf(pre) === 0 && l.items[k2] && l.items[k2].url
          && !l.items[k2].sim) had = true;
    }
    if (!had) { a8Button(); return; }
    A8.widthFree = true;
    try { a8Generate(); } finally { A8.widthFree = false; }
  }
  /* 2026-10-18 (Ansen: "refresh, or go to the home page and come back, while a custom finish renders: the rendering
     preview is gone, while the matching set pieces still render"): a render that starts is noted in this browser
     (agcf8:inflight:v1, key -> start time, kept 10 minutes). When that product's page opens again with the same pick and
     no saved preview, it asks the service once, free (&derive=1: joins the job still running, or answers the finished
     preview; 204 when there is neither, and the note goes), and shows it rendering again from where it is. Nothing new
     is ever started or counted; the result lands as usual. */
  var A8_IF_KEY = 'agcf8:inflight:v1', A8_IF_MS = 600000;
  function a8InflightAll() {
    try { var o = JSON.parse(localStorage.getItem(A8_IF_KEY) || '{}'); return o && typeof o === 'object' ? o : {}; }
    catch (e) { return {}; }
  }
  function a8InflightSave(o) {
    try {
      var now = Date.now();
      for (var k in o) { if (!o[k] || now - o[k] > A8_IF_MS) delete o[k]; }
      localStorage.setItem(A8_IF_KEY, JSON.stringify(o));
    } catch (e) {}
  }
  function a8InflightPut(key, t0) { var o = a8InflightAll(); o[key] = t0 || Date.now(); a8InflightSave(o); }
  function a8InflightDrop(key) { var o = a8InflightAll(); if (o[key]) { delete o[key]; a8InflightSave(o); } }
  function a8ResumeCheck() {
    var key = a8Key();
    if (!key || !st || !st.primary || A8.jobs[key] || a8PairHit(key)) return;   /* the look-up itself says if the service is up */
    var t0 = a8InflightAll()[key];
    if (!t0 || Date.now() - t0 > A8_IF_MS) return;
    var qs = '?primary=' + encodeURIComponent(st.primary.code)
      + (st.accent ? '&accent=' + encodeURIComponent(st.accent.code) : '')
      + '&src=' + encodeURIComponent(a8Side())
      + a8HandleQS()
      + '&vid=' + encodeURIComponent(a8Vid())
      + (a8Width() ? '&size=' + a8Width() : '')
      + '&derive=1&b=r29';
    fetch(a8GenBase() + '/jobs' + qs, { method: 'POST' }).then(function (r) {
      if (r.status !== 200 && r.status !== 202) { a8InflightDrop(key); return; }
      if (a8Key() !== key || A8.jobs[key] || a8PairHit(key)) return;
      A8.resume = { key: key, t0: t0 };
      a8Generate();
    }).catch(function () {});
  }
  function a8ResumeArm() {
    var tries = 0;
    (function tick() {
      if (A8STICK.ready) { setTimeout(a8ResumeCheck, 300); return; }
      if (++tries < 40) setTimeout(tick, 250);
    })();
  }
  function a8Generate() {
    var key = a8Key();
    if (!key) return;
    if (A8.jobs[key]) {

      a8Goto(key, 500);
      return;
    }
    var hit29 = a8PairHit(key);
    if (hit29 && hit29.url) {

      var known = hit29.url;
      var sim = hit29.sim;

      var pv = new Image();
      pv.onload = function () {
        a8UpsertSlides(key, known, sim);
        a8LedgerPut(key, known, sim);

        a8Trk('render', { url: known, hit: 1 });
        a8CartProps();
        a8Goto(key, 500);
        a8ScrollGen();
      };
      if (!a8CarryOn(key)) a8SetEvent();
      pv.onerror = function () {
        a8LedgerDrop(key);
        delete A8.cache[key];
        a8GateFail(0);
      };
      pv.src = known;
      return;
    }

    if (a8JobCount() >= A8_JOBS_MAX) {
      announce(A8_GATE_BUSY + ' · ' + A8_GATE_BUSY_SUB);
      a8GateBusy();
      return;
    }
    var token = ++A8.token;

    /* 2026-10-18: resume mode = a render still running from before a refresh or another page (a8ResumeCheck) */
    var rs = (A8.resume && A8.resume.key === key) ? A8.resume : null;
    A8.resume = null;
    if (!rs) a8Trk('gen');
    A8.live[token] = key;
    A8.jobs[key] = { tok: token, t0: rs ? rs.t0 : ((a8CarryOn(key) && A8.carry.t0) || Date.now()), li: 0,
                     lastAt: Date.now(),
                     stages: a8CarryOn(key) ? a8CarryStages(key) : a8StagesFor(key),
                     tap: true, exit: null };
    A8.generating = true;
    if (!rs) a8InflightPut(key, A8.jobs[key].t0);   /* 2026-10-18: kept across a refresh or another page */
    a8CartProps(); /* 2026-10-16: the line added mid-render carries the predicted preview */

    if (a8PhMount(key, false)) {
      var nd0 = a8JobNode(key);
      if (nd0) {
        var st0 = nd0.querySelector('[data-agcf8-phstage]');
        if (st0) st0.textContent = A8.jobs[key].stages[0][1];
      }
      a8PhTickArm();
    } else {
      if (a8JobCount() > 1) {

        delete A8.jobs[key];
        delete A8.live[token];
        A8.generating = a8JobCount() > 0;
        return;
      }
      A8.fbKey = key;
      a8Loading(true);
    }
    a8Button();
    if (!rs) a8ScrollGen();   /* a resumed render never moves the page */
    var done = function (url, simulated, j) {
      if (a8TokDead(token)) return;
      A8.cache[key] = url;

      var sib;
      if (j && j.sibling_url) {
        sib = /^https?:/i.test(j.sibling_url) ? j.sibling_url
          : a8GenBase() + j.sibling_url;
      }
      a8LedgerPut(key, url, simulated, sib);
      a8InflightDrop(key);

      a8Trk('render', { url: url, sim: simulated });
      a8CartProps();
      a8Reveal(key, url, simulated);
    };
    var fallback = function () {
      if (a8TokDead(token)) return;

      setTimeout(function () {
        if (a8TokDead(token)) return;
        done(new URL(st.accent ? A8_SIM.pair : A8_SIM.single,
                     location.href).href, true);
      }, 12000);
    };
    if (A8.server === false && !rs) {   /* resumed: the look-up just answered, so the service is up */

      if (!A8_PROTO) { a8GateFail(token); return; }
      fallback(); return;
    }
    var qs = '?primary=' + encodeURIComponent(st.primary.code)
      + (st.accent ? '&accent=' + encodeURIComponent(st.accent.code) : '')
      + '&src=' + encodeURIComponent(a8Side())
      + a8HandleQS()
      + '&vid=' + encodeURIComponent(a8Vid())
      + (a8Width() ? '&size=' + a8Width() : '')
      + (A8.widthFree ? '&set=1&lead=' + encodeURIComponent(a8Handle()) : '')
      + (!A8.widthFree && a8CarryOn(key) ? '&set=1&lead=' + encodeURIComponent(A8.carry.lead) : '')
      + (rs ? '&derive=1' : '')   /* resume: join only, never a new render */
      + '&b=r29';
    if (!rs && !A8.widthFree && !a8CarryOn(key)) a8SetEvent();

    a8JobFetch(token, qs, null, done, function (j) {
      if (a8TokDead(token)) return;
      if (a8CarryOn(key) && !(j && j.sitekey)) { A8.carry = null; a8JobKill(key); return; }
      if (!j || !j.sitekey) {

        a8GateFail(token, (j && (j.error === 'daily_capacity'
          || (j.error === 'rate_limited' && j.captcha === false)))
          ? 'cap' : null);
        return;
      }
      a8Gate(token, j.sitekey, function (cfToken) {
        a8Retry(token, qs, cfToken, done, fallback, 0);
      });
    }, A8_PROTO ? fallback : function () {
      if (a8CarryOn(key)) { A8.carry = null; a8JobKill(key); return; }
      a8GateFail(token);
    });
  }

  /* 2026-10-16 (Ansen, options page https://claude.ai/artifact/1wzXoydFBeKYnyRf3xKkKi; picks: A, the finish names in
     the button, a bar while it renders): the preview button shows the picked finishes as swatches and names them;
     while this preview renders it says so over a thin sage bar; once the preview shows, "Preview ready". Screen
     readers keep the full sentence (a8BtnLabel). The look is in agcf.css ("the preview button, 2026-10-16"). */
  function a8BtnNames() {
    if (!st || !st.primary) return '';
    var p = st.primary.name || '', a = st.accent ? (st.accent.name || '') : '';
    if (a && /^pantone\s/i.test(p) && /^pantone\s/i.test(a)) a = a.replace(/^pantone\s+/i, '');
    return p + (a ? ' + ' + a : '');
  }
  function a8BtnChip(f) {
    var c = document.createElement('span');
    c.className = 'agcf8-btn-chip';
    var src = f && f.image ? cdn(f.image, 80) : '';
    if (src) c.style.backgroundImage = 'url("' + String(src).replace(/"/g, '%22') + '")';
    else if (f && f.hex) c.style.backgroundColor = f.hex;
    return c;
  }
  function a8BtnShow() {
    var key = a8Key();
    if (!key) return;
    a8Goto(key, 500);
    var g = gallery();
    if (!g) return;
    var r = g.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (r.top >= 0 && r.bottom <= vh) return;
    var rm = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { g.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' }); }
    catch (err) { g.scrollIntoView(); }
  }
  function a8BtnPaint(b, key, mine, busy) {
    var lbl = b.querySelector('[data-agcf8-btn-label]');
    if (!lbl) return;
    if (!lbl.querySelector('[data-agcf8-btn-l1]')) {
      lbl.innerHTML = '<span class="agcf8-btn-l1" data-agcf8-btn-l1></span>'
        + '<span class="agcf8-btn-l2" data-agcf8-btn-l2></span>';
      var go = document.createElement('span');
      go.className = 'agcf8-btn-go';
      go.setAttribute('aria-hidden', 'true');
      go.setAttribute('data-agcf8-btn-go', '');
      b.appendChild(go);
      var bar = document.createElement('span');
      bar.className = 'agcf8-btn-bar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<i></i>';
      b.appendChild(bar);
    }
    if (!A8.btnMq && window.matchMedia) {
      /* the layout the button speaks of: the gallery sits above the button up to 991px (a8ScrollGen's line) */
      A8.btnMq = window.matchMedia('(max-width: 991px)');
      try { A8.btnMq.addEventListener('change', a8Button); }
      catch (e0) { try { A8.btnMq.addListener(a8Button); } catch (e1) {} }
    }
    var stacked = !!(A8.btnMq && A8.btnMq.matches);
    var names = a8BtnNames();
    var rendering = !!(mine || A8.fbKey);
    /* ready = this pick's preview exists; showing = it is the gallery's current picture */
    var ready = !rendering && !!key && !!a8PairHit(key);
    var showing = ready && a8CurrentKey() === key;
    var full = !rendering && !ready && !!busy;
    var l1 = rendering ? 'Rendering in ' + names : ready ? 'Preview ready' : 'Preview in ' + names;
    var l2 = rendering ? 'About a minute · add to cart anytime'
      : ready ? (showing ? (stacked ? 'Showing above' : 'Showing on the left') : 'Press to see it') + ' · ' + names
      : full ? 'Another preview is still rendering' : 'Free · about a minute';
    var e1 = lbl.querySelector('[data-agcf8-btn-l1]'), e2 = lbl.querySelector('[data-agcf8-btn-l2]');
    if (e1.textContent !== l1) e1.textContent = l1;
    if (e2.textContent !== l2) e2.textContent = l2;
    var g = b.querySelector('[data-agcf8-btn-go]');
    var arrow = rendering ? '' : ready ? (stacked ? '↑' : '←') : '→';
    if (g && g.textContent !== arrow) g.textContent = arrow;
    /* the swatches, redrawn only when the pair changes */
    var cap = b.querySelector('[data-agcf8-btn-cap]');
    var pair = st && st.primary ? st.primary.code + '|' + (st.accent ? st.accent.code : '') : '';
    if (cap && cap.getAttribute('data-agcf8-pair') !== pair) {
      cap.setAttribute('data-agcf8-pair', pair);
      cap.innerHTML = '';
      if (st && st.primary) {
        cap.appendChild(a8BtnChip(st.primary));
        if (st.accent) cap.appendChild(a8BtnChip(st.accent));
      }
    }
    /* the bar starts where this render really is (round 3's rule for every bar) */
    var was = b.classList.contains('is-rendering');
    b.classList.toggle('is-rendering', rendering);
    b.classList.toggle('is-ready', ready);
    b.classList.toggle('is-full', full);
    if (rendering && !was) {
      var job = key && A8.jobs[key];
      var bi = b.querySelector('.agcf8-btn-bar > i');
      if (bi) {
        bi.style.animation = 'none';
        void bi.offsetWidth;
        bi.style.animation = '';
        bi.style.animationDelay = (-(job ? Math.max(0, Date.now() - job.t0) : 0) / 1000).toFixed(2) + 's';
      }
    }
    var aria = rendering ? 'Rendering your preview in ' + names
      : ready ? 'Preview ready: show the ' + names + ' preview' : a8BtnLabel();
    if (b.getAttribute('aria-label') !== aria) b.setAttribute('aria-label', aria);
  }
  function a8Button() {
    var b = A8.btn;
    if (!b) return;
    var key = a8Key();

    var mine = !!(key && A8.jobs[key]);
    var busy = mine || !!A8.fbKey
      || (!!key && a8CurrentKey() === key)
      || a8JobCount() >= A8_JOBS_MAX;
    a8BtnPaint(b, key, mine, busy); /* 2026-10-16: swatches, the finish names, a bar while it renders */
    b.classList.toggle('is-show', !!key);
    var was = b.classList.contains('is-busy');
    b.classList.toggle('is-busy', busy);
    b.disabled = !key || (busy && !b.classList.contains('is-ready'));
    b.setAttribute('aria-busy', mine || !!A8.fbKey ? 'true' : 'false');

    if (busy && !was) a8BtnCapDraw();
    a8Place();
  }
  function a8MatchQtyHeight() {

    var b = A8.btn;
    if (!b) return;
    b.style.height = '';
    a8BtnCapFit();
  }
  function a8BtnCapFit() {
    /* R44 (Datch 2026-09-07): the cap no longer stretches to a JS-measured
       square - it's a fixed-size icon sized by CSS now, not an isolated box. */
  }
  function a8BtnCapDraw() {
    /* 2026-10-16: the button's cap holds the picked finishes' swatches now (a8BtnPaint); the desk drawing stays
       in the gallery's rendering slide */
  }
  function a8Place() {
    var b = A8.btn;
    if (!b) return;
    var want = A8.place;
    if (b.getAttribute('data-agcf8-at') !== want) {
      var host = null;
      if (want === 'p1') host = document.querySelector('.agcf-ghost-cell');
      if (want === 'p2') {

        var band = document.querySelector('.agcf-band');
        var row = document.getElementById('add-to-cart-container');
        if (band && band.parentNode) {
          band.insertAdjacentElement('afterend', b);
          b.setAttribute('data-agcf8-at', want);
        } else if (row && row.parentNode) {

          row.parentNode.insertBefore(b, row);
          b.setAttribute('data-agcf8-at', want);
        }
      } else if (want === 'p3') {
        host = gallery();
      }
      if (want !== 'p2' && host) {
        host.appendChild(b);
        b.setAttribute('data-agcf8-at', want);
      }
      b.className = 'agcf8-btn agcf8-btn--' + want
        + (b.classList.contains('is-show') ? ' is-show' : '')
        + (b.classList.contains('is-busy') ? ' is-busy' : '');
    }
    a8MatchQtyHeight();

    a8BtnCapFit();
  }
  /* PDP polish (Ansen 2026-10-17, board 3A): pressing the Preview button folds the Custom Finishing panel (toggleBand's
     close: the band's own 0.3s fold), so the picture, the button and the set card's pieces are what the shopper sees
     while everything renders; "Change selection?" opens it again */
  function a8FoldBand() {
    var band = q('.agcf-band');
    if (!band || !band.classList.contains('is-open')) return;
    band.classList.remove('is-open');
    var ghost = q('.agcf-ghost');
    if (ghost) setExpanded(ghost, false);
    updateChanger();
  }
  function agcf8Boot() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'agcf8-btn agcf8-btn--p2';
    b.setAttribute('data-agcf8-btn', '');

    b.innerHTML = '<span class="agcf8-btn-cap" data-agcf8-btn-cap'
      + ' aria-hidden="true"><svg aria-hidden="true" focusable="false" viewBox="0 0 240 120">' + A8_ART
      + '</svg></span>'
      + '<span class="agcf8-btn-label" data-agcf8-btn-label>'
      + esc(a8BtnLabel()) + '</span>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      a8FoldBand();
      if (b.classList.contains('is-ready')) { a8BtnShow(); return; }
      a8Generate();
    });
    A8.btn = b;
    a8Place();

    a8GdHelp();
    window.addEventListener('resize', a8MatchQtyHeight);
    window.addEventListener('resize', a8SyncSlideW);

    window.addEventListener('load', a8MatchQtyHeight);
    window.addEventListener('load', a8SyncSlideW);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      /* R44 (Datch 2026-09-07): the ATC button's price span only followed
         Return Desk/Reception Configuration changes - a Size change swaps
         the variant (and #product-main-price) but left the button stale.
         .product-variant-option is the theme's own marker for every
         variant-affecting control (dawn-variant-selector.js), so this
         covers Size and any future option the same way. */
      if (t.classList && t.classList.contains('product-variant-option')) {
        updateAtcPrice();
        if (t.name === 'Size') a8WidthChange();
      }
      if (A8_SIDE_NAMES.indexOf(t.name) < 0) return;
      updateAtcPrice();

      if (st && st.customOn) {
        var k29 = a8Key();
        if (k29 && (A8.jobs[k29] || a8PairHit(k29))) a8Latch();
      }
      a8SideSwap();
      a8CartProps();
      a8Button();
      if (window.matchMedia
          && window.matchMedia('(min-width: 769px)').matches) {
        a8ScrollSel();
      }
    });
    a8CartShim();
    a8SurFold();
    a8PayBoot();
    a8NavShim();
    a8ArrowShim();
    a8VarNavGate();
    a8MFieldGuard();
    a8SlickHooks();
    a8BootRestore();
    a8CarryBoot(); /* 2026-10-16 round 5: a link carried a custom finish */
    a8StickBoot(); /* 2e: Back keeps the custom finish */
    a8ResumeArm(); /* 2026-10-18: a render still running from before shows rendering again */
    a8BadgeSync();
    a8HistMount();
    a8FamIcons();
    a8ClearCell();
    a8PfBoot();
    a8SwipeBar();
    a8RailNav();
    a8PopFx();
    a8AgspSkin();
    a8StockSheet();
    a8FocusGate();
    a8LiveSheet();
    a8BadgeAlign();
    window.addEventListener('resize', a8BadgeAlign);
    window.addEventListener('load', a8BadgeAlign);

    document.addEventListener('click', function (e) {
      var sm = e.target.closest ? e.target.closest('.agcf-pop5-sample') : null;
      if (!sm || isMobile()) return;
      if (!sm.classList.contains('is-done')) return;
      closePop(true);
      openDrawer();
    });

    document.addEventListener('pointerdown', function (e) {
      if (!A8.histOn) return;
      if (A8.histPanel && A8.histPanel.contains(e.target)) return;
      if (A8.hist && A8.hist.contains(e.target)) return;
      a8HistClose();
    }, true);

    document.addEventListener('click', function (e) {
      if (!A8.histOn) return;
      if (A8.histPanel && A8.histPanel.contains(e.target)) return;
      if (A8.hist && A8.hist.contains(e.target)) return;
      a8HistClose();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && A8.histOn) a8HistClose(true);
    });
    window.addEventListener('scroll', function (e) {
      if (!A8.histOn || isMobile()) return;

      if (A8.histPanel && e.target && e.target !== document
          && A8.histPanel.contains && A8.histPanel.contains(e.target)) return;

      if (A8.histAt && Date.now() - A8.histAt < 350) return;
      a8HistClose();
    }, true);
    window.addEventListener('resize', function () {
      if (A8.histOn) a8HistClose();
    });

    if (!A8_PROTO) { a8Button(); return; }
    var c = document.createElement('div');
    c.setAttribute('data-agcf-proto', '');
    c.className = 'agcf8-proto';
    c.innerHTML = '<span>Button placement</span>'
      + '<button type="button" data-p="p1">P1 tile</button>'
      + '<button type="button" data-p="p2" class="is-on">P2 buy box</button>'
      + '<button type="button" data-p="p3">P3 gallery</button>'
      + '<i class="agcf8-proto-sep"></i>'
      + '<span>Rail scroll</span>'
      + '<button type="button" data-r14o="arrows" class="is-on">'
      + 'R1 arrows</button>'
      + '<button type="button" data-r14o="endrow">R2 end pair</button>'
      + '<button type="button" data-r14o="dragbar">R3 drag bar</button>'
      + '<em data-agcf8-server>fal: probing…</em>';
    c.addEventListener('click', function (e) {
      var t = e.target.closest('button[data-p]');
      if (t) {
        A8.place = t.getAttribute('data-p');
        c.querySelectorAll('button[data-p]').forEach(function (x) {
          x.classList.toggle('is-on', x === t);
        });
        a8Place();
        return;
      }

      var o = e.target.closest('button[data-r14o]');
      if (!o) return;
      document.body.setAttribute('data-agcf14-railopt',
        o.getAttribute('data-r14o'));
      c.querySelectorAll('button[data-r14o]').forEach(function (x) {
        x.classList.toggle('is-on', x === o);
      });
      if (A8.railnavPaint) A8.railnavPaint();
    });
    document.body.appendChild(c);

    var badge = c.querySelector('[data-agcf8-server]');
    fetch(a8GenBase() + '/health').then(function (r) {
      A8.server = r.ok;
      badge.textContent = r.ok ? 'fal: live' : 'fal: offline (simulated)';
    }).catch(function () {
      A8.server = false;
      badge.textContent = 'fal: offline (simulated)';
    });
    a8Button();
  }

  var A8_PROTO = false;
  window.__agcfDrawerOwner = 'agcf';
  var A8_PAY_DEFAULT = 'hide';
  var A8_PAY_PROBE_OK = true;
  function a8PayForm() {
    var b = document.getElementById('add-to-cart-btn');
    return (b && b.closest) ? b.closest('form') : null;
  }

  function a8EnvNode() {
    return document.querySelector('[data-agcf-r6]') || document.body;
  }
  function a8GenBase() {
    var n = a8EnvNode();
    var v = n && n.getAttribute ? n.getAttribute('data-agcf-gen-base') : '';
    return (v && v.trim()) ? v.trim().replace(/\/+$/, '') : A8.base;
  }
  function a8Handle() {

    var n = a8EnvNode();
    var v = n && n.getAttribute ? n.getAttribute('data-agcf-handle') : '';
    return (v && v.trim()) ? v.trim() : '';
  }
  function a8HandleQS() {
    var h = a8Handle();
    return h ? '&handle=' + encodeURIComponent(h) : '';
  }
  function a8PayMode() {
    if (A8.payMode) return A8.payMode;
    var mode = '';

    if (A8_PAY_PROBE_OK) {
      try {
        var m = /[?&]agcf_pay=([a-zA-Z]+)/.exec(window.location.search || '');
        if (m) {
          mode = m[1].toLowerCase();
          try { sessionStorage.setItem('agcf:paymode', mode); } catch (e) {}
        } else {
          try { mode = sessionStorage.getItem('agcf:paymode') || ''; }
          catch (e2) { mode = ''; }
        }
      } catch (e3) { mode = ''; }
    }

    if (!mode) {
      var f = a8PayForm();
      mode = (f && f.getAttribute('data-agcf-pay-setting')) || '';
    }

    if (!mode) mode = A8_PAY_DEFAULT;

    A8.payMode = (mode === 'carry') ? 'carry' : 'hide';
    return A8.payMode;
  }
  function a8PayBoot() {

    var f = a8PayForm();
    if (!f) return;
    f.setAttribute('data-agcf-pay', a8PayMode());
  }

  var A8_SUR = {"vid": 46054424543292, "unit": 10, "fixture": false};
  /* PER-AMOUNT SURCHARGE (Datch 2026-10-14; review
     https://claude.ai/artifact/BzCZSmBoWg9AMdAYGwo4tQ): the unlisted product
     "Custom Finishing" (handle custom-finishing-surcharge-amounts, product
     15414035349564) has one variant per $10 from $10 to $3,000, so a piece's
     surcharge is ONE line at its amount, quantity = the piece's quantity
     (_units_per_item "1"), and checkout reads "Custom Finishing $90" instead
     of "x9". Same SKU AGCF-SURCHARGE, tax, shipping and location as the $10
     variant above, which stays the fallback for an amount without a variant
     and for carts that already hold units. {amount in dollars: variant id};
     re-bake from workspace surcharge-pricing-review/amounts-variants.json if
     the product's variants are ever recreated. */
  A8_SUR.amounts = {"10":67664256008252,"20":67664256303164,"30":67664256335932,"40":67664256368700,"50":67664256401468,"60":67664256434236,"70":67664256467004,"80":67664256499772,"90":67664256532540,"100":67664256565308,"110":67664256598076,"120":67664256630844,"130":67664256663612,"140":67664256696380,"150":67664256729148,"160":67664256761916,"170":67664256794684,"180":67664256827452,"190":67664256860220,"200":67664256892988,"210":67664256925756,"220":67664256958524,"230":67664256991292,"240":67664257024060,"250":67664257056828,"260":67664257089596,"270":67664257122364,"280":67664257155132,"290":67664257187900,"300":67664257220668,"310":67664257253436,"320":67664257286204,"330":67664257318972,"340":67664257351740,"350":67664257384508,"360":67664257417276,"370":67664257450044,"380":67664257482812,"390":67664257515580,"400":67664257548348,"410":67664257581116,"420":67664257613884,"430":67664257646652,"440":67664257679420,"450":67664257712188,"460":67664257744956,"470":67664257777724,"480":67664257810492,"490":67664257843260,"500":67664257876028,"510":67664257908796,"520":67664257941564,"530":67664257974332,"540":67664258007100,"550":67664258039868,"560":67664258072636,"570":67664258105404,"580":67664258138172,"590":67664258170940,"600":67664258203708,"610":67664258236476,"620":67664258269244,"630":67664258302012,"640":67664258334780,"650":67664258367548,"660":67664258400316,"670":67664258433084,"680":67664258465852,"690":67664258498620,"700":67664258531388,"710":67664258564156,"720":67664258596924,"730":67664258629692,"740":67664258662460,"750":67664258695228,"760":67664258727996,"770":67664258760764,"780":67664258793532,"790":67664258826300,"800":67664258859068,"810":67664258891836,"820":67664258924604,"830":67664258957372,"840":67664258990140,"850":67664259022908,"860":67664259055676,"870":67664259088444,"880":67664259121212,"890":67664259153980,"900":67664259186748,"910":67664259219516,"920":67664259252284,"930":67664259285052,"940":67664259317820,"950":67664259350588,"960":67664259383356,"970":67664259416124,"980":67664259448892,"990":67664259481660,"1000":67664259514428,"1010":67664259547196,"1020":67664259612732,"1030":67664259645500,"1040":67664259678268,"1050":67664259711036,"1060":67664259743804,"1070":67664259776572,"1080":67664259809340,"1090":67664259842108,"1100":67664259874876,"1110":67664259907644,"1120":67664259940412,"1130":67664259973180,"1140":67664260005948,"1150":67664260038716,"1160":67664260071484,"1170":67664260104252,"1180":67664260137020,"1190":67664260169788,"1200":67664260202556,"1210":67664260235324,"1220":67664260268092,"1230":67664260300860,"1240":67664260333628,"1250":67664260366396,"1260":67664260399164,"1270":67664260431932,"1280":67664260464700,"1290":67664260497468,"1300":67664260530236,"1310":67664260563004,"1320":67664260595772,"1330":67664260628540,"1340":67664260661308,"1350":67664260694076,"1360":67664260726844,"1370":67664260759612,"1380":67664260792380,"1390":67664260825148,"1400":67664260857916,"1410":67664260890684,"1420":67664260923452,"1430":67664260956220,"1440":67664260988988,"1450":67664261021756,"1460":67664261054524,"1470":67664261087292,"1480":67664261120060,"1490":67664261152828,"1500":67664261185596,"1510":67664261218364,"1520":67664261251132,"1530":67664261283900,"1540":67664261316668,"1550":67664261349436,"1560":67664261382204,"1570":67664261414972,"1580":67664261447740,"1590":67664261480508,"1600":67664261513276,"1610":67664261546044,"1620":67664261578812,"1630":67664261611580,"1640":67664261644348,"1650":67664261677116,"1660":67664261709884,"1670":67664261742652,"1680":67664261775420,"1690":67664261808188,"1700":67664261840956,"1710":67664261873724,"1720":67664261906492,"1730":67664261939260,"1740":67664261972028,"1750":67664262004796,"1760":67664262037564,"1770":67664262070332,"1780":67664262103100,"1790":67664262135868,"1800":67664262168636,"1810":67664262201404,"1820":67664262234172,"1830":67664262266940,"1840":67664262299708,"1850":67664262332476,"1860":67664262365244,"1870":67664262398012,"1880":67664262430780,"1890":67664262463548,"1900":67664262496316,"1910":67664262529084,"1920":67664262561852,"1930":67664262594620,"1940":67664262627388,"1950":67664262660156,"1960":67664262692924,"1970":67664262725692,"1980":67664262758460,"1990":67664262791228,"2000":67664262823996,"2010":67664262856764,"2020":67664262922300,"2030":67664262955068,"2040":67664262987836,"2050":67664263020604,"2060":67664263053372,"2070":67664263086140,"2080":67664263118908,"2090":67664263151676,"2100":67664263184444,"2110":67664263217212,"2120":67664263249980,"2130":67664263282748,"2140":67664263315516,"2150":67664263348284,"2160":67664263381052,"2170":67664263413820,"2180":67664263446588,"2190":67664263479356,"2200":67664263512124,"2210":67664263544892,"2220":67664263577660,"2230":67664263610428,"2240":67664263643196,"2250":67664263675964,"2260":67664263708732,"2270":67664263741500,"2280":67664263774268,"2290":67664263807036,"2300":67664263839804,"2310":67664263872572,"2320":67664263905340,"2330":67664263938108,"2340":67664263970876,"2350":67664264003644,"2360":67664264036412,"2370":67664264069180,"2380":67664264101948,"2390":67664264134716,"2400":67664264167484,"2410":67664264200252,"2420":67664264233020,"2430":67664264265788,"2440":67664264298556,"2450":67664264331324,"2460":67664264364092,"2470":67664264396860,"2480":67664264429628,"2490":67664264462396,"2500":67664264495164,"2510":67664264527932,"2520":67664264560700,"2530":67664264593468,"2540":67664264626236,"2550":67664264659004,"2560":67664264691772,"2570":67664264724540,"2580":67664264757308,"2590":67664264790076,"2600":67664264822844,"2610":67664264855612,"2620":67664264888380,"2630":67664264921148,"2640":67664264953916,"2650":67664264986684,"2660":67664265019452,"2670":67664265052220,"2680":67664265084988,"2690":67664265117756,"2700":67664265150524,"2710":67664265183292,"2720":67664265216060,"2730":67664265248828,"2740":67664265281596,"2750":67664265314364,"2760":67664265347132,"2770":67664265379900,"2780":67664265412668,"2790":67664265445436,"2800":67664265478204,"2810":67664265510972,"2820":67664265543740,"2830":67664265576508,"2840":67664265609276,"2850":67664265642044,"2860":67664265674812,"2870":67664265707580,"2880":67664265740348,"2890":67664265773116,"2900":67664265805884,"2910":67664265838652,"2920":67664265871420,"2930":67664265904188,"2940":67664265936956,"2950":67664265969724,"2960":67664266002492,"2970":67664266035260,"2980":67664266068028,"2990":67664266100796,"3000":67664266133564};
  /* a surcharge line: the $10 units or a line of the amounts product (both
     handles start with custom-finishing-surcharge) */
  function a8IsSur(it) {
    return !!it && ((A8_SUR.vid && it.variant_id === A8_SUR.vid)
      || String(it.handle || '').indexOf('custom-finishing-surcharge') === 0);
  }
  function a8ShimVariantId() {
    var el = document.getElementById('product-variant-id');
    return el ? el.value : '';
  }
  function a8ShimProps() {

    var f = a8PayForm();
    if (!f) return null;
    var ins = f.querySelectorAll('input[data-agcf14-prop]');
    var o = {}, n = 0;
    for (var i = 0; i < ins.length; i++) {
      var nm = ins[i].getAttribute('data-agcf14-prop');
      var v = ins[i].value;

      if (!nm || v === '' || v === null || v === undefined) continue;
      o[nm] = v; n++;
    }
    return n ? o : null;
  }
  function a8ShimInit(init) {
    var props = a8ShimProps();
    if (!props) return init;
    var data;
    try { data = JSON.parse(init.body); } catch (e) { return init; }
    if (!data || !data.items || !data.items.length) return init;
    var vid = a8ShimVariantId(), touched = false, pq = 1;
    for (var i = 0; i < data.items.length; i++) {
      var it = data.items[i];
      if (!it) continue;

      if (vid && String(it.id) !== String(vid)) continue;
      if (it.properties) continue;
      it.properties = props;
      touched = true;

      pq = Math.max(1, parseInt(it.quantity, 10) || 1);
    }
    if (!touched) return init;

    if (A8_SUR.vid) {
      try {
        var d = customPrice() - unitPrice();
        if (d > 0 && d % A8_SUR.unit === 0) {
          var sp = {};
          if (props['_finish_codes']) sp['_surcharge_for'] = props['_finish_codes'];
          var fp = a8Handle() || a8ProductName();
          if (fp) sp['_for_product'] = fp;

          /* one line at the piece's amount (A8_SUR.amounts), else $10 units */
          var amt = A8_SUR.amounts && A8_SUR.amounts[String(d)];
          var upi = amt ? 1 : d / A8_SUR.unit;
          sp['_units_per_item'] = String(upi);
          data.items.push({ id: amt || A8_SUR.vid,
                            quantity: upi * pq,
                            properties: sp });
        }
      } catch (e) {   }
    }
    var out = {};
    for (var k in init) {
      if (Object.prototype.hasOwnProperty.call(init, k)) out[k] = init[k];
    }
    out.body = JSON.stringify(data);
    return out;
  }
  function a8CartTap(url, m, pr) {

    if (!pr || typeof pr.then !== 'function') return;
    var full = (m === 'GET' && /\/cart\.js(on)?(\?|$)/.test(url))
      || (m === 'POST'
          && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url));
    if (!full) return;
    pr.then(function (r) {
      if (r && r.ok && r.clone) {
        r.clone().json().then(a8CartMemo, function () {});
      }
    }, function () {});
  }
  function a8CartShim() {
    if (window.__agcfCartShim) return;
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;
    window.__agcfCartShim = true;
    window.fetch = function (input, init) {
      var useInit = init;
      var url = '';
      var m = 'GET';
      try {
        url = String((typeof input === 'string')
          ? input : (input && input.url) || '');
        m = init && init.method
          ? String(init.method).toUpperCase() : 'GET';
        if (m === 'POST' && typeof init.body === 'string'
            && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          useInit = a8ShimInit(init);
        }
      } catch (e) {

        useInit = init;
      }

      var pr = (arguments.length < 2)
        ? nativeFetch.call(this, input)
        : nativeFetch.call(this, input, useInit);
      try { a8CartTap(url, m, pr); } catch (e2) {}
      return pr;
    };
  }

  function a8PickerJoin() {

    if (A8_PROTO || !window.AG_SAMPLE_PICKER) return;
    if (window.AG_SAMPLE_PICKER.__agcfJoin) return;
    var rawOpen = window.AG_SAMPLE_PICKER.open;
    var rawDirect = window.AG_SAMPLE_PICKER.directAdd;
    A8.rawDirect = rawDirect;
    var inject = function (cfg) {
      if (!cfg) return cfg;
      if (!cfg.samples) cfg.samples = [];
      if (!cfg.unavailable) cfg.unavailable = [];
      var sm = cfg.samples, un = cfg.unavailable, i;

      for (i = sm.length - 1; i >= 0; i--) {
        if (sm[i] && sm[i].agcfJoin) sm.splice(i, 1);
      }
      for (i = un.length - 1; i >= 0; i--) {
        if (un[i] && un[i].agcfJoin) un.splice(i, 1);
      }
      var seen = {};
      sm.concat(un).forEach(function (e) {
        if (e && e.code) seen[e.code] = 1;
      });
      customAdditions().forEach(function (f) {
        if (seen[f.code]) return;
        var m = A8.smp[f.code];
        var e = { code: f.code, name: f.name,
          image: cdn(f.image, 360), imageLarge: cdn(f.image, 800),
          toneLabel: f.tone ? (f.tone + ' tone').toUpperCase() : '',
          usecase: TONE_USECASE[f.tone] || '', texture: f.texture || '',
          material: f.material || '', agcfJoin: 1 };
        if (m && !m.none && m.avail) {

          e.variantId = m.vid; e.price = m.price; e.mode = effMode(f);
          sm.push(e);
          return;
        }
        e.state = (m && !m.none) ? 'soldout' : 'none';
        un.push(e);
      });
      return cfg;
    };
    window.AG_SAMPLE_PICKER.open = function (cfg) {

      var need = [];
      try {
        customAdditions().forEach(function (f) {
          if (!A8.smp[f.code]) need.push(a8SampleFetch(f.code));
        });
      } catch (e0) {}
      var go = function () {
        if (!A8.smpOpen) return;
        A8.smpOpen = false;
        try { cfg = inject(cfg); } catch (e1) {}
        rawOpen(cfg);
      };
      if (!need.length) {
        try { cfg = inject(cfg); } catch (e2) {}
        return rawOpen(cfg);
      }
      if (A8.smpOpen) return;
      A8.smpOpen = true;
      setTimeout(go, 800);
      Promise.all(need).then(go, go);
    };
    window.AG_SAMPLE_PICKER.directAdd = function (cfg) {

      try {
        if (customAdditions().length && cfg && cfg.sample) {
          return window.AG_SAMPLE_PICKER.open({ samples: [cfg.sample],
            unavailable: [], cart: cfg.cart, onAdded: cfg.onAdded });
        }
      } catch (e) {}
      return rawDirect(cfg);
    };
    window.AG_SAMPLE_PICKER.__agcfJoin = true;
  }
  function a8BlobData() {

    if (A8.sampleBlob) return A8.sampleBlob;
    var d = { samples: [], unavailable: [] };
    try {
      var w = document.querySelector('.ag-sample-link-wrap');
      var n = w && document.getElementById(
        'sample-request-data-' + w.getAttribute('data-product-id'));
      if (n) d = JSON.parse(n.textContent) || d;
    } catch (e) {}
    A8.sampleBlob = d;
    return d;
  }
  function a8BlobEntry(code) {
    var s = a8BlobData().samples || [];
    for (var i = 0; i < s.length; i++) {
      if (s[i].code === code) return s[i];
    }
    return null;
  }
  function a8SampleFetch(code) {

    if (A8_PROTO || !code) return Promise.resolve(null);
    if (A8.smpP[code]) return A8.smpP[code];
    var keep = function (m) { A8.smp[code] = m; return m; };
    var p = fetch('/products/finish-sample-'
        + String(code).toLowerCase() + '.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var v = j && j.variants && j.variants[0];
        return keep(v ? { vid: v.id, price: v.price,
                          avail: !!v.available, name: j.title }
                      : { none: true });
      }, function () { return keep({ none: true }); });
    A8.smpP[code] = p;
    return p;
  }
  function a8SmpState(code) {

    if (A8_PROTO || !code) return '';
    var m = A8.smp[code];
    if (!m) {
      a8SampleFetch(code).then(function () { a8SmpRepaint(code); });
      return '';
    }
    return m.none ? 'none' : (m.avail ? '' : 'soldout');
  }
  function a8SmpRepaint(code, revert) {

    var p = document.querySelector('.agcf-pop5.is-show');
    var f = st && st.popFinish;
    if (!p || !f || f.code !== code) return;
    var b = p.querySelector('.agcf-pop5-sample');
    if (!b) return;
    var lbl = b.querySelector('.agcf-pop5-sample-lbl');
    var led = b.querySelector('.agcf-pop5-lead');
    if (revert) {
      b.classList.remove('is-done');
      b.removeAttribute('aria-disabled');
      if (lbl) lbl.textContent = R5.popover.request_sample;
    } else if (b.classList.contains('is-done')) return;
    var s = a8SmpState(code);
    if (led) led.textContent = leadFor(f, s);
    if (s) {
      b.setAttribute('aria-disabled', 'true');
      if (document.activeElement !== b) b.disabled = true;
    } else {
      b.disabled = false;
      b.removeAttribute('aria-disabled');
    }
  }
  function a8RealCart() {

    return {
      read: function () {
        return fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) {
            return { items: (c.items || []).map(function (i) {
              return { id: i.variant_id || i.id }; }) };
          });
      },
      add: function (items) {
        return fetch('/cart/add.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }) })
          .then(function (r) {
            if (r.ok) return r.json();
            return r.json().catch(function () { return {}; })
              .then(function (b) {
                throw { status: r.status,
                        message: b.message || 'Cart Error',
                        description: b.description || '' };
              });
          });
      }
    };
  }
  function a8PortSample(f) {

    if (!f || !effMode(f) || st.requested[f.code]) return false;
    var da = A8.rawDirect
      || (window.AG_SAMPLE_PICKER && window.AG_SAMPLE_PICKER.directAdd);
    if (!da) return false;
    var code = f.code;
    var fail = function (state) {
      A8.smpBusy[code] = 0;

      if (!A8.smp[code]) A8.smp[code] = state === 'soldout'
        ? { avail: false } : { none: true };
      announce(state === 'none'
        ? R5.sample.lead_unavailable
        : 'This sample is temporarily out of stock.');

      a8SmpRepaint(code, true);
    };
    var fire = function (sample) {
      da({ sample: sample, cart: a8RealCart(),
        onAdded: function () {
          A8.smpBusy[code] = 0;
          st.requested[code] = 1;
          announce(R5.sample.added + ': ' + f.name);
          openDrawer();
        },
        onSoldOut: function () { fail('soldout'); } });
    };
    var e = a8BlobEntry(code);
    if (e) { fire(e); return true; }
    var m = A8.smp[code];
    if (m && (m.none || !m.avail)) {
      fail(m.none ? 'none' : 'soldout');
      return false;
    }
    if (A8.smpBusy[code]) return false;
    A8.smpBusy[code] = 1;
    a8SampleFetch(code).then(function (r) {
      if (r && !r.none && r.avail) {
        fire({ code: code, name: f.name, variantId: r.vid });
        return;
      }
      fail(r && !r.none ? 'soldout' : 'none');
    }, function () { fail('none'); });
    return true;
  }
  function a8PortDrawer() {

    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }
  function a8Money(cents) {

    var v = Math.abs(Math.round(cents));
    var s = '$' + Math.floor(v / 100).toLocaleString('en-US');
    var c = v % 100;
    if (c) s += '.' + (c < 10 ? '0' : '') + c;
    return (cents < 0 ? '-' : '') + s;
  }
  var A8_DSYNC = { gen: 0, t: null, busy: false, cart: null };
  var A8_IMGC = {};
  var A8_FB = {};
  function a8Prewarm(url) {

    if (!url || !/^https?:/.test(url) || A8_IMGC[url]) return;
    A8_IMGC[url] = 'load';
    var im = new Image();
    im.onload = function () {
      var fin = function () { A8_IMGC[url] = 'warm'; a8MemoPaint(); };
      if (im.decode) { im.decode().then(fin, fin); } else { fin(); }
    };
    im.onerror = function () { A8_IMGC[url] = 'dead'; a8MemoPaint(); };
    setTimeout(function () {
      if (A8_IMGC[url] === 'load') {
        A8_IMGC[url] = 'late';
        a8MemoPaint();
      }
    }, 900);
    im.src = url;
  }
  function a8CartMemo(cart) {

    if (!cart || !cart.items) return;
    A8_DSYNC.cart = cart;

    try { window.__agcfCart = cart; } catch (e) {}
    cart.items.forEach(function (it) {
      var pv = (it.properties || {})['_preview'];
      if (pv) a8Prewarm(pv);
    });
  }
  function a8MemoPaint() {

    if (A8_PROTO || !A8_DSYNC.cart) return;
    try { a8DrawerPaint(A8_DSYNC.cart, false); } catch (e) {}
  }
  function a8DrawerSync() {

    if (A8_PROTO) return;
    var g = ++A8_DSYNC.gen;
    clearTimeout(A8_DSYNC.t);
    A8_DSYNC.t = setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (g === A8_DSYNC.gen && cart && cart.items) {
            a8CartMemo(cart);
            a8DrawerPaint(cart, true);
          }
        })
        .catch(function (e) {   });
    }, 60);
  }
  function a8SurFor(surs, p, it) {
    for (var i = 0; i < surs.length; i++) {
      var sp = surs[i].it.properties || {};
      if (sp['_surcharge_for'] === p['_finish_codes'] && a8SurOwns(sp, it)) {
        return surs[i];
      }
    }
    return null;
  }
  /* A surcharge line belongs to ONE product (Datch 2026-10-13): a set piece
     added in the page's combo carries the same codes and its own surcharge
     line, so the codes alone no longer name the line. _for_product is the
     handle (a8Handle; older lines may carry the product title). */
  function a8SurOwns(sp, it) {
    var fp = sp['_for_product'];
    return !fp || !it || fp === it.handle || fp === it.product_title;
  }
  /* The line's surcharge goes INTO the drawer's own figures (Datch
     2026-10-13): the redesigned drawer prints LINE totals, with a struck list
     total over the discounted one when a discount applies; replacing the
     whole block with unit + surcharge dropped the quantity and the discount.
     Each figure keeps the drawer's own value in data-agcf-base, so repaints
     never add twice. A drawer without those spans keeps the unit text. */
  function a8MoneyCents(t) {
    var m = /(\d[\d,]*)(?:\.(\d{1,2}))?/.exec(t || '');
    if (!m) return null;
    return parseInt(m[1].replace(/,/g, ''), 10) * 100
      + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0);
  }
  function a8FoldPrice(row, addCents, unitWant) {
    var spans = row.querySelectorAll(
      '.cart-drawer__item-price-final, .cart-drawer__item-price-compare');
    if (!spans.length) {
      var el = row.querySelector('.cart-drawer__item-price');
      var want = a8Money(unitWant);
      if (el && el.textContent.trim() !== want) el.textContent = want;
      return;
    }
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      var cur = s.textContent.trim();
      var base = s.getAttribute('data-agcf-base');
      if (base === null || cur !== s.getAttribute('data-agcf-out')) {
        base = cur;
        s.setAttribute('data-agcf-base', base);
      }
      var c = a8MoneyCents(base);
      if (c === null) continue;
      var out = a8Money(c + addCents);
      s.setAttribute('data-agcf-out', out);
      if (cur !== out) s.textContent = out;
    }
  }
  function a8DrawerPaint(cart, fresh) {

    var items = cart.items || [];
    var surs = [];
    items.forEach(function (it, i) {
      if (a8IsSur(it)) {
        surs.push({ it: it, line: i + 1 });
      }
    });
    var rows = document.querySelectorAll(
      '#cart-drawer-items .cart-drawer__item');
    for (var i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('.quantity__input[data-index]');
      var idx = input ? parseInt(input.getAttribute('data-index'), 10) : 0;
      var it = idx ? items[idx - 1] : null;
      if (!it) continue;

      var lk = rows[i].querySelector('.cart-drawer__item-link');
      if (lk && it.url && lk.getAttribute('href') !== it.url) continue;
      var p = it.properties || {};
      if (a8IsSur(it)) {
        rows[i].classList.add('is-agcf-sur');
        continue;
      }
      if (!p['Custom Finishing']) continue;
      rows[i].classList.add('is-agcf-cline');
      var img = rows[i].querySelector('.cart-drawer__item-image-img');
      var pv = p['_preview'] || '';
      if (img && pv) {

        var ist = A8_IMGC[pv];
        if (!ist) { a8Prewarm(pv); ist = A8_IMGC[pv]; }
        if (ist === 'warm' || ist === 'late') {
          rows[i].classList.remove('is-agcf-imgwait');
          if (ist === 'warm' && img.getAttribute('src') !== pv) {
            if (!(it.key in A8_FB)) {
              A8_FB[it.key] = img.getAttribute('src') || '';
            }
            (function (u8, k8, im8) {
              im8.onerror = function () {

                im8.onerror = null;
                A8_IMGC[u8] = 'dead';
                var fb = A8_FB[k8];
                if (fb && im8.getAttribute('src') !== fb) im8.src = fb;
              };
            })(pv, it.key, img);
            img.src = pv;
          }
        } else if (ist === 'load') {
          rows[i].classList.add('is-agcf-imgwait');
        } else {
          rows[i].classList.remove('is-agcf-imgwait');
        }
      }
      /* no "Custom Finishing:" note under the title any more: the drawer's
         FINISH row names the combo (Datch 2026-10-13, one FINISH row) */
      var sur = a8SurFor(surs, p, it);
      if (sur) {
        var upi = parseInt((sur.it.properties || {})['_units_per_item'],
                           10) || 0;
        if (upi) {
          /* per piece = the surcharge line's own price x its units per piece
             ($10 x 9 today, $90 x 1 with the amounts product) */
          var each = (sur.it.price || A8_SUR.unit * 100) * upi;
          a8FoldPrice(rows[i], each * (it.quantity || 1), it.price + each);
        }
      }
    }
    if (fresh) a8SurQtyReconcile(items, surs);
  }
  function a8SurQtyReconcile(items, surs) {

    if (!A8_SUR.vid || A8_DSYNC.busy) return;
    var want = null;
    for (var i = 0; i < surs.length && !want; i++) {
      var sp = surs[i].it.properties || {};
      var upi = parseInt(sp['_units_per_item'], 10) || 0;
      var parent = null;
      for (var j = 0; j < items.length; j++) {
        var pp = items[j].properties || {};
        if (!a8IsSur(items[j]) && pp['_finish_codes']
            && pp['_finish_codes'] === sp['_surcharge_for']
            && a8SurOwns(sp, items[j])) {
          parent = items[j];
          break;
        }
      }
      var expect;
      if (!parent) expect = 0;
      else if (upi) expect = upi * parent.quantity;
      else continue;
      if (expect !== surs[i].it.quantity) {
        want = { key: surs[i].it.key, qty: expect };
      }
    }
    if (!want || !want.key) return;
    A8_DSYNC.busy = true;
    fetch('/cart/change.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: want.key, quantity: want.qty }) })
      .then(function () {
        A8_DSYNC.busy = false;
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.refreshCart === 'function') d.refreshCart();
        a8DrawerSync();
      })
      .catch(function (e) { A8_DSYNC.busy = false; });
  }
  function a8SurHide() {

    if (!A8_SUR.vid) return;
    var links = document.querySelectorAll(
      '.cart-drawer__item a[href*="/products/custom-finishing-surcharge"]');
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest('.cart-drawer__item');
      if (row) row.classList.add('is-agcf-sur');
    }
  }
  function a8SurFold() {
    if (!A8_SUR.vid) return;
    var host = document.querySelector(
      'cart-drawer, #cart-drawer, .cart-drawer');
    if (!host || !window.MutationObserver) return;

    new MutationObserver(function () {
      a8SurHide();
      a8MemoPaint();
      a8DrawerSync();
    }).observe(host, { childList: true, subtree: true });
    a8SurHide();
    a8DrawerSync();
  }
  function a8PayRestore() {

    if (a8PayMode() !== 'hide') return;
    if (typeof window.refreshPaymentButtons !== 'function') return;
    requestAnimationFrame(function () {
      try { window.refreshPaymentButtons(); } catch (e) {}
    });
  }

  var A8G_STEPS = [{"h":"Custom Finishing is Available.","p":"This model can be finished in one of 120+ finishing choices. Use this process to choose now."},{"h":"Choose your custom finishings here","p":"Find and select the custom finishings here. Start with a PRIMARY finishing, then an optional ACCENT finishing."},{"h":"The PRIMARY finishing is shown here","p":"Once you select the PRIMARY finishing it will show alongside the default finishing options."},{"h":"The ACCENT finishing is shown here","p":"Once you select the ACCENT finishing it will show within the PRIMARY that you chose. (ACCENT finishings are optional but highly recommended for a modern look.)"},{"h":"Finishing history","p":"You can access all your previously selected finishes here anytime."},{"h":"See the model in your custom finish","p":"We build a preview of this exact piece in the finishes you chose."},{"h":"Your preview arrives.","p":"Previews help you visualize the design in your preferred finish. For more detailed views, contact our Design Concierge here.","lk":["here","/pages/book"]},{"h":"You can revisit your preview here.","p":"Your preview appears alongside the design images for easy reference."}];
  var A8G_TITLE = "How custom finishing works";
  var A8G_LABEL = "Example - your own preview replaces this";

  var A8G_WM1 = "Rendered finish preview.";
  var A8G_WM2 = "Confirm exact finish details with a $5 sample.";
  var A8G_WM3 = "Our design team will confirm colors with you before production.";

  var A8G_SRC = {"arlune-front-reception-desk-for-salon-retail":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/qMbQq00zEDqksInmPpTd2_sLCKJgJg_r2c4_logo_a2426616-b2ab-4d50-a1a9-9f75fd891eea.webp?v=1778100700","dahlia-71-158-white-rectangular-receptionist-desk-with-gloss-finishing-af-zt-z291044r":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/vV6tXlynjyOkbC1iwZXLP_ij3AAYpV_r1c1_logo_cf7f7ebf-3aa5-4b5a-bd95-1857145bbb18.webp?v=1778099904","elyra-front-reception-desk-for-hospitality-retail":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/hf_20260210_030921_0c6c833c-18f0-4d4d-abaa-3537ea84e35b.webp?v=1770693576","faye-front-reception-desk":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/P0Kwa9gDkp2DRQ9F3UfTX_fSdIjXYj_r2c2_logo_176a3758-e6a7-457e-86aa-6caf03125467.webp?v=1778102094","lavien-front-office-lobby-desk":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/ol4InHKQaEtUlfarbdg9V_63DM4zJS_r1c2_logo_73714758-eff1-4d96-82f5-24b345c645a6.webp?v=1778101371","ovelle-front-reception-deskfor-spa-or-lobby":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/hf_20260210_034451_f1c93f14-f405-4b92-9355-1960bcf064cd.webp?v=1770695934","ryvion-front-lobby-reception-desk":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/hf_20260210_012622_ac6454db-5ee3-48d9-9543-0a03cd46ea7b.webp?v=1770688192","vaelric-71-126-brown-rectangular-receptionist-desk-with-gloss-finishing-af-sl-qt-01":"https://cdn.shopify.com/s/files/1/0600/0659/6668/files/3WF1BaxKXFesPXgDFc6f-_QGEjz7wz_r1c3_logo_949983c3-e021-439e-8ddf-6aa5835c368d.webp?v=1778101811"};
  var A8G_BACK = "Back";
  var A8G_NEXT = "Next";
  var A8G_DONE = "Done";

  var GS_ROW = 1, GS_PRIM = 2, GS_ACC = 3, GS_HIST = 4, GS_CTA = 5,
      GS_SHOT = 6, GS_CELL = 7;

  var A8G_STAB_MAX = 180;

  var A8G_CLEAR = 24;

  var A8G_PAN = 1400;

  var A8G = {
    veil: null, dim: null, holes: null, card: null, at: 0,

    open: false, snap: null, tok: 0, ptok: 0, scrollT: null,

    sheet: false,

    hold: false, pan: false, panT: null,

    ovr: false, stab: null, onScroll: null, ro: null, pTop: null,

    rdy: false, lit: false
  };

  function a8GdBtn() {
    return document.querySelector('[data-agcf8-btn]');
  }
  function a8GdBandW() {
    return !!(window.matchMedia
      && window.matchMedia('(max-width: 991px)').matches);
  }
  function a8GdMode() {

    if (isMobile()) return 'phone';
    return a8GdBandW() ? 'band' : 'desktop';
  }
  function a8GdReduce() {
    return !!(window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function a8GdFixed(n) {

    for (var e = n; e && e.nodeType === 1; e = e.parentNode) {
      var p = window.getComputedStyle(e).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  }
  function a8GdTopSheet() {

    return A8G.sheet && A8G.at === GS_HIST;
  }
  function a8GdChrome() {

    var vw = document.documentElement.clientWidth || window.innerWidth || 0;
    var vh = window.innerHeight || 0;
    var out = 0;
    if (!document.elementsFromPoint) return out;
    var els = document.elementsFromPoint(Math.round(vw / 2), 2) || [];
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (!e || (A8G.veil && A8G.veil.contains(e))) continue;
      for (var n = e; n && n.nodeType === 1; n = n.parentNode) {
        var p = window.getComputedStyle(n).position;
        if (p !== 'fixed' && p !== 'sticky') continue;
        var r = n.getBoundingClientRect();
        if (r.top <= 2 && r.bottom > out && r.bottom < vh / 2) out = r.bottom;
        break;
      }
    }
    return Math.round(out);
  }
  function a8GdCardBand() {

    var vh = window.innerHeight || 0;

    var top0 = a8GdChrome();
    if (top0) top0 += A8G_CLEAR;
    var out = { top: top0, bot: vh };
    var c = A8G.card;
    if (!c || !A8G.sheet || !c.offsetHeight) return out;
    if (a8GdTopSheet()) {

      out.top = Math.max(top0, c.offsetHeight + A8G_CLEAR);
      var pn = a8GdHistOpen();
      if (pn) {
        var pr = pn.getBoundingClientRect();
        if (pr.height > 0 && pr.top < vh) out.bot = pr.top - A8G_CLEAR;
      }
      return out;
    }

    out.bot = vh - c.offsetHeight - A8G_CLEAR;
    return out;
  }
  function a8GdSettle(done) {

    var last = null, still = 0, n = 0;
    if (A8G.scrollT) { cancelAnimationFrame(A8G.scrollT); A8G.scrollT = null; }
    var step = function () {
      var y = window.pageYOffset || 0;
      n++;
      if (last !== null && Math.abs(y - last) < 1) still++; else still = 0;
      last = y;
      if (still >= 3 || n > 50) { A8G.scrollT = null; done(); return; }
      A8G.scrollT = requestAnimationFrame(step);
    };
    A8G.scrollT = requestAnimationFrame(step);
  }
  function a8GdSpan() {

    var lead = a8GdLead();
    var nodes = a8GdTargets(), box = null, i;
    for (i = 0; i < nodes.length; i++) {
      if (!nodes[i] || !nodes[i].getBoundingClientRect) continue;
      if (!nodes[i].offsetWidth && !nodes[i].offsetHeight) continue;

      if (a8GdFixed(nodes[i])) continue;

      var pd = a8GdPad(nodes[i]);
      var r = nodes[i].getBoundingClientRect();
      if (!box) {
        box = { top: r.top - pd, bottom: r.bottom + pd };
        continue;
      }
      box.top = Math.min(box.top, r.top - pd);
      box.bottom = Math.max(box.bottom, r.bottom + pd);
    }
    if (!lead || !box) return lead ? lead.getBoundingClientRect() : null;
    var lr = lead.getBoundingClientRect();
    var band = a8GdCardBand();
    var room = band.bot - band.top - 28;

    var wide = { top: Math.min(box.top, lr.top),
                 bottom: Math.max(box.bottom, lr.bottom) };
    if (wide.bottom - wide.top <= room) return wide;
    return box;
  }
  function a8GdScroll(node, done) {

    var r = (node && node.getBoundingClientRect)
      ? node.getBoundingClientRect() : node;
    if (!r) { done(); return; }
    var band = a8GdCardBand();
    var yOff = window.pageYOffset || 0;
    var pad = 14, y = null;
    if (r.top < band.top + pad) {
      y = r.top + yOff - band.top - 12;
    } else if (r.bottom > band.bot - pad) {
      y = r.bottom + yOff - band.bot + 12;

      var minY = r.top + yOff - band.top - 12;
      if (y > minY) y = minY;
    }
    if (y === null) { done(); return; }
    y = Math.max(0, y);
    try {
      window.scrollTo({ top: y, behavior: a8GdReduce() ? 'auto' : 'smooth' });
    } catch (e) { window.scrollTo(0, y); }
    if (a8GdReduce()) { done(); return; }
    a8GdSettle(done);
  }

  function a8GdPair() {

    var pool = RANKED.filter(function (f) {
      return !!(f && f.image && !GRAY[f.code]);
    });
    if (!pool.length) pool = RANKED.slice();
    var p = pool[0] || null, a = null;
    for (var i = 1; i < pool.length; i++) {
      if (pool[i] && p && pool[i].tone !== p.tone) { a = pool[i]; break; }
    }
    if (!a) a = pool[1] || null;
    return { p: p, a: a };
  }
  function a8GdHero() {

    var pick = A8G_SRC[a8Handle()];
    if (pick) return pick;
    var cfgSrc = (CFG && CFG.src) ? CFG.src : '';
    if (cfgSrc) return cfgSrc;
    var g = gallery();
    var im = g && g.querySelector('img.product-header_gallery-image');
    if (!im) im = document.querySelector('img.product-header_gallery-image');
    return im ? (im.currentSrc || im.getAttribute('src') || '') : '';
  }

  function a8GdSnap() {

    var band = q('.agcf-band');
    var ghost = q('.agcf-ghost');
    var box = q('.agcf-ghost-box');
    var name = q('.agcf-ghost-name');
    var gp = box && box.querySelector('.agcf-ghost-primary');
    var ga = box && box.querySelector('.agcf-ghost-accent');
    var hist = q('[data-agcf8-hist]');
    var panel = A8.histPanel;
    var btn = a8GdBtn();
    return {
      y: window.pageYOffset || 0,
      focus: document.activeElement,
      bandOpen: !!(band && band.classList.contains('is-open')),
      ghostOpen: !!(ghost && ghost.classList.contains('is-open')),
      filled: !!(box && box.classList.contains('is-filled')),
      hasAcc: !!(box && box.classList.contains('has-accent')),
      pSrc: gp ? gp.getAttribute('src') : null,
      aSrc: ga ? ga.getAttribute('src') : null,

      pDisp: gp ? gp.style.display : null,
      aDisp: ga ? ga.style.display : null,
      name: name ? name.innerHTML : null,
      histEmpty: !!(hist && hist.classList.contains('is-empty')),
      histHTML: panel ? panel.innerHTML : null,
      histOpen: !!(panel && panel.classList.contains('is-open')),
      btnShow: !!(btn && btn.classList.contains('is-show')),
      btnBusy: !!(btn && btn.classList.contains('is-busy'))
    };
  }
  function a8GdRestore() {
    var s = A8G.snap;

    var mine = document.querySelectorAll('[data-agcfg-demo]');
    for (var i = 0; i < mine.length; i++) {
      if (mine[i].parentNode) mine[i].parentNode.removeChild(mine[i]);
    }
    if (!s) return;
    var band = q('.agcf-band');
    var ghost = q('.agcf-ghost');
    var box = q('.agcf-ghost-box');
    var name = q('.agcf-ghost-name');
    var hist = q('[data-agcf8-hist]');
    var panel = A8.histPanel;
    var btn = a8GdBtn();
    if (band) band.classList.toggle('is-open', s.bandOpen);
    if (ghost) ghost.classList.toggle('is-open', s.ghostOpen);
    if (box) {
      box.classList.toggle('is-filled', s.filled);
      box.classList.toggle('has-accent', s.hasAcc);
      var gp = box.querySelector('.agcf-ghost-primary');
      var ga = box.querySelector('.agcf-ghost-accent');
      if (gp) {
        if (s.pSrc === null) gp.removeAttribute('src');
        else gp.setAttribute('src', s.pSrc);
        gp.style.display = s.pDisp || '';
      }
      if (ga) {
        if (s.aSrc === null) ga.removeAttribute('src');
        else ga.setAttribute('src', s.aSrc);
        ga.style.display = s.aDisp || '';
      }
    }
    if (name && s.name !== null) name.innerHTML = s.name;
    if (hist) hist.classList.toggle('is-empty', s.histEmpty);
    if (panel) {
      if (s.histHTML !== null) panel.innerHTML = s.histHTML;
      panel.classList.toggle('is-open', s.histOpen);
    }
    if (btn) {
      btn.classList.toggle('is-show', s.btnShow);
      btn.classList.toggle('is-busy', s.btnBusy);
    }
    a8Scrim('guide', false);
    a8Lock('guide', false);
    try { window.scrollTo(0, s.y); } catch (e) {}
  }

  function a8GdSwap(img, src, fade) {

    if (!img) return;
    var cur = img.getAttribute('src');
    var shown = img.style.display !== 'none';
    if (cur === src && shown) return;
    if (!fade || !cur || !shown || a8GdReduce()) {
      img.setAttribute('src', src);
      img.style.display = '';
      return;
    }
    var host = img.parentNode;
    if (!host) { img.setAttribute('src', src); return; }

    var fkey = img.className;
    var pre = host.querySelectorAll('[data-agcfg-fade="' + fkey + '"]');
    for (var i = 0; i < pre.length; i++) {
      if (pre[i].parentNode) pre[i].parentNode.removeChild(pre[i]);
    }
    var g = document.createElement('img');
    g.className = img.className;
    g.setAttribute('data-agcfg-fade', fkey);

    g.setAttribute('data-agcfg-demo', '');
    g.setAttribute('aria-hidden', 'true');
    g.alt = '';
    g.src = cur;
    g.style.display = '';

    img.insertAdjacentElement('afterend', g);
    var run = function () {
      if (!g.parentNode) return;
      g.getBoundingClientRect();
      g.style.transition = 'opacity 420ms cubic-bezier(0.4,0,0.2,1)';
      g.style.opacity = '0';
      var done = false;
      var kill = function () {
        if (done) return;
        done = true;
        if (g.parentNode) g.parentNode.removeChild(g);
      };
      g.addEventListener('transitionend', kill);
      setTimeout(kill, 620);
    };
    var inc = new Image();
    inc.onload = function () { img.setAttribute('src', src); run(); };
    inc.onerror = function () { img.setAttribute('src', src); run(); };
    inc.src = src;
  }
  function a8GdHideImg(img, fade) {

    if (!img || img.style.display === 'none') return;
    if (!fade || a8GdReduce()) { img.style.display = 'none'; return; }
    var tok = (img.__agHideTok || 0) + 1;
    img.__agHideTok = tok;
    img.style.transition = 'opacity 420ms cubic-bezier(0.4,0,0.2,1)';
    img.getBoundingClientRect();
    img.style.opacity = '0';
    var done = false;
    var fin = function () {
      if (done || img.__agHideTok !== tok) return;
      done = true;
      img.style.display = 'none';
      img.style.transition = '';
      img.style.opacity = '';
    };
    img.addEventListener('transitionend', fin);
    setTimeout(fin, 620);
  }
  function a8GdShowImg(img, fade) {

    if (!img) return;
    img.__agHideTok = (img.__agHideTok || 0) + 1;
    img.style.transition = '';
    img.style.opacity = '';
    img.style.display = '';

    if (!fade || a8GdReduce()) return;
    img.style.opacity = '0';
    img.getBoundingClientRect();
    img.style.transition = 'opacity 420ms cubic-bezier(0.4,0,0.2,1)';
    img.style.opacity = '1';
    var done = false;
    var clear = function () {
      if (done) return;
      done = true;
      img.style.transition = '';
      img.style.opacity = '';
    };
    img.addEventListener('transitionend', clear);
    setTimeout(clear, 620);
  }
  function a8GdGhost(kind, over) {

    if (st && st.primary && !over) return;
    var box = q('.agcf-ghost-box');
    var name = q('.agcf-ghost-name');
    if (!box) return;
    var pair = (over && over.p) ? over : a8GdPair();
    if (over) A8G.ovr = !!(st && st.primary);
    var gp = box.querySelector('.agcf-ghost-primary');
    var ga = box.querySelector('.agcf-ghost-accent');
    if (!gp) {
      gp = document.createElement('img');
      gp.className = 'agcf-ghost-primary';
      gp.alt = '';
      gp.setAttribute('data-agcfg-demo', '');
      box.appendChild(gp);
    }
    if (!ga) {
      ga = document.createElement('img');
      ga.className = 'agcf-ghost-accent';
      ga.alt = '';
      ga.setAttribute('data-agcfg-demo', '');
      box.appendChild(ga);
    }
    if (kind === 'none') {

      box.classList.remove('is-filled', 'has-accent');
      a8GdHideImg(gp, true);
      a8GdHideImg(ga, true);
      if (name) name.textContent = COPY.ghost;
      return;
    }
    box.classList.add('is-filled');
    if (pair.p) {

      var pHid = gp.style.display === 'none';
      a8GdSwap(gp, cdn(pair.p.image, 260), !!over && !pHid);
      a8GdShowImg(gp, pHid);
    }
    if (kind === 'pair' && pair.a) {
      box.classList.add('has-accent');
      var aHid = ga.style.display === 'none';
      a8GdSwap(ga, cdn(pair.a.image, 260), !!over && !aHid);
      a8GdShowImg(ga, aHid);

      if (name) placeCaption(name, pair.p.name, pair.a.name);
    } else {
      box.classList.remove('has-accent');
      a8GdHideImg(ga, !!over);
      if (name && pair.p) name.textContent = pair.p.name;
    }
  }
  function a8GdUnover() {

    if (!A8G.ovr) return;
    A8G.ovr = false;
    var s = A8G.snap;
    if (!s) return;
    var box = q('.agcf-ghost-box');
    var name = q('.agcf-ghost-name');
    if (box) {
      box.classList.toggle('is-filled', s.filled);
      box.classList.toggle('has-accent', s.hasAcc);
      var gp2 = box.querySelector('.agcf-ghost-primary');
      var ga2 = box.querySelector('.agcf-ghost-accent');

      a8GdShowImg(gp2);
      a8GdShowImg(ga2);
      if (gp2) {
        if (s.pSrc !== null) gp2.setAttribute('src', s.pSrc);
        gp2.style.display = s.pDisp || '';
      }
      if (ga2) {
        if (s.aSrc !== null) ga2.setAttribute('src', s.aSrc);
        ga2.style.display = s.aDisp || '';
      }
    }
    if (name && s.name !== null) name.innerHTML = s.name;
  }
  function a8GdBand(open) {
    var band = q('.agcf-band');
    if (!band) return;
    if (open) { openBand(); return; }
    if (!A8G.snap || A8G.snap.bandOpen) return;
    band.classList.remove('is-open');
  }
  function a8GdHist(open) {

    var hist = q('[data-agcf8-hist]');
    if (!hist) return;
    if (!open) return;
    hist.classList.remove('is-empty');
    var p = a8HistPanel();
    if (!p) return;
    if (!A8G.snap.histHTML || !p.querySelector('.agcf8-hist-item')) {
      p.innerHTML = a8GdHistRows();
      p.setAttribute('data-agcfg-rows', '');
    }

    if (isMobile()) {
      p.style.left = '';
      p.style.top = '';
      void p.offsetHeight;
    } else {
      a8HistPlace();
    }
    p.classList.add('is-open');
    if (isMobile()) { a8Scrim('guide', true); a8Lock('guide', true); }

    var replace = function () {
      p.removeEventListener('transitionend', replace);
      if (A8G.open) a8GdPlace();
    };
    p.addEventListener('transitionend', replace);
    setTimeout(function () { if (A8G.open) a8GdPlace(); }, 420);
  }
  function a8GdHistRows() {
    var pool = RANKED.filter(function (f) { return f && f.image; });
    var title = document.querySelector('h1');
    var pname = title ? title.textContent.trim() : '';
    var rows = '';
    var combos = [[0, 1], [2, 3], [4, -1]];
    for (var i = 0; i < combos.length; i++) {
      var pf = pool[combos[i][0]];
      var af = combos[i][1] > -1 ? pool[combos[i][1]] : null;
      if (!pf) continue;
      rows += '<span class="agcf8-hist-item" data-agcfg-demo'
        + ' data-p="' + esc(pf.code) + '"'
        + (af ? ' data-a="' + esc(af.code) + '"' : '') + '>'
        + '<span class="agcf8-hist-thumbs">'
        + '<img class="agcf8-hist-thumb' + (af ? '' : ' agcf8-hist-thumb--wide')
        + '" src="' + esc(cdn(pf.image, 240)) + '" alt="">'
        + (af ? '<img class="agcf8-hist-thumb" src="'
          + esc(cdn(af.image, 240)) + '" alt="">' : '')
        + '</span><span class="agcf8-hist-lines">'
        + '<span class="agcf8-hist-names">' + esc(pf.name)
        + (af ? ' &amp; ' + esc(af.name) : '') + '</span>'
        + '<span class="agcf8-hist-product">' + esc(pname) + '</span>'
        + '</span></span>';
    }
    return '<div class="agcf8-hist-head" data-agcfg-demo>'
      + '<span class="agcf8-hist-title">' + 'Finish history'
      + '</span></div>' + rows;
  }

  function a8GdHistShut() {
    var p = A8.histPanel;
    if (p) p.classList.remove('is-open');
    a8Scrim('guide', false);
    if (!A8G.sheet) a8Lock('guide', false);
  }

  function a8GdCta(on) {

    var btn = a8GdBtn();
    if (!btn) return;
    if (on) btn.classList.add('is-show');
    else if (A8G.snap && !A8G.snap.btnShow) btn.classList.remove('is-show');
  }

  function a8GdStage() {

    var g = gallery();
    if (!g) return null;
    var s = g.querySelector('[data-agcfg-stage]');
    if (s) return s;
    s = document.createElement('div');
    s.className = 'agcfg-stage';
    s.setAttribute('data-agcfg-stage', '');
    s.setAttribute('data-agcfg-demo', '');
    g.appendChild(s);
    return s;
  }
  function a8GdPickHTML(cls, attrs) {
    var pair = a8GdPair();
    var acc = pair.a ? '<img class="agcf8-pick-accent" src="'
      + esc(cdn(pair.a.image, 120)) + '" alt="">' : '';
    var label = pair.p
      ? (pair.p.name + (pair.a ? ' / ' + pair.a.name : '')) : '';
    return '<span class="agcf8-slide-pick' + (cls ? ' ' + cls : '') + '"'
      + (attrs ? ' ' + attrs : '') + '>'
      + '<span class="agcf8-pick-box">'
      + '<img class="agcf8-pick-primary" src="'
      + esc(pair.p ? cdn(pair.p.image, 120) : '') + '" alt="">' + acc
      + '</span><span class="agcf8-pick-name">' + A8_RE_ICO
      + '<span class="agcf8-pick-txt">' + esc(label)
      + '</span></span></span>';
  }
  function a8GdShotHTML() {

    return '<img class="agcfg-shot" src="' + esc(a8GdHero()) + '" alt="">'

      + '<span class="agcfg-tile" data-agcfg-tile></span>'
      + '<span class="agcfg-wm" data-agcfg-wm>'
      + '<span class="agcfg-leaf"></span>'
      + '<span class="agcfg-wmtxt"><b>' + esc(A8G_WM1) + '</b>'
      + '<i>' + esc(A8G_WM2) + '</i>'
      + '<i>' + esc(A8G_WM3) + '</i></span></span>'

      + a8GdPickHTML('agcfg-pick', 'data-agcfg-pick');
  }
  function a8GdWm(stage) {

    var wm = stage.querySelector('[data-agcfg-wm]');
    if (!wm) return;
    var r = stage.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var scale = Math.max(r.width, r.height) / 2048;
    var src = 2048 * scale;
    var cropX = (src - r.width) / 2;
    var cropY = (src - r.height) / 2;
    var h = Math.round(130 * scale);
    wm.style.bottom = Math.max(6, Math.round(63 * scale - cropY)) + 'px';
    wm.style.left = Math.max(6, Math.round(63 * scale - cropX)) + 'px';
    wm.style.height = h + 'px';
    wm.style.setProperty('--agcfg-leafw', h + 'px');
    wm.style.setProperty('--agcfg-gap', Math.round(src * 0.0176) + 'px');
    wm.style.setProperty('--agcfg-l1', (src * 0.0166).toFixed(2) + 'px');
    wm.style.setProperty('--agcfg-l2', (src * 0.0146).toFixed(2) + 'px');

    var tile = stage.querySelector('[data-agcfg-tile]');
    if (!tile) return;
    var cw = src / 4, chh = src / 6;
    var size = cw.toFixed(1) + 'px ' + (chh * 2).toFixed(1) + 'px';
    var pos = '0px 0px, ' + (cw / 2).toFixed(1) + 'px '
      + chh.toFixed(1) + 'px';
    tile.style.webkitMaskSize = size + ', ' + size;
    tile.style.maskSize = size + ', ' + size;
    tile.style.webkitMaskPosition = pos;
    tile.style.maskPosition = pos;
  }
  function a8GdDock(on) {

    var g = gallery();
    if (!g || !g.parentNode) return;
    var old = document.querySelector('[data-agcfg-dock]');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!on) return;
    var d = document.createElement('div');
    d.className = 'agcf8-dockbar agcfg-dock';
    d.setAttribute('data-agcfg-dock', '');
    d.setAttribute('data-agcfg-demo', '');
    d.innerHTML = a8GdPickHTML('', '');
    g.insertAdjacentElement('afterend', d);
  }
  function a8GdCell(on) {

    var old = document.querySelector('[data-agcfg-cell]');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!on) return null;
    var url = a8GdHero();
    var rail = document.querySelector('.slick-product-thumbnail');
    if (!rail) return null;
    var mob = a8GdMode() !== 'desktop';
    var host = mob ? rail : a8RailTrack();
    if (!host) host = rail;
    var c = document.createElement(mob ? 'span' : 'div');
    c.setAttribute('data-agcfg-cell', '');
    c.setAttribute('data-agcfg-demo', '');
    if (mob) {
      c.className = 'agcf8-mthumb agcf8-mthumb--flow agcfg-cell';
      c.innerHTML = '<img class="product_thumbnail-image" src="'
        + esc(url) + '" alt="">'
        + '<span class="agcf8-thumb-tag">'
        + 'Preview' + '</span>';
    } else {
      c.className = 'slick-slide agcf8-thumb agcfg-cell';
      c.innerHTML = '<div><div class="product_thumbnail-wrapper"'
        + ' data-media-type="image">'
        + '<img class="product_thumbnail-image" src="' + esc(url) + '" alt="">'
        + '<span class="agcf8-thumb-tag">'
        + 'Preview' + '</span></div></div>';
    }
    if (!mob) {

      var sib = host.querySelector('.slick-slide');
      if (sib) {
        c.style.width = sib.style.width || '';
        c.style.height = sib.style.height || '';
        if (sib.style.display) c.style.display = sib.style.display;
      }
    }
    host.insertBefore(c, a8GdCellAt(host, mob));
    return c;
  }
  function a8GdCellAt(host, mob) {

    var first = host.firstElementChild;
    if (mob) return first;
    var list = host.closest ? host.closest('.slick-list') : null;
    if (!list) return first;
    var lr = list.getBoundingClientRect();
    if (!lr.height) return first;
    var kids = host.children;
    for (var i = 0; i < kids.length; i++) {
      var kr = kids[i].getBoundingClientRect();
      if (!kr.height) continue;

      if (kr.bottom > lr.top + 2) return kids[i];
    }
    return first;
  }

  function a8GdFinal(tok) {
    if (tok !== A8G.tok) return;
    var stage = a8GdStage();
    if (!stage) return;
    stage.className = 'agcfg-stage is-shot';
    stage.innerHTML = a8GdShotHTML();
    a8GdWm(stage);

    if (A8G.at >= GS_SHOT) a8GdDock(a8GdMode() !== 'desktop');
    if (A8G.at >= GS_CELL) a8GdCell(true);
    a8GdPlace();
  }
  function a8GdStageOff() {
    var s = document.querySelector('[data-agcfg-stage]');
    if (s && s.parentNode) s.parentNode.removeChild(s);
    a8GdDock(false);
    a8GdCell(false);
  }

  function a8GdScene(at) {
    var mode = a8GdMode();
    var tok = ++A8G.tok;

    a8GdBand(at >= GS_ROW);

    if (at >= GS_ACC) {
      a8GdUnover();
      a8GdGhost('pair');
    } else if (at >= GS_PRIM) {
      a8GdUnover();
      a8GdGhost('primary');
    } else {
      a8GdUnover();
      a8GdGhost('none');
    }
    a8GdHist(at === GS_HIST);
    if (at !== GS_HIST && A8.histPanel) a8GdHistShut();
    a8GdCta(at >= GS_CTA);

    if (at >= GS_SHOT) {
      if (!document.querySelector('[data-agcfg-stage].is-shot')) {
        a8GdFinal(tok);
      } else {
        a8GdDock(mode !== 'desktop');
        a8GdCell(at >= GS_CELL);
      }
    } else { a8GdStageOff(); }
  }
  function a8GdTargets() {

    var at = A8G.at, out = [];
    var stage = document.querySelector('[data-agcfg-stage]');
    var box = q('.agcf-ghost-box');
    switch (at) {
      case 0: out.push(q('.agcf-ghost-cell')); break;
      case GS_ROW: out.push(q('.agcf-rail')); break;

      case GS_PRIM: out.push(a8GdSwatch('p'), box); break;
      case GS_ACC:
        out.push(a8GdSwatch('a'),
          q('.agcf-ghost-accent') || box);
        break;

      case GS_HIST:
        out.push(q('[data-agcf8-hist-btn]') || q('[data-agcf8-hist]'),
          a8GdHistOpen());
        break;
      case GS_CTA: out.push(a8GdBtn()); break;
      case GS_SHOT: out.push(stage || gallery()); break;
      case GS_CELL: out.push(document.querySelector('[data-agcfg-cell]')
        || document.querySelector('.slick-product-thumbnail')); break;

      default: out.push(q('.agcf-ghost-cell'));
    }
    return out;
  }
  function a8GdHistOpen() {
    var p = A8.histPanel;
    return (p && p.classList.contains('is-open')) ? p : null;
  }
  function a8GdReveal(t) {

    if (!t || !t.getBoundingClientRect) return;
    var n = t.parentNode;
    while (n && n.nodeType === 1 && n !== document.body) {
      if (n.scrollWidth > n.clientWidth + 4) {
        var tr = t.getBoundingClientRect(), nr = n.getBoundingClientRect();
        if (tr.left < nr.left) {
          n.scrollLeft -= (nr.left - tr.left) + 12;
        } else if (tr.right > nr.right) {
          n.scrollLeft += (tr.right - nr.right) + 12;
        }
        return;
      }
      n = n.parentNode;
    }
  }
  function a8GdSwatch(role) {

    var pair = a8GdPair();
    var f = (role === 'a') ? pair.a : pair.p;
    if (!f || !f.code) return null;
    return q('[data-agcf-sw][data-code="' + f.code + '"]');
  }
  function a8GdTarget() {

    var t = a8GdTargets();
    for (var i = 0; i < t.length; i++) {
      if (t[i] && t[i].nodeType === 1) return t[i];
    }
    return null;
  }
  function a8GdPad(node) {

    if (node && node.classList
        && node.classList.contains('agcf-ghost-accent')) {
      return isMobile() ? 13 : 9;
    }

    if (node && window.getComputedStyle) {
      var ps = window.getComputedStyle(node).position;
      if (ps === 'fixed' || ps === 'sticky') return 0;
    }
    return 6;
  }

  function a8GdRect(t, vw, vh) {

    if (!t || !t.getBoundingClientRect
        || (!t.offsetWidth && !t.offsetHeight)) return null;
    var r = t.getBoundingClientRect(), pad = a8GdPad(t);
    var hl = Math.round(r.left - pad), ht = Math.round(r.top - pad);
    var hr = Math.round(r.right + pad), hb = Math.round(r.bottom + pad);

    var host = t.parentNode;
    if (pad > 6 && host && host.getBoundingClientRect) {
      var pr = host.getBoundingClientRect();
      if (pr.width > 0 && pr.height > 0) {
        if (hl < pr.left) hl = Math.round(pr.left);
        if (ht < pr.top) ht = Math.round(pr.top);
        if (hr > pr.right) hr = Math.round(pr.right);
        if (hb > pr.bottom) hb = Math.round(pr.bottom);
      }
    }
    if (hl < 0) hl = 0;
    if (ht < 0) ht = 0;
    if (hr > vw) hr = vw;
    if (hb > vh) hb = vh;
    if (hr - hl <= 0 || hb - ht <= 0) return null;
    return { l: hl, t: ht, w: hr - hl, h: hb - ht };
  }
  function a8GdCut(rects, vw, vh) {

    var d = 'M0 0H' + vw + 'V' + vh + 'H0Z';
    for (var i = 0; i < rects.length; i++) {
      var r = rects[i];
      d += 'M' + r.l + ' ' + r.t
        + 'V' + (r.t + r.h)
        + 'H' + (r.l + r.w)
        + 'V' + r.t + 'Z';
    }
    return 'path(evenodd, "' + d + '")';
  }
  function a8GdHoles(n) {

    var v = A8G.veil;
    if (!v) return [];
    if (!A8G.holes) A8G.holes = [];
    while (A8G.holes.length < n) {
      var h = document.createElement('span');
      h.className = 'agcfg-hole';
      h.setAttribute('data-agcfg-hole', '');
      v.appendChild(h);
      A8G.holes.push(h);
    }
    return A8G.holes;
  }
  function a8GdPlace() {
    var card = A8G.card;
    if (!card || !A8G.open) return;
    var vw = document.documentElement.clientWidth || window.innerWidth || 0;
    var vh = window.innerHeight || 0;
    var sheet = a8GdMode() === 'phone';
    A8G.sheet = sheet;
    card.classList.toggle('is-sheet', sheet);

    if (sheet) {
      card.style.top = '';
      card.style.left = '';
      card.style.maxHeight = Math.round(Math.min(vh * 0.5, 340)) + 'px';

      var top = a8GdTopSheet();
      card.classList.toggle('is-sheet-top', top);
      document.documentElement.classList.toggle('agcfg-top', top);
      document.documentElement.style.setProperty(
        '--agcfg-cardh', (card.offsetHeight || 220) + 'px');
    } else {
      card.classList.remove('is-sheet-top');
      document.documentElement.classList.remove('agcfg-top');
    }
    var nodes = a8GdTargets(), rects = [], i;
    for (i = 0; i < nodes.length; i++) {
      var rc = a8GdRect(nodes[i], vw, vh);
      if (rc) rects.push(rc);
    }

    if (!A8G.rdy || A8G.hold || !a8GdNeedOk()) rects = [];
    var holes = a8GdHoles(Math.max(1, rects.length));

    var lit0 = A8G.lit;
    for (i = 0; i < holes.length; i++) {
      var rr = rects[i];
      if (!rr) { holes[i].style.visibility = 'hidden'; continue; }
      if (!lit0) holes[i].style.transition = 'none';
      holes[i].style.visibility = 'visible';
      holes[i].style.left = rr.l + 'px';
      holes[i].style.top = rr.t + 'px';
      holes[i].style.width = rr.w + 'px';
      holes[i].style.height = rr.h + 'px';
      if (!lit0) {
        holes[i].getBoundingClientRect();
        holes[i].style.transition = '';
      }
    }
    A8G.lit = rects.length > 0;
    if (A8G.dim) {
      A8G.dim.style.clipPath = rects.length
        ? a8GdCut(rects, vw, vh) : 'none';
      A8G.dim.style.webkitClipPath = A8G.dim.style.clipPath;
    }
    if (!rects.length) {

      if (A8G.rdy) {
        card.style.maxHeight = '';
        if (sheet) { card.style.top = ''; card.style.left = ''; }
      }
      return;
    }

    var r = { left: rects[0].l, top: rects[0].t,
              right: rects[0].l + rects[0].w,
              bottom: rects[0].t + rects[0].h };
    for (i = 1; i < rects.length; i++) {
      r.left = Math.min(r.left, rects[i].l);
      r.top = Math.min(r.top, rects[i].t);
      r.right = Math.max(r.right, rects[i].l + rects[i].w);
      r.bottom = Math.max(r.bottom, rects[i].t + rects[i].h);
    }
    r.width = r.right - r.left;
    r.height = r.bottom - r.top;

    if (sheet) {

      return;
    }

    card.classList.remove('is-sheet');
    card.style.maxHeight = Math.max(150, vh - 24) + 'px';
    var ch2 = card.offsetHeight || 220, cw = card.offsetWidth || 340;

    var below = r.bottom + A8G_CLEAR;
    var midY = r.top + (r.height - ch2) / 2;
    var leftOf = r.left - cw - A8G_CLEAR, rightOf = r.right + A8G_CLEAR;
    var top2, left2;
    if (below + ch2 <= vh - 10) { top2 = below; left2 = r.left; }
    else if (leftOf >= 12) { top2 = midY; left2 = leftOf; }
    else if (rightOf + cw <= vw - 12) { top2 = midY; left2 = rightOf; }
    else { top2 = r.top - ch2 - A8G_CLEAR; left2 = r.left; }
    card.style.top = Math.max(10, Math.min(top2, vh - ch2 - 10)) + 'px';
    card.style.left = Math.max(12, Math.min(left2, vw - cw - 12)) + 'px';

    var over = false;
    var cr = { l: parseFloat(card.style.left), t: parseFloat(card.style.top) };
    cr.r = cr.l + cw;
    cr.b = cr.t + ch2;
    for (i = 0; i < rects.length; i++) {
      var q2 = rects[i];
      if (!(cr.r <= q2.l || cr.l >= q2.l + q2.w
            || cr.b <= q2.t || cr.t >= q2.t + q2.h)) { over = true; break; }
    }
    if (over && rects.length > 1) a8GdOnly(rects[0], vw, vh);
  }
  function a8GdOut() {

    var band = a8GdCardBand(), room = band.bot - band.top;
    var nodes = a8GdTargets(), out = null, i;
    for (i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n || !n.getBoundingClientRect) continue;
      if (!n.offsetWidth && !n.offsetHeight) continue;
      var r = n.getBoundingClientRect();
      if (r.top >= band.top - 1 && r.bottom <= band.bot + 1) continue;

      if (r.bottom - r.top >= room) continue;
      if (a8GdFixed(n)) continue;
      out = out
        ? { top: Math.min(out.top, r.top),
            bottom: Math.max(out.bottom, r.bottom) }
        : { top: r.top, bottom: r.bottom };
    }
    return out;
  }
  function a8GdPan(ptok) {

    if (a8GdMode() === 'desktop') return;
    if (!a8GdOut()) {

      A8G.panT = setTimeout(function () {
        A8G.panT = null;
        if (ptok === A8G.ptok) a8GdRefit();
      }, A8G_PAN);
      return;
    }
    A8G.pan = true;
    A8G.panT = setTimeout(function () {
      A8G.panT = null;
      if (ptok !== A8G.ptok) { A8G.pan = false; return; }

      var r = a8GdOut();
      if (!r) return;
      a8GdScroll(r, function () {
        if (ptok === A8G.ptok) a8GdPlace();
      });
    }, A8G_PAN);

  }
  function a8GdOnly(rect, vw, vh) {

    var holes = A8G.holes || [], card = A8G.card, i;
    for (i = 1; i < holes.length; i++) holes[i].style.visibility = 'hidden';
    if (A8G.dim) {
      A8G.dim.style.clipPath = a8GdCut([rect], vw, vh);
      A8G.dim.style.webkitClipPath = A8G.dim.style.clipPath;
    }
    if (!card || A8G.sheet) return;
    var ch = card.offsetHeight || 220, cw = card.offsetWidth || 340;
    var below = rect.t + rect.h + A8G_CLEAR;
    var top2 = (below + ch <= vh - 10) ? below : (rect.t - ch - A8G_CLEAR);
    card.style.top = Math.max(10, Math.min(top2, vh - ch - 10)) + 'px';
    card.style.left = Math.max(12, Math.min(rect.l, vw - cw - 12)) + 'px';
  }

  function a8GdPaint() {
    var v = A8G.veil;
    if (!v) return;
    var s = A8G_STEPS[A8G.at] || {};
    var body = (a8GdMode() !== 'desktop' && s.m) ? s.m : s.p;

    a8N2(v, 'h').textContent = s.h || '';
    a8GdBody(a8N2(v, 'p'), body || '', s.lk);
    var back = a8N2(v, 'back'), next = a8N2(v, 'next');
    back.disabled = (A8G.at === 0);
    next.textContent = (A8G.at === A8G_STEPS.length - 1)
      ? A8G_DONE : A8G_NEXT;

    var note = a8N2(v, 'note');

    if (note) note.hidden = (A8G.at !== GS_SHOT);
    var bars = a8N2(v, 'bars');
    bars.innerHTML = '';
    for (var i = 0; i < A8G_STEPS.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = (i === A8G.at) ? 'is-at' : '';
      b.setAttribute('aria-label', 'Step ' + (i + 1));
      b.setAttribute('data-agcfg-jump', String(i));
      bars.appendChild(b);
    }
  }
  function a8GdBody(node, text, lk) {

    node.textContent = '';
    var label = lk && lk[0], href = lk && lk[1];
    var at = label ? text.lastIndexOf(label) : -1;
    if (at < 0) { node.textContent = text; return; }
    node.appendChild(document.createTextNode(text.slice(0, at)));
    var a = document.createElement('a');
    a.className = 'agcfg-lk';
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = label;
    node.appendChild(a);
    node.appendChild(document.createTextNode(text.slice(at + label.length)));
  }
  function a8N2(root, name) {
    return root.querySelector('[data-agcfg-' + name + ']');
  }
  function a8GdReady(done) {

    if (A8G.stab) { cancelAnimationFrame(A8G.stab); A8G.stab = null; }
    var n = 0, last = -1, still = 0;
    var tick = function () {
      var t = a8GdTarget();
      var h = t ? Math.round(t.getBoundingClientRect().height) : -1;
      var need = a8GdNeedOk();
      n++;
      if (h > 0 && h === last && need) still++; else still = 0;
      last = h;
      if (still >= 2) { A8G.stab = null; done(true); return; }
      if (n > A8G_STAB_MAX) { A8G.stab = null; done(need); return; }
      A8G.stab = requestAnimationFrame(tick);
    };
    A8G.stab = requestAnimationFrame(tick);
  }
  function a8GdNeedOk() {

    var at = A8G.at;

    if (at === GS_HIST) {
      var hp = A8.histPanel;
      if (!hp || !hp.classList.contains('is-open')) return false;
      var htop = Math.round(hp.getBoundingClientRect().top);
      var hwas = A8G.pTop;
      A8G.pTop = htop;
      return hwas === htop;
    }
    if (at !== GS_ROW && at !== GS_PRIM && at !== GS_ACC) return true;
    var band = q('.agcf-band');
    if (!band || !band.classList.contains('is-open')) return false;
    var sw = q('[data-agcf-sw]'), rail = q('.agcf-rail');
    if (!sw || !rail) return false;
    var sh = sw.getBoundingClientRect().height;

    return sh > 0
      && Math.max(rail.scrollHeight, rail.getBoundingClientRect().height)
        >= sh;
  }
  function a8GdGo(at) {
    if (at < 0 || at >= A8G_STEPS.length) return;
    A8G.at = at;
    var ptok = ++A8G.ptok;

    A8G.rdy = false;
    A8G.lit = false;

    A8G.pTop = null;

    if (A8G.panT) { clearTimeout(A8G.panT); A8G.panT = null; }
    A8G.pan = false;

    A8G.hold = a8GdMode() !== 'desktop';
    a8GdScene(at);
    a8GdPaint();
    a8GdPlace();

    a8GdWatch(a8GdTarget());
    a8GdReady(function (ok) {
      if (ptok !== A8G.ptok) return;

      A8G.rdy = true;

      if (!ok) { A8G.hold = false; a8GdPlace(); return; }

      var tg = a8GdTargets();
      for (var ti = 0; ti < tg.length; ti++) a8GdReveal(tg[ti]);
      a8GdPlace();
      a8GdScroll(a8GdSpan(), function () {
        if (ptok !== A8G.ptok) return;

        A8G.hold = false;
        a8GdPlace();
        requestAnimationFrame(function () {
          if (ptok !== A8G.ptok) return;
          a8GdPlace();

          a8GdPan(ptok);
        });
      });
    });
  }
  function a8GdLead(){

    var t = a8GdTarget();
    if (A8G.at === GS_CELL && a8GdMode() !== 'desktop') {
      var g = gallery();
      if (g) return g;
    }

    if (t && a8GdFixed(t)) {
      var tg = a8GdTargets();
      for (var i = 0; i < tg.length; i++) {
        if (tg[i] && tg[i].nodeType === 1 && !a8GdFixed(tg[i])) return tg[i];
      }
    }
    return t;
  }
  function a8GdWatch(node) {

    if (!window.ResizeObserver) return;
    if (!A8G.ro) {
      A8G.ro = new ResizeObserver(function () {
        if (!A8G.open) return;
        a8GdPlace();
        a8GdRefit();
      });
    }
    A8G.ro.disconnect();
    if (node && node.nodeType === 1) A8G.ro.observe(node);
  }
  function a8GdRefit() {

    if (!A8G.open || !A8G.sheet) return;

    if (A8G.hold || A8G.pan) return;

    var r = a8GdSpan();
    if (!r) return;
    var pad = 6;
    var band = a8GdCardBand();
    if (r.bottom + pad <= band.bot - 2 && r.top - pad >= band.top + 2) return;
    a8GdScroll(r, function () { a8GdPlace(); });
  }
  function a8GdUnwatch() {
    if (A8G.ro) A8G.ro.disconnect();
  }
  function a8GdTrack() {

    if (A8G.onScroll) return;
    var q2 = false;
    A8G.onScroll = function () {
      if (q2 || !A8G.open) return;
      q2 = true;
      requestAnimationFrame(function () { q2 = false; a8GdPlace(); });
    };
    window.addEventListener('scroll', A8G.onScroll, true);
  }
  function a8GdUntrack() {
    if (!A8G.onScroll) return;
    window.removeEventListener('scroll', A8G.onScroll, true);
    A8G.onScroll = null;
  }

  function a8GdCardHTML() {

    return '<span class="agcfg-dim" data-agcfg-dim></span>'
      + '<span class="agcfg-hole" data-agcfg-hole></span>'
      + '<div class="agcfg-card" role="dialog" aria-modal="true"'
      + ' aria-label="' + esc(A8G_TITLE) + '" data-agcfg-card>'
      + '<button type="button" class="agcfg-x" data-agcfg-x'
      + ' aria-label="' + esc(COPY.dialog.close) + '">'

      + '<svg class="agcf-x" viewBox="0 0 256 256" fill="currentColor"'
      + ' aria-hidden="true"><path d="' + P_X + '"/></svg></button>'

      + '<h4 class="agcfg-h" data-agcfg-h></h4>'
      + '<hr class="agcfg-rule">'
      + '<p class="agcfg-p" data-agcfg-p></p>'

      + '<p class="agcfg-note" data-agcfg-note hidden>'
      + esc(A8G_LABEL) + '</p>'
      + '<div class="agcfg-nav"><div class="agcfg-bars" data-agcfg-bars></div>'
      + '<div class="agcfg-btns">'
      + '<button type="button" class="agcfg-btn" data-agcfg-back>'
      + esc(A8G_BACK) + '</button>'
      + '<button type="button" class="agcfg-btn agcfg-btn--go"'
      + ' data-agcfg-next>' + esc(A8G_NEXT) + '</button>'
      + '</div></div></div>';
  }
  function a8GdMount() {
    if (A8G.veil) return A8G.veil;
    var v = document.createElement('div');
    v.className = 'agcfg-veil';
    v.setAttribute('data-agcfg', '');
    v.innerHTML = a8GdCardHTML();
    document.body.appendChild(v);
    A8G.veil = v;
    A8G.dim = a8N2(v, 'dim');
    A8G.holes = [a8N2(v, 'hole')];
    A8G.card = a8N2(v, 'card');
    v.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-agcfg-x]')) { a8GdClose(); return; }
      if (t.closest('[data-agcfg-back]')) { a8GdGo(A8G.at - 1); return; }
      if (t.closest('[data-agcfg-next]')) {
        if (A8G.at === A8G_STEPS.length - 1) a8GdClose();
        else a8GdGo(A8G.at + 1);
        return;
      }
      var j = t.closest('[data-agcfg-jump]');
      if (j) { a8GdGo(parseInt(j.getAttribute('data-agcfg-jump'), 10)); return; }

      if (!t.closest('[data-agcfg-card]')) a8GdClose();
    });
    v.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) { a8GdClose(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;

      var f = A8G.card.querySelectorAll(
        'button:not([disabled]):not([hidden]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
    return v;
  }
  function a8GdOpen() {
    if (A8G.open) return;

    if (drawerIsOpen() || pickerOpen()) return;
    a8GdMount();
    A8G.open = true;
    A8G.snap = a8GdSnap();
    A8G.veil.classList.add('is-open');
    document.documentElement.classList.add('agcfg-on');
    a8GdTrack();
    a8GdGo(0);
    var nx = a8N2(A8G.veil, 'next');
    if (nx) setTimeout(function () { try { nx.focus(); } catch (e) {} }, 60);
  }
  function a8GdClose() {
    if (!A8G.open) return;
    A8G.open = false;
    A8G.ptok++;
    A8G.tok++;
    if (A8G.scrollT) { cancelAnimationFrame(A8G.scrollT); A8G.scrollT = null; }
    if (A8G.stab) { cancelAnimationFrame(A8G.stab); A8G.stab = null; }

    if (A8G.panT) { clearTimeout(A8G.panT); A8G.panT = null; }
    A8G.pan = false;
    A8G.hold = false;
    a8GdUntrack();
    a8GdUnwatch();
    A8G.ovr = false;
    if (A8G.veil) A8G.veil.classList.remove('is-open');
    document.documentElement.classList.remove('agcfg-on');

    document.documentElement.classList.remove('agcfg-top');
    document.documentElement.style.removeProperty('--agcfg-cardh');
    a8GdStageOff();
    a8GdRestore();
    var f = A8G.snap && A8G.snap.focus;
    A8G.snap = null;
    if (f && f.focus && f.isConnected) { try { f.focus(); } catch (e) {} }
  }
  function a8GdHelp() {

    var h = q('[data-agcfg-help]');
    if (!h || h.getAttribute('data-agcfg-wired')) return;
    h.setAttribute('data-agcfg-wired', '1');
    h.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      a8GdOpen();
    });

    var nm = q('.agcf-ghost-name');
    if (nm && !nm.getAttribute('data-agcfg-wired')) {
      nm.setAttribute('data-agcfg-wired', '1');
      nm.addEventListener('click', function () {
        var g = q('.agcf-ghost');
        if (g) g.click();
      });
    }
    var re = debounce(function () {
      if (!A8G.open) return;

      a8GdScene(A8G.at);
      a8GdPaint();
      a8GdPlace();
    }, 160);
    window.addEventListener('resize', re);
    window.addEventListener('orientationchange', re);
  }

  /* Price-update flash (improve-animations plan 002): snap #product-main-price
     to the accent colour, then let the CSS transition ease it back. Remove +
     reflow + re-add so an in-flight flash restarts cleanly; the nested rAF
     guarantees one painted frame with the class present before removal, so
     the browser has a colour to transition FROM (a single rAF is too early). */
  function a8FlashPrice(el) {
    if (!el) return;
    el.classList.remove('ag-price-flash');
    void el.offsetHeight; /* force reflow so re-adding the class is a new frame, not a no-op */
    el.classList.add('ag-price-flash');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.remove('ag-price-flash');
      });
    });
  }

  function boot() {
    var atc = document.getElementById('add-to-cart-btn');
    var form = atc && atc.closest ? atc.closest('form') : null;
    if (form) {

      form.querySelectorAll('select, input[type="radio"]')
        .forEach(function (el) {
          el.addEventListener('change', updateAtcPrice);
        });
    }

    if (atc && A8_PROTO) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      });
    }

    var slink = document.querySelector('.ag-sample-link');
    if (slink && A8_PROTO) {
      slink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPicker();
      });
    }

    if (!A8_PROTO) a8PickerJoin();
    updateAtcPrice();
    agcf8Boot();

    /* R44 (Datch 2026-09-07): dawn-variant-selector.js updates this element
       on its own debounce + requestAnimationFrame after a variant swap (e.g.
       Size) - no event fires when it lands, so the ATC button's price span
       went stale on anything other than a Return/Reception change. Watching
       the source of truth directly makes this correct regardless of what
       changed it or how long its update takes. */
    var a8MainPriceEl = document.getElementById('product-main-price');
    if (a8MainPriceEl && window.MutationObserver) {
      /* Flash only when the visible number actually changed: dawn-variant-
         selector.js rewrites textContent on EVERY variant swap, including
         Return L/R where both variants share a price, and the observer fires
         on the identical rewrite too. A flash with no change is a false cue. */
      var a8LastFlashTxt = a8MainPriceEl.textContent.trim();
      new MutationObserver(function () {
        updateAtcPrice();
        var a8Txt = a8MainPriceEl.textContent.trim();
        if (a8Txt !== a8LastFlashTxt) {
          a8LastFlashTxt = a8Txt;
          a8FlashPrice(a8MainPriceEl);
        }
      })
        .observe(a8MainPriceEl, { childList: true, characterData: true, subtree: true });
    }
  }
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
